{
    "apiErrors": {
        "draft_busy": "Muitas respostas estão sendo redigidas neste momento. Tente de novo em instantes.",
        "special_hours_require_business_hours": "O horário especial precisa do horário de funcionamento. Mantenha o horário com pelo menos um dia aberto, ou remova antes as datas especiais.",
        "special_hours_duplicate_date": "Uma data especial aparece mais de uma vez. Mantenha uma só entrada por data.",
        "menu_name_conflict": "Já existe outro menu publicado com o mesmo nome em uma das localizações deste menu. Renomeie um dos menus primeiro.",
        "conversation_assigned_to_agent": "Esta conversa está sendo tratada pelo Pulse. Entre na conversa para assumi-la.",
        "conversation_already_in_team": "A conversa já está nesta equipe.",
        "team_not_found": "Esta equipe já não existe. Atualize a página e tente novamente.",
        "conversation_assigned_to_another_user": "Esta conversa está atribuída a outro agente. Entre na conversa para assumi-la.",
        "billing_surveys_advanced_disabled": "Esta funcionalidade está disponível no plano Profissional.",
        "google_authentication_failed": "Impossível integrar",
        "google_access_revoked": "Não é possível conectar",
        "google_auth_code_expired": "O início de sessão com o Google expirou. Tente novamente",
        "google_server_error": "O Google está temporariamente indisponível. Tente novamente mais tarde",
        "google_validation_failed": "O Google rejeitou este pedido: {{reasons}}",
        "google_not_found": "A verificação do Google não está disponível para esta localização neste momento",
        "something_wrong": "Algo errado aconteceu",
        "validation": "Algo errado aconteceu",
        "message_too_long": "O texto da publicação é longo demais para uma das plataformas selecionadas. Encurte a mensagem e tente novamente.",
        "duplicate_question_titles": "Os títulos das perguntas devem ser únicos. Duplicados: {{duplicates}}",
        "forbid": "Acesso não autorizado",
        "unauthorized": "Acesso não autorizado",
        "google_access_revoke_error": "Não foi possível desconectar",
        "google_publish_reply_error": "Não foi possível publicar a resposta à avaliação",
        "google_delete_reply_error": "Não foi possível eliminar a resposta",
        "review_not_found": "Não foi possível responder à avaliação porque ela não existe mais.",
        "google_reply_rejected": "O Google não aceitou a solicitação. Tente novamente mais tarde",
        "review_still_live_on_google": "Esta avaliação ainda está publicada no Google",
        "google_verification_unavailable": "Não foi possível confirmar com o Google se a avaliação ainda existe. Tente novamente mais tarde",
        "google_reply_unclaimed_location": "O Google não aceita respostas para esta ficha até que ela seja verificada no Perfil da Empresa no Google",
        "google_my_business_missing_rights": "Permissões em falta - Conceda permissões para 'Gerir Listagens' durante o registo no Google para prosseguir",
        "delete_user_failed_assigned_to_other_companies": "Impossível eliminar. Usuáro está atribuido a outros locais.",
        "user_already_exists": "Usuário com email {{email}} existe",
        "user_not_found": "O usuário não existe",
        "invalid_credentials": "Credenciais inválidas",
        "google_email_unverified": "Verifique este endereço de e-mail na sua conta do Google e tente novamente",
        "invalid_password": "Senha inválida",
        "campaign_not_enough_credits": "Não tem mensagens suficientes para dirigir esta campanha",
        "cannot_edit_campaign": "Não pode editar a campanha",
        "running_campaigns_exists": "Não é possível continuar: {{amount}} campanha(s) em progresso",
        "running_coupons_exist": "Não é possível continuar: {{amount}} modelo(s) de oferta ativo(s) atribuído(s) a esta localização",
        "active_directories_addon_exists": "Cancele primeiro o complemento Diretórios Locais desta localização",
        "location_country_locked_by_listings": "Cancele o complemento Diretórios Locais ou desconecte a ficha antes de alterar o país desta localização",
        "location_country_required": "Defina o país da localização",
        "location_country_locked_by_google": "Desconecte a ficha do Google desta localização antes de alterar o país",
        "google_listing_country_mismatch": "Esta ficha do Google está em {{listingCountry}}, mas a localização está em {{locationCountry}}. Conecte uma ficha do país da localização",
        "located_in_self_reference": "Uma localização não pode estar localizada dentro de si mesma. Escolha o negócio dentro do qual ela fica",
        "located_in_place_required": "Escolha o negócio dentro do qual esta localização fica ou desative \"Localizado dentro de outro negócio\"",
        "tracking_tags_medium_invalid": "Use letras minúsculas, dígitos e hífens em utm_medium",
        "tracking_tags_medium_paid": "A análise contaria este utm_medium como tráfego pago. Escolha outro valor",
        "tracking_tags_campaign_invalid": "Use letras minúsculas, dígitos e hífens em utm_campaign",
        "tracking_tags_campaign_shopping": "A análise contaria este utm_campaign como tráfego de compras. Escolha outro valor",
        "store_code_too_long": "Um código da loja tem no máximo 64 caracteres",
        "located_in_place_invalid": "Não foi possível reconhecer esse negócio no Google. Pesquise de novo e escolha nos resultados",
        "located_in_relation_invalid": "Escolha um tipo de relação para o negócio dentro do qual esta localização fica",
        "pulse_ai_agent_assigned": "Não é possível continuar: agente activo nesta localização",
        "campaign_empty": "Não há contactos no segmento selecionado",
        "campaign_audience_to_big": "Impossível criar a campanha com mais de 1.000 contactos",
        "maximum_daily_messages_reached": "Limite máximo alcançado de mensagens diárias",
        "over_survey": "Pedido a este contacto foi enviado no(s) último(s) {{delay}} dia(s)",
        "contact_unsubscribed": "Este contacto foi retirado",
        "ticket_managenet_disabled": "Atualize o seu plano para utilizar esta funcionalidade",
        "maximum_sms_count_reached": "Atualize o seu plano para enviar mais SMS",
        "maximum_emails_count_reached": "Atualize o seu plano para enviar mais emails",
        "maximum_companies_count_reached": "Atualize o seu plano para utilizar esta funcionalidade",
        "maximum_users_count_reached": "Atualize o seu plano para utilizar esta funcionalidade",
        "maximum_templates_count_reached": "Atualize o seu plano para utilizar esta funcionalidade",
        "maximum_company_services_count_reached": "Atualize o seu plano para utilizar esta funcionalidade",
        "maximum_reply_rules_count_reached": "Atualize o seu plano para utilizar esta funcionalidade",
        "review_platforms_disabled": "Atualize o seu plano para utilizar esta funcionalidade",
        "IFOOD_AUTHENTICATION_FAILED": "Falha na autenticação do iFood",
        "IFOOD_REVIEW_ALREADY_REPLIED": "Comentário já respondido",
        "IFOOD_MERCHANT_NOT_REGISTERED": "O acesso do iFood para este estabelecimento não está ativo",
        "IFOOD_INTEGRATION_NOT_CONNECTED": "A integração com o iFood não está conectada",
        "IFOOD_REVIEW_DISCARDED_OR_MODERATION_PENDING": "A avaliação já foi descartada ou tem moderação pendente",
        "IFOOD_INVALID_REVIEW_REPLY_LENGTH": "A resposta tem um limite mínimo de 10 e um máximo de 300 caracteres",
        "IFOOD_EMPTY_REVIEW": "Você não pode responder à revisão com comentários vazios",
        "IFOOD_REVIEW_RATING_NOT_REPLYABLE": "Avaliações de cinco estrelas não podem ser respondidas",
        "IFOOD_REVIEW_REPLY_WINDOW_EXPIRED": "O iFood deixa de aceitar respostas 5 dias após a avaliação",
        "channel_not_connected": "Não se pode enviar mensagens para este canal porque não está ligado.",
        "channel_unreachable_contact": "Este contacto não pode receber mensagens por este canal. Verifique o número de telefone e tente novamente.",
        "ringcentral_not_connected": "A conta RingCentral já não está conectada. Reconecte-a em Integrações.",
        "ringcentral_number_not_available": "O número selecionado não pode enviar SMS a partir desta conta RingCentral.",
        "ringcentral_unavailable": "O RingCentral não está a responder. Tente novamente dentro de alguns minutos.",
        "channel_phone_number_in_use": "Este número de telefone já é usado por outro canal.",
        "sms_provider_cannot_change": "Não é possível alterar o fornecedor de um canal SMS existente. Crie um canal novo.",
        "file_size_too_large": "O tamanho do ficheiro não pode exceder {{size}} {{metric}}",
        "attachment_type_not_supported": "Este tipo de ficheiro não pode ser enviado por este canal",
        "file_size_too_small": "O tamanho do ficheiro não pode ser inferior a {{size}} {{metric}}",
        "image_dimensions_too_small": "A imagem deve ter pelo menos {{minWidth}}×{{minHeight}} pixels",
        "video_duration_out_of_range": "O vídeo deve durar entre {{min}} e {{max}} segundos para as plataformas selecionadas",
        "VTEX_AUTHENTICATION_FAILED": "Falha na autenticação do VTEX",
        "COVERMANAGER_NOT_CONNECTED": "CoverManager não está conectado",
        "FACEBOOK_NOT_AUTHENTICATED": "O Facebook não está autenticado",
        "FACECBOOK_COMMON_ERROR": "O Facebook não está disponível no momento, tente novamente mais tarde",
        "WHATSAPP_REGISTRATION_FAILED": "Falha no registo do número de telefone do WhatsApp. Verifique se o número está verificado e tente novamente.",
        "WHATSAPP_CLOUD_API_NOT_ACCEPTED": "Tem de aceitar os Termos de Serviço da API Cloud do WhatsApp Business antes de conectar.",
        "WHATSAPP_WABA_MISSING": "O registo do WhatsApp não devolveu uma conta WhatsApp Business. Volte a conectar e conclua todos os passos do registo.",
        "WHATSAPP_NUMBER_NOT_VALID": "O formato do número de telefone do WhatsApp não é válido.",
        "WHATSAPP_NUMBER_IN_USE": "Este número ainda está registado numa aplicação do WhatsApp. Se for a aplicação WhatsApp Business, volte a conectá-lo e escolha continuar a usar a aplicação. Caso contrário, faça uma cópia de segurança das suas conversas, elimine essa conta do WhatsApp, aguarde alguns minutos e tente novamente.",
        "Internal error": "Algo errado aconteceu",
        "csv_validation": "Formato incorreto de ficheiro",
        "csv_import_phone_invalid": "O número de telefone deve estar no formato internacional se o país não estiver especificado",
        "csv_import_country_required": "Defina o país de: {{errors}}",
        "invalid_format": "Formato incorreto de ficheiro",
        "request_timeout": "A solicitação expirou. Por favor, tente novamente",
        "channel_configuration_error": "Não é possível enviar a mensagem: Configuração do canal inválida",
        "phoneOrEmailRequired": "Um telefone ou um email deve ser obrigatório",
        "phone_number_required": "Número de telefone de contato é obrigatório",
        "email_required": "Endereço de e-mail de contato é obrigatório",
        "invalid_email": "Endereço de e-mail de contato não é válido: {{errors}}",
        "videos_not_supported_by_google": "Vídeos não são compatíveis com o Google",
        "google_allow_one_image": "As publicações no Google só podem ter 1 imagem",
        "stories_allow_one_media": "As histórias permitem exatamente uma imagem ou um vídeo",
        "facebook_allow_one_video": "As publicações no Facebook só podem ter 1 vídeo",
        "facebook_allow_one_type_of_media": "As publicações de vídeo do Facebook não podem incluir imagens",
        "tiktok_allow_one_video": "As publicações no TikTok só podem ter 1 vídeo",
        "tiktok_no_mixed_media": "As publicações no TikTok não podem misturar fotos e vídeos",
        "tiktok_max_photos_exceeded": "As publicações de fotos no TikTok aceitam no máximo 35 imagens",
        "x_allow_one_video": "As publicações no X só podem ter 1 vídeo",
        "x_no_mixed_media": "As publicações no X não podem misturar fotos e vídeos",
        "x_max_photos_exceeded": "As publicações no X aceitam no máximo 4 imagens",
        "profile_connected_to_another_location": "Este perfil online já está ligado a outra localização. Escolha um perfil diferente ou desligue-o da localização atual antes de continuar",
        "brand_locations_required": "A marca requer pelo menos uma localização",
        "brand_requires_location": "Esta é a única localização da marca. Atribua primeiro outra localização à marca",
        "delete_brand_failed_assigned_to_channels": "Impossível eliminar. Marca atribuída a canais ativos",
        "delete_brand_failed_assigned_to_agent": "Impossível eliminar. Marca atribuída a agente ativo",
        "delete_brand_failed_assigned_to_survey_templates": "Impossível eliminar. Marca vinculada a modelos de pesquisa existentes",
        "conversations_export_in_progress": "Exportação em andamento. Aguarde o e-mail",
        "export_in_progress": "Exportação em andamento. Aguarde o e-mail",
        "invalidWhatsAppTemplate": "O modelo contém variáveis não suportadas",
        "an_unexpected_error_occurred": "Ocorreu um erro inesperado. Por favor, tente novamente",
        "agent_sole_knowledge_owner": "Não é possível eliminar o agente. Existe conteúdo da base de conhecimento atribuído apenas a este agente. Reatribua-o ou remova-o primeiro.",
        "team_owns_channels": "Esta equipe possui canais. Primeiro reatribua seus canais a outra equipe.",
        "team_owns_channels_requires_messaging": "Não é possível remover o acesso a mensagens de uma equipe que possui canais. Primeiro reatribua seus canais.",
        "channel_team_required": "Selecione uma equipe para este canal.",
        "live_chat_notification_channel_out_of_scope": "O canal de acompanhamento deve pertencer à marca do live chat, ou a nenhuma localização ou marca.",
        "live_chat_brand_required": "Escolha a marca à qual este live chat pertence.",
        "live_chat_phone_or_email_required": "Torne o e-mail ou o telefone um campo obrigatório.",
        "live_chat_follow_up_channel_required": "Escolha um canal para falar com os visitantes que saíram.",
        "live_chat_follow_up_channel_not_collected": "O canal de acompanhamento precisa de um dado de contato que o chat não exige. Escolha outro canal.",
        "live_chat_locations_out_of_brand": "Todas as localizações selecionadas devem pertencer à marca escolhida.",
        "live_chat_texts_required": "Escreva a mensagem de boas-vindas.",
        "live_chat_welcome_name_fallback_required": "Na mensagem de boas-vindas {{errors}}, adicione a cada [name] um texto substituto para os visitantes não autenticados, como [name|cliente].",
        "business_hours_time_zone_invalid": "O fuso horário do horário não é suportado. Entre em contato com o suporte.",
        "business_hours_invalid": "O horário de funcionamento deve ter horas como 09:00.",
        "business_hours_range_empty": "Um intervalo não pode começar e terminar no mesmo horário.",
        "business_hours_days_required": "Ative pelo menos um dia.",
        "live_chat_location_out_of_scope": "Este live chat não atende a localização selecionada.",
        "channel_team_requires_messaging": "Esta equipe não tem acesso a mensagens. Escolha uma equipe com permissões de mensagens.",
        "page_already_connected": "Esta página já está conectada a outro canal.",
        "page_cannot_be_changed": "A página de um canal existente não pode ser alterada. Crie um novo canal.",
        "subscription_required": "É necessária uma assinatura ativa — assine para continuar",
        "minimum_locations_required": "O plano Pluspoint começa em {{minimumLocations}} localizações",
        "plan_not_available_for_new_subscriptions": "Este plano já não está disponível para novas assinaturas",
        "custom_pricing_requires_support": "A sua conta tem preços personalizados. Contacte o suporte para alterar o plano ou o período de faturação.",
        "billing_catalog_ambiguous": "A faturação está temporariamente indisponível para este plano. Contacte o suporte.",
        "directories_addon_requires_subscription": "Diretórios Locais requer uma assinatura ativa",
        "directories_addon_included_in_plan": "A publicação em Diretórios Locais já está incluída no seu plano",
        "directories_addon_already_enrolled": "Esta localização já tem Diretórios Locais",
        "directories_addon_not_enrolled": "Esta localização não tem Diretórios Locais",
        "directories_addon_subscription_required": "Escolha em que assinatura cobrar os Diretórios Locais",
        "directories_addon_minimum_term": "Diretórios Locais pode ser cancelado após o período mínimo de 3 meses",
        "directories_addon_country_not_supported": "A publicação em Diretórios Locais ainda não está disponível no país desta localização",
        "locations_below_directories_enrollments": "{{enrolledLocationsCount}} localização(ões) têm Diretórios Locais — cancele esses complementos antes de reduzir localizações",
        "billing_surveys_disabled": "As pesquisas não estão incluídas no seu plano atual",
        "billing_campaigns_disabled": "As campanhas não estão incluídas no seu plano atual",
        "billing_coupons_disabled": "Os cupões não estão incluídos no seu plano atual",
        "billing_plan_not_found": "Plano de faturação não encontrado",
        "billing_stripe_subscription_not_found": "Assinatura não encontrada",
        "billing_stripe_subscription_email_is_empty": "A assinatura não tem e-mail registado",
        "subscription_expired": "A sua assinatura expirou — renove-a para continuar",
        "maximum_custom_domains_reached": "Atingiu o número máximo de domínios personalizados do seu plano",
        "billing_listing_directories_disabled": "Os diretórios de listagens não estão disponíveis no seu plano atual",
        "email_template_name_taken": "Já existe um modelo com esse nome.",
        "email_template_not_found": "Modelo de email não encontrado. Ele pode ter sido excluído.",
        "email_template_required": "Campanhas de email do tipo mensagem exigem um modelo da biblioteca.",
        "email_template_archived": "Este modelo está arquivado e não pode ser selecionado. Desarquive-o na biblioteca primeiro.",
        "email_template_read_only": "Os designs iniciais são somente leitura. Duplique o modelo para editá-lo.",
        "email_template_invalid_design": "O design do modelo é inválido. Verifique o conteúdo dos blocos, as URLs e o tamanho dos campos.",
        "email_template_dynamic_link_required": "Campanhas de pesquisa e cupom precisam de um modelo com botão de link dinâmico.",
        "email_template_dynamic_link_not_supported": "Modelos com botão de link dinâmico só podem ser usados em campanhas de pesquisa ou cupom.",
        "email_template_link_type_mismatch": "Os botões de link deste modelo apontam para outro tipo de destino, então ele não pode ser usado nesta campanha.",
        "email_template_links_locked_while_in_use": "Os botões de link dinâmico deste modelo são usados em campanhas ou automações. Remova essas referências ou duplique o modelo.",
        "whatsapp_template_required": "Campanhas de WhatsApp exigem um modelo de mensagem.",
        "email_template_in_use": "Este modelo é usado em campanhas ou automações e não pode ser excluído. Remova essas referências primeiro.",
        "whatsapp_template_delete_blocked": "Este modelo é usado em campanhas ou automações e não pode ser excluído. Remova essas referências ou arquive o modelo.",
        "whatsapp_template_in_use": "Este modelo é usado por campanhas agendadas ou em andamento, ou por automações ativas. Duplique-o e edite a cópia, ou remova essas referências primeiro.",
        "whatsapp_template_copy_code_requires_coupon": "O botão de copiar código deste modelo precisa de uma campanha de oferta para fornecer o código.",
        "whatsapp_template_header_media_missing": "O cabeçalho de imagem deste modelo ainda não tem imagem. Conclua a configuração dele na Biblioteca primeiro.",
        "whatsapp_template_not_found": "Modelo de WhatsApp não encontrado. Ele pode ter sido excluído.",
        "whatsapp_template_name_taken": "Já existe um modelo com esse nome e idioma.",
        "whatsapp_template_invalid_content": "O conteúdo do modelo é inválido. Verifique as variáveis, os botões e o tamanho dos campos.",
        "whatsapp_template_not_editable": "Este modelo não pode ser editado no status atual.",
        "whatsapp_template_unavailable": "Este modelo de WhatsApp está indisponível no momento — ele pode estar pausado, desativado ou sem configurações obrigatórias.",
        "whatsapp_template_not_approved": "Somente modelos de WhatsApp aprovados podem ser usados em campanhas.",
        "whatsapp_template_not_mapped": "O modelo tem variáveis sem configuração. Conclua a configuração na biblioteca primeiro.",
        "whatsapp_template_archived": "Este modelo está arquivado e não pode ser selecionado. Desarquive-o na biblioteca primeiro.",
        "whatsapp_template_waba_mismatch": "Este modelo pertence a uma conta do WhatsApp Business diferente da do canal selecionado.",
        "whatsapp_template_disconnected": "A conta do WhatsApp Business deste modelo está desconectada.",
        "whatsapp_template_link_required": "Campanhas de pesquisa e oferta precisam de um modelo com botão de link dinâmico.",
        "whatsapp_template_link_not_supported": "Este modelo tem um botão de link dinâmico, então só pode ser usado em campanhas de pesquisa ou oferta.",
        "whatsapp_template_link_type_mismatch": "O botão de link deste modelo aponta para um tipo de destino diferente do que este envio precisa.",
        "whatsapp_template_links_locked_while_in_use": "Não é possível adicionar ou remover o botão de link enquanto campanhas ou automações usam este modelo. Remova essas referências ou duplique o modelo.",
        "automation_invalid_trigger": "Uma automação precisa de exatamente um gatilho.",
        "automation_trigger_no_events": "Escolha pelo menos um evento de gatilho.",
        "automation_no_action": "Adicione pelo menos uma mensagem ou pesquisa ligada ao gatilho.",
        "automation_wait_invalid": "Uma etapa de espera precisa de uma duração maior que zero.",
        "automation_survey_missing": "Escolha um modelo de pesquisa para a etapa de pesquisa.",
        "automation_message_empty": "Adicione conteúdo à etapa de mensagem.",
        "automation_condition_incomplete": "Um filtro está sem campo ou valor.",
        "automation_too_large": "Uma automação não pode ter mais de 100 etapas.",
        "automation_unreachable_node": "Cada etapa deve estar conectada ao gatilho.",
        "automation_has_cycle": "Uma automação não pode conter loops.",
        "automation_invalid_edge": "Uma conexão aponta para uma etapa inexistente.",
        "automation_branch_edge_invalid": "Os caminhos de uma ramificação devem ser marcados como sim ou não.",
        "automation_branch_duplicate": "Uma ramificação pode ter no máximo um caminho de sim e um de não.",
        "automation_multiple_next": "Uma etapa pode ter no máximo uma próxima etapa.",
        "automation_unexpected_branch_key": "Apenas ramificações podem ter caminhos marcados.",
        "automation_invalid_node_id": "Uma etapa da automação está sem id.",
        "automation_duplicate_node_id": "As etapas da automação devem ter ids únicos.",
        "automation_node_channel_required": "Escolha um canal para cada etapa de mensagem e pesquisa.",
        "automation_node_channel_invalid": "Uma etapa usa um canal inválido ou indisponível.",
        "automation_node_survey_invalid": "Uma etapa usa um modelo de pesquisa inválido.",
        "automation_node_coupon_invalid": "Uma etapa usa um modelo de cupom inválido.",
        "automation_channel_type_unsupported": "Esse tipo de canal não é compatível com automações.",
        "automation_segment_in_use": "Este segmento é usado em uma automação. Remova-o da automação antes de excluir.",
        "facebook_profile_id_missing": "Este link do Facebook não inclui o id do perfil. Copie o endereço completo da página, incluindo a parte ?id=",
        "google_place_id_missing": "Este link do Google não contém um id de local",
        "profile_url_invalid": "Insira um endereço web completo que comece com http:// ou https://",
        "social_platform_managed_as_link": "Esta rede social é gerida através das ligações sociais da localização, não como perfil de avaliações",
        "ubereats_store_url_invalid": "Insira o endereço da página de uma loja no Uber Eats, por exemplo https://www.ubereats.com/store/nome/id",
        "bbb_profile_url_invalid": "Insira o endereço do perfil da empresa no BBB, por exemplo https://www.bbb.org/us/tx/san-antonio/profile/categoria/nome-0825-1000132336",
        "thefork_restaurant_url_invalid": "Insira o endereço da página de um restaurante no TheFork, por exemplo https://www.thefork.com/restaurant/nome-r123",
        "booking_profile_url_invalid": "Insira o endereço de uma página de hotel do Booking.com, por exemplo https://www.booking.com/hotel/br/nome.html",
        "expedia_group_profile_already_connected": "Esta localização já tem Expedia / Hotels.com. Para mudar para o outro site, remova-o e adicione o novo endereço.",
        "expedia_group_profile_url_invalid": "Insira o endereço da página da propriedade no Expedia ou no Hotels.com, por exemplo https://www.hotels.com/ho123456",
        "booking_extranet_url_invalid": "Insira um link da Extranet do Booking.com desta propriedade ou o ID numérico dela.",
        "media_dimensions_too_large": "O arquivo não pode exceder {{maxWidth}}×{{maxHeight}} pixels para as plataformas selecionadas",
        "video_invalid": "Este arquivo não é um vídeo válido",
        "video_too_long": "O vídeo excede a duração máxima para as plataformas selecionadas",
        "video_too_short": "O vídeo é mais curto que o mínimo de 3 segundos",
        "video_too_large": "O vídeo excede o tamanho máximo de envio",
        "video_too_small": "O arquivo de vídeo está vazio ou é pequeno demais para ser um vídeo válido",
        "video_format_unsupported": "Apenas arquivos de vídeo MP4 são suportados",
        "video_processing_failed": "Não foi possível processar o vídeo. Tente exportá-lo novamente como MP4.",
        "video_codec_unsupported": "O vídeo deve estar codificado em H.264 ou HEVC — exporte-o novamente como MP4 padrão",
        "video_audio_unsupported": "O áudio do vídeo deve ser AAC — exporte-o novamente como MP4 padrão",
        "video_too_large_for_platform": "Este vídeo é grande demais para uma das plataformas selecionadas — veja os avisos acima",
        "video_too_small_for_platform": "Este vídeo está abaixo do tamanho mínimo de uma das plataformas selecionadas",
        "video_too_long_for_platform": "Este vídeo é longo demais para uma das plataformas selecionadas — veja os avisos acima",
        "video_too_short_for_platform": "Este vídeo é mais curto que o mínimo de 3 segundos",
        "video_too_wide_for_platform": "A resolução deste vídeo é alta demais para uma das plataformas selecionadas — veja os avisos acima",
        "video_not_supported_by_platform": "Uma das plataformas selecionadas não aceita publicações de vídeo",
        "video_link_untrusted": "Este vídeo precisa ser enviado pelo Pluspoint antes de ser usado",
        "video_external_not_supported_by_tiktok": "O TikTok só publica vídeos enviados pelo Pluspoint — envie o arquivo ou remova o TikTok",
        "tiktok_settings_required": "Faltam as definições do TikTok. Abra a publicação e escolha-as.",
        "tiktok_disclosure_incomplete": "Tem de indicar se o seu conteúdo promove a si próprio, a terceiros ou a ambos.",
        "video_too_long_for_creator": "O vídeo é mais longo do que a conta do TikTok conectada permite.",
        "tiktok_privacy_unavailable": "A opção de privacidade que escolheu já não está disponível na conta do TikTok conectada. Tente novamente quando a conta a voltar a oferecer, ou agende uma nova publicação com outro público.",
        "tiktok_branded_private": "O conteúdo de marca não pode ser publicado como Só eu.",
        "tiktok_cannot_post_now": "O TikTok não está a aceitar publicações desta conta neste momento. Tente novamente mais tarde.",
        "tiktok_unaudited": "A aplicação do TikTok da Pluspoint ainda não está aprovada para publicações públicas.",
        "tiktok_account_not_resolved": "Esta localização não indica que conta do TikTok publica para ela. Escolha uma no perfil da localização.",
        "tiktok_auth_removed": "A conta do TikTok foi desconectada. Volte a ligá-la e depois tente novamente.",
        "tiktok_media_pull_failed": "O TikTok não conseguiu descarregar o conteúdo. Tente novamente.",
        "tiktok_media_rejected": "O TikTok rejeitou o conteúdo. Verifique o formato, a resolução e a duração e depois agende uma nova publicação.",
        "tiktok_publish_cancelled": "A publicação foi cancelada no TikTok.",
        "video_too_wide": "A resolução deste vídeo excede a de qualquer plataforma suportada (máx. 4096 px no lado maior)",
        "review_reply_draft_unusable": "A Pulse AI devolveu um rascunho com marcadores por preencher. Tente Escrever resposta novamente.",
        "recovery_form_unresolved": "O formulário de recuperação não está disponível para esta avaliação. Remova o marcador da resposta.",
        "description_contains_url": "Não são permitidos links nas descrições do negócio.",
        "special_hours_times_required": "Uma data especial aberta precisa do seu horário.",
        "special_hours_times_not_allowed": "Uma data especial fechada não pode ter horário.",
        "special_hours_invalid_time_range": "Um intervalo de tempo deve terminar depois de começar.",
        "location_not_found": "Esta localização não existe mais.",
        "concurrency_conflict": "Outra pessoa alterou ou excluiu esta localização ao mesmo tempo. Abra-a de novo e tente outra vez.",
        "bulk_update_conflict": "Outra pessoa alterou uma destas localizações enquanto a edição era aplicada. Nada foi salvo. Aplique a edição de novo.",
        "email_domain_taken": "Este domínio já está registrado. Fale com o suporte se ele for seu.",
        "email_domain_suspended": "O envio a partir deste domínio está suspenso. Fale com o suporte.",
        "email_domain_public": "Este é um provedor de e-mail público. Use um domínio que pertença ao seu negócio.",
        "email_domain_reserved": "Domínios da Pluspoint não podem ser conectados.",
        "email_domain_invalid": "Informe um domínio válido, por exemplo acme.com.",
        "email_domain_return_path_invalid": "O subdomínio Return-Path só pode conter letras, dígitos e hifens.",
        "hosted_email_capacity": "Não é possível conectar e-mail no seu próprio domínio agora. Fale com o suporte.",
        "email_domain_return_path_fixed": "Este domínio já tem um subdomínio Return-Path. Desative o subdomínio personalizado para reutilizá-lo.",
        "email_address_invalid": "Informe um endereço de e-mail válido no seu próprio domínio.",
        "email_channel_address_locked": "O endereço deste canal de e-mail não pode ser alterado.",
        "email_channel_hosted_create": "Canais de e-mail com domínio próprio são criados pela configuração do domínio.",
        "email_domain_in_use": "Exclua primeiro os canais deste domínio.",
        "hosted_email_unavailable": "E-mail com domínio próprio não está disponível neste ambiente.",
        "channel_not_ready": "Este canal ainda está aguardando a verificação do domínio.",
        "channel_throttled": "O serviço de envio está sobrecarregado. Tente de novo em um minuto.",
        "email_domain_check_failed": "Não foi possível verificar os registros agora. Tente de novo em um minuto.",
        "invalid_website": "Insira um domínio, com ou sem caminho, como ajuda.exemplo.com ou exemplo.com/ajuda",
        "document_too_many_pages": "O ficheiro não pode exceder {{pages}} páginas",
        "document_too_many_rows": "Cada folha não pode exceder {{rows}} linhas",
        "knowledge_base_document_limit": "Estes agentes já têm o número máximo de documentos: {{errors}}",
        "knowledge_base_website_limit": "Estes agentes já têm o número máximo de sites: {{errors}}",
        "knowledge_base_conflict": "Outra pessoa alterou este conteúdo ao mesmo tempo. Nada foi salvo. Tente de novo.",
        "file_required": "Selecione um ficheiro",
        "no_active_account": "Você não tem mais acesso a nenhuma conta da Pluspoint. Peça ao proprietário da conta para convidar você novamente.",
        "invalid_sex": "O sexo deve ser Feminino ou Masculino: {{errors}}",
        "invalid_date_of_birth": "A data de nascimento deve ser AAAA-MM-DD, ou MM-DD sem o ano, a partir de 1900 e não no futuro: {{errors}}",
        "invalid_language": "O idioma deve ser um código de idioma como en ou pt: {{errors}}",
        "birth_year_required": "Uma data de nascimento digitada precisa do ano",
        "automation_trigger_date_invalid": "Escolha uma data e um horário válidos para o gatilho.",
        "automation_condition_invalid": "Um filtro tem um valor que não pode ser usado.",
        "automation_trigger_date_passed": "Esta data única já passou.",
        "automation_condition_event_on_date": "Filtros de evento não se aplicam a uma automação que começa em uma data."
    },
    "AnalyticsConversion": {
        "conversion": "Conversão",
        "sentSurveys": "Pesquisas enviadas",
        "responsesReceived": "Respostas recebidas",
        "reviewsReceived": "Avaliações recebidas",
        "openedSurveys": "Pesquisas abertas",
        "responses": "Respostas",
        "proceededToReviewSite": "Seguiu para sites de avaliação",
        "responseRate": "Taxa de Respostas",
        "reviewRate": "Taxa de Avaliações",
        "reviewRateTooltip": "A taxa de avaliações inclui todas as avaliações dos locais selecionados, não apenas as originadas de pesquisas. A taxa real de avaliações geradas por pesquisas pode ser diferente.",
        "fromPreviousPeriod": "do período anterior",
        "reviewsLifecycle": "Funil de conversão",
        "overall": "Geral",
        "surveyInvitations": "Convites para pesquisas",
        "qrCodes": "Códigos QR",
        "conversionTrend": "Tendência de conversão"
    },
    "AnalyticsKeywords": {
        "tableTitle": "Tabela de Análise de Palavra-chave",
        "keyword": "Palavra-chave",
        "avgRating": "Pontuação média",
        "numberOfReviews": "Número de Avaliações",
        "sentiment": "Sentimento",
        "positiveKeywords": "Palavras-chave positivas",
        "negativeKeywords": "Palavras-chave negativas"
    },
    "AnalyticsOperationalInsights": {
        "topStrengths": "Principais pontos fortes",
        "topStrengthsSubtitle": "As categorias onde os clientes mais frequentemente deixam avaliações de 5 estrelas.",
        "topIssues": "Principais problemas",
        "topIssuesSubtitle": "As categorias mais frequentemente mencionadas em avaliações com pontuações mais baixas.",
        "incidents": "Incidentes",
        "incidentsSubtitle": "A percentagem de avaliações negativas em cada categoria. Valores mais altos indicam uma maior concentração de insatisfação dos clientes.",
        "sentimentScore": "Pontuação de sentimento",
        "sentimentScoreSubtitle": "O equilíbrio geral entre feedback positivo e negativo por categoria. Pontuações positivas indicam pontos fortes; pontuações negativas indicam áreas problemáticas."
    },
    "AnalyticsReviews": {
        "averageRating": "Pontuação média",
        "reviews": "Avaliações",
        "totalReviews": "Avaliações Totais",
        "totalRepliesPercentage": "Taxa de resposta",
        "totalResponses": "Respostas Totais",
        "reviewsRatingDistribution": "Distribuição média de pontuação",
        "responsesRatingDistribution": "Distribuição média de respostas",
        "stars1": "1 estrela",
        "stars2": "2 estrelas",
        "stars3": "3 estrelas",
        "stars4": "4 estrelas",
        "stars5": "5 estrelas",
        "ratingsTimeline": "Linha temporal de classificações",
        "ratingsTimelineTooltip": "A linha temporal de classificações mostra valores históricos estimados. As classificações reais nas plataformas podem diferir.",
        "reviewIndex": "Índice de avaliações",
        "reviewIndexTooltip": "Uma pontuação de até 100 que mostra como os clientes avaliam as suas localizações nos sites de avaliação, em que as avaliações recentes pesam mais. Aparece quando há avaliações recentes com nota suficientes.",
        "sentimentTrend": "Tendência sentimental",
        "positiveReviews": "Avaliações positivas",
        "positiveResponses": "Respostas positivas",
        "negativeReviews": "Avaliações negativas",
        "negativeResponses": "Respostas negativas",
        "reviewSitesTrend": "Tendência de sites de avaliação",
        "fromPreviousPeriod": "do período anterior",
        "others": "Outros",
        "nps": "Net Promoter Score",
        "reviewsByDay": "Avaliações por dia",
        "reviewsByDaypart": "Avaliações por período do dia",
        "sunday": "Dom",
        "monday": "Seg",
        "tuesday": "Ter",
        "wednesday": "Qua",
        "thursday": "Qui",
        "friday": "Sex",
        "saturday": "Sáb",
        "morning": "Manhã",
        "afternoon": "Tarde",
        "evening": "Noite"
    },
    "AnalyticsConversations": {
        "responseRate": "Taxa de respostas",
        "responseTime": "Tempo de respostas (horas)",
        "resolutionTime": "Tempo de resoluções (horas)",
        "resolutionRate": "Taxa de resoluções",
        "newConversations": "Novas conversas",
        "resolvedConversations": "Conversas resolvidas",
        "openConversations": "Conversas abertas",
        "unassignedConversations": "Conversas não atribuídas",
        "conversationsTrend": "Tendência",
        "channelsBreakdown": "Distribuição canais",
        "totalConversations": "Total de conversas",
        "messagesPerConversation": "Mensagens por conversa",
        "conversationsHandled": "Conversas atendidas",
        "averageHandleTime": "Tempo médio de atendimento (horas)"
    },
    "AnalyticsSocialPosts": {
        "posts": "Publicações",
        "followers": "Seguidores",
        "reach28": "Alcance a 28 dias",
        "rateByReach": "Taxa de interação por alcance",
        "rateByFollowers": "Taxa de interação por seguidores",
        "reach": "Alcance",
        "likes": "Curtidas",
        "comments": "Comentários",
        "shares": "Compartilhamentos",
        "engagements": "Engajamentos",
        "clicks": "Cliques",
        "saves": "Salvamentos",
        "percentagePoints": "{{value}} p.p."
    },
    "AnalyticsPresence": {
        "searchAppearances": "Aparições em pesquisa",
        "views": "Visualizações",
        "calls": "Chamadas",
        "directions": "Direcções",
        "websiteClicks": "Cliques no site",
        "devicesBreakdown": "Desagregação por dispositivos",
        "googleSearchMobile": "Pesquisa Google - Móvel",
        "googleMapsMobile": "Google Maps - Móvel",
        "googleSearchDesktop": "Pesquisa do Google - Desktop",
        "googleMapsDesktop": "Google Maps - Desktop",
        "searchKeywords": "Palavras-chave de pesquisa",
        "totalViews": "Visualizações totais"
    },
    "AnalyticsVisibility": {
        "pageTitle": "Acompanhe sua visibilidade na busca local",
        "pageSubtitle": "Veja como cada localização aparece nos resultados do Google Maps em uma grade de pontos ao redor dela. Compare localizações, acompanhe as mudanças de posição ao longo do tempo, execute análises quando quiser e abra uma localização para ver o mapa ponto a ponto e os concorrentes.",
        "reportTitle": "Relatório de visibilidade",
        "vs90DaysAgo": "vs. há 90 dias",
        "loadError": "Não foi possível carregar os dados de visibilidade. Tente novamente.",
        "averageVisibility": "Visibilidade média",
        "locationsInTop3": "Localizações no top 3 local",
        "averageMapRank": "Posição média no mapa",
        "location": "Localização",
        "visibility": "Visibilidade",
        "avgRank": "Posição média",
        "rankTrend": "Tendência de posição",
        "rankTrendHint": "Posição média no mapa por mês nos últimos 12 meses, do mais antigo ao mais recente. Meses sem análises aparecem como intervalos.",
        "delta90d": "Variação de posição (90 d)",
        "delta90dHint": "Variação da posição média no mapa em relação à análise mais próxima de há 90 dias. Verde — subiu em direção ao n.º 1, vermelho — desceu.",
        "inTop3": "No top 3",
        "inTop3Hint": "Percentagem de pontos analisados onde este negócio apareceu no top 3 local na última análise.",
        "avgMapRank": "Posição média no mapa",
        "top3Points": "Pontos no top 3",
        "trackedKeywords": "Palavras-chave monitorizadas",
        "whoWinsHere": "Quem vence aqui",
        "business": "Negócio",
        "rating": "Avaliação",
        "you": "você",
        "runNewScan": "Executar nova verificação",
        "printReport": "Imprimir relatório",
        "scanInProgress": "Verificação em curso",
        "scanDate": "Data da análise",
        "googleProfile": "Perfil do Google",
        "address": "Endereço",
        "phone": "Telefone",
        "website": "Site",
        "mapRankTitle": "Posição no mapa — {{keyword}}",
        "gridSpacing": "espaçamento de {{km}} km",
        "top3": "Top 3",
        "fourToTen": "4–10",
        "elevenToTwenty": "11–20",
        "notInTop20": "Fora do top 20",
        "noDataYet": "Ainda não há resultados — configure a monitorização de uma localização para executar a primeira verificação",
        "noCoordinates": "Complete o endereço para ativar a verificação",
        "rescanConflict": "Já existe uma verificação em curso para esta localização",
        "gridSettings": "Configurações da grelha",
        "gridSizeLabel": "Tamanho da grelha",
        "gridSpacingLabel": "Distância entre pontos",
        "spacingKm": "{{km}} km",
        "addKeywordLabel": "Adicionar palavra-chave",
        "keywordsRequired": "Adicione pelo menos uma palavra-chave",
        "excludePinsHint": "Clique num ponto para o excluir da monitorização; clique num ponto excluído para o restaurar.",
        "keepOnePin": "Pelo menos um ponto deve continuar a ser monitorizado",
        "settingsApplyNote": "As alterações aplicam-se a partir da próxima verificação.",
        "settingsSaved": "Configurações de visibilidade guardadas",
        "settingsSavedScanStarted": "Configurações guardadas — primeira verificação iniciada",
        "autoScan": "Verificação mensal",
        "autoScanHint": "Quando ativada, esta localização é verificada automaticamente todos os meses.",
        "autoScanConfigureFirst": "Configure primeiro a monitorização desta localização",
        "viewReports": "Ver relatórios",
        "runScan": "Executar verificação",
        "scanStarted": "Verificação iniciada",
        "configure": "Configurar",
        "reviews": "Avaliações",
        "reviewsHint": "Total de avaliações do Google; o valor entre parênteses é a variação mensal, estimada a partir da diferença entre as duas últimas verificações.",
        "categories": "Categorias",
        "googleMapsLink": "Perfil",
        "openOnGoogleMaps": "Abrir no Google Maps",
        "competitorPinHint": "★ — localização deste concorrente"
    },
    "alertMessages": {
        "popupBlocked": "Permita pop-ups para abrir o formulário de denúncia do Google",
        "createSuccess": "Criado com sucesso",
        "createFail": "Não foi possível criar",
        "editSuccess": "Editado com sucesso",
        "editFail": "Não foi possível editar",
        "deleteSuccess": "Excluído com sucesso",
        "deleteFail": "Não foi possível excluir",
        "updateSuccess": "Atualizado com sucesso",
        "updateFail": "Não foi possível atualizar",
        "retrySuccess": "Nova tentativa agendada",
        "retryFail": "Não foi possível agendar nova tentativa",
        "downloadFail": "Não foi possível baixar",
        "printFail": "Não foi possível imprimir",
        "sendSuccess": "Enviada com sucesso",
        "conversationCreated": "Conversa criada",
        "sendFail": "Não foi possível enviar",
        "importSuccess": "Importado com sucesso",
        "importFail": "Não foi possível importar",
        "importPartial": "Importadas {{imported}} localizações, ignoradas {{skipped}}",
        "cancelSuccess": "Cancelado com sucesso",
        "cancelFail": "Não foi possível cancelar",
        "uploadSuccess": "Upload bem sucedido",
        "uploadFail": "Não foi possível fazer o upload",
        "connectIntegrationSuccess": "A integração foi conectada com sucesso",
        "connectIntegrationFail": "Não foi possível conectar a integração",
        "ifoodConnectRequestSent": "Sua solicitação de conexão com o iFood foi enviada. A integração será ativada assim que o iFood conceder o acesso",
        "disconnectIntegrationSuccess": "A integração foi desconectada",
        "disconnectIntegrationFail": "Não foi possível desconectar a integração",
        "tooManyFiles": "Pode carregar no máximo {{limit}} ficheiros",
        "loadFail": "Não foi possível carregar"
    },
    "buttons": {
        "moveConversation": "Mover conversa",
        "cancel": "Cancelar",
        "close": "Fechar",
        "discard": "Descartar",
        "clearFilters": "Limpar filtros",
        "copy": "Copiar",
        "open": "Abrir",
        "delete": "Eliminar",
        "edit": "Editar",
        "create": "Criar",
        "revoke": "Revogar",
        "save": "Salvar",
        "merge": "Fusão",
        "mergeContacts": "Fusão de contactos",
        "saveChanges": "Salvar Alterações",
        "filters": "Filtros",
        "applyFilters": "Aplicar Filtros",
        "addLocation": "Adicionar Local",
        "addLocationManually": "Adicionar Local manualmente",
        "sendMessage": "Enviar Mensagem",
        "reopen": "Reabrir",
        "resolve": "Resolver",
        "enable": "Activar",
        "pause": "Pausar",
        "continue": "Continuar",
        "back": "Voltar",
        "done": "Concluído",
        "cheduleCampaign": "Agendar Campanha",
        "getCode": "Obter Código",
        "reply": "Responder",
        "publish": "Publicar",
        "connect": "Conectar",
        "disable": "Desativar",
        "disconnect": "Desconectar",
        "reconnect": "Reconectar",
        "sendSurveys": "Enviar Pesquisas",
        "replaceCSV": "Substituir Ficheiro CSV",
        "uploadCSVFile": "Escolher Ficheiro",
        "addChannel": "Adicionar Novo Canal",
        "importFromGoogle": "Importar do Google",
        "upgradePlan": "Upgrade do Plano",
        "managePlan": "Gerir Plano",
        "changePlan": "Alterar plano",
        "talkToSales": "Falar com vendas",
        "addUser": "Adicionar Usuário",
        "addRule": "Adicionar Nova Resposta-auto",
        "createCampaign": "Criar Campanha",
        "import": "Importar",
        "contact": "CONTACTAR SUPORTE",
        "setUpSurveys": "Configurar Pesquisas",
        "viewResponses": "Ver Respostas às Pesquisas",
        "newTicket": "Novo ticket",
        "viewTicket": "Ver Ticket",
        "sendLink": "Enviar Link",
        "manageMicrosites": "Gerir Micro-sites",
        "seeSurveyResponse": "Ver Respostas",
        "resolveComplaints": "Resolver Reclamações",
        "replyToReviews": "Responder Avaliações",
        "download": "Baixar",
        "print": "Imprimir",
        "viewReviews": "Ver Avaliações",
        "logIn": "Iniciar Sessão",
        "createNewMicrosite": "Criar Novo Micro-site",
        "replace": "Substituir",
        "upload": "Carregar",
        "add": "Adicionar",
        "localization": "Localização",
        "addLanguage": "Adicionar Idiomas",
        "addCategory": "Adicionar categoria",
        "addManually": "Adicionar Manualmente",
        "connectAnotherAccount": "Conectar a Outra Conta",
        "complete": "Concluído",
        "addTemplate": "Adicionar Modelo de Resposta",
        "changePassword": "Mudar a Senha",
        "signupButton": "Criar Conta",
        "addSurvey": "Criar Nova Pesquisa",
        "createQrCode": "Criar código QR",
        "copyCode": "Copiar Código",
        "replaceSecret": "Substituir segredo",
        "generateSecret": "Gerar segredo",
        "copyLink": "Copiar link",
        "preview": "Vizualizar",
        "exportAsCSV": "Exportar como CSV",
        "exportAsExcel": "Exportar como Excel",
        "logout": "Sair",
        "deleteSite": "Eliminar Micro-site",
        "configure": "Configurar",
        "documentation": "Documentação",
        "viewMore": "Ver mais",
        "confirm": "Confirmar",
        "createNewPost": "Criar nova publicação",
        "manage": "Gerir",
        "connectProfile": "Conectar Perfil",
        "viewStatus": "Ver Status",
        "createNewProfile": "Criar Novo Perfil",
        "manageProfile": "Gerir Perfil",
        "publishProfile": "Publicar Perfil",
        "schedulePost": "Agendar publicação",
        "updateLocations": "Atualizar localizações",
        "validate": "Validar",
        "bulkUpdateCSV": "Importar (CSV)",
        "bulkEdit": "Edição em massa",
        "selectAll": "Selecionar todos",
        "deselectAll": "Desmarcar todos",
        "send": "Enviar",
        "addNewTemplate": "Adicionar novo modelo de mensagem",
        "export": "Exportar",
        "startSync": "Iniciar sincronização",
        "syncing": "Sincronização..",
        "importing": "Importando..",
        "addNewDate": "Adicionar nova data",
        "report": "Denunciar",
        "undoReport": "Desfazer denúncia",
        "viewOnGoogle": "Ver no Google",
        "connectWithMeta": "Conectar Meta Business",
        "saveDraft": "Guardar rascunho",
        "hideAllNotifications": "Ocultar todas as notificações",
        "hide": "Ocultar",
        "markAsReplied": "Marcar como respondido",
        "copyAndOpen": "Copiar e abrir",
        "addContent": "Adicionar conteúdo",
        "createBrand": "Criar uma nova marca",
        "addAgent": "Adicionar agente",
        "reset": "Reiniciar",
        "joinConversation": "Entrar na conversa",
        "join": "Entrar",
        "tryForFree": "Testar grátis",
        "resend": "Reenviar código",
        "cropImage": "Confirmar imagem",
        "assignAgents": "Atribuir agentes",
        "upgrade": "Upgrade"
    },
    "AutomationsPage": {
        "create": "Criar automação",
        "editor": {
            "channel": "Canal",
            "oncePerContact": "Uma vez por contato",
            "save": "Salvar",
            "nameRequired": "Dê um nome à automação",
            "saved": "Automação salva",
            "addStep": "Adicionar etapa",
            "branchYes": "Sim",
            "branchNo": "Não",
            "namePlaceholder": "Automação sem título",
            "fixIssues": "Algumas etapas têm problemas. Corrija as etapas destacadas antes de salvar."
        },
        "palette": {
            "send": "Enviar",
            "flow": "Fluxo"
        },
        "paletteHint": {
            "sendMessage": "Envie um SMS, WhatsApp ou e-mail",
            "sendCoupon": "Envie um cupom ao contato",
            "sendSurvey": "Envie uma pesquisa ao contato",
            "wait": "Pause antes da próxima etapa",
            "branch": "Divida o caminho com base em uma condição"
        },
        "trigger": {
            "whoCanEnter": "Quem pode entrar",
            "byEvent": "Evento",
            "byDate": "Data",
            "date": "Data",
            "contactBirthday": "Aniversário do contato",
            "fixedDate": "Uma data fixa",
            "month": "Mês",
            "day": "Dia",
            "year": "Ano",
            "everyYear": "Todo ano",
            "timing": "Quando",
            "onTheDay": "No dia",
            "before": "Antes",
            "offsetDaysBefore": "Dias antes",
            "after": "Depois",
            "offsetDaysAfter": "Dias depois",
            "sendAt": "Horário",
            "birthday": "Aniversário",
            "whichSegments": "Segmentos (deixe vazio para qualquer um)",
            "daysBefore_one": "{{count}} dia antes",
            "daysBefore_other": "{{count}} dias antes",
            "daysAfter_one": "{{count}} dia depois",
            "daysAfter_other": "{{count}} dias depois"
        },
        "nodes": {
            "trigger": "Gatilho",
            "branch": "Se / então",
            "sendMessage": "Enviar mensagem",
            "sendCoupon": "Enviar cupom",
            "sendSurvey": "Enviar pesquisa",
            "wait": "Aguardar",
            "exit": "Saída",
            "setDuration": "Definir duração",
            "noMessage": "Nenhuma mensagem ainda",
            "pickSurvey": "Escolha uma pesquisa",
            "surveySelected": "Pesquisa selecionada",
            "pickCoupon": "Escolha um cupom",
            "couponSelected": "Cupom selecionado",
            "setCondition": "Definir condição",
            "pickEvents": "Escolha os eventos",
            "eventCount": "{{count}} evento(s)",
            "conditionCount": "{{count}} condição(ões)",
            "exitSubtitle": "Os contatos saem da automação aqui"
        },
        "drawer": {
            "customEventType": "Tipo de evento personalizado (opcional)",
            "branchHint": "O caminho “sim” é seguido quando estas condições são atendidas",
            "wait": "Espera"
        },
        "table": {
            "steps": "Etapas",
            "enrolled": "Contatos inscritos",
            "enrolledHint": "Contatos que entraram nesta automação",
            "failedFixHint": "Esta automação falhou. Abra e corrija o problema para reativá-la."
        },
        "conditions": {
            "everyoneEnters": "Todos que acionarem esta automação entrarão.",
            "matchAllHint": "Somente contatos que atendam a todos estes critérios:",
            "matchAnyHint": "Contatos que atendam a qualquer um destes cenários:",
            "addFilter": "Adicionar filtro",
            "addAlternative": "Adicionar alternativa “OU”",
            "scenario": "Cenário {{number}}",
            "and": "e",
            "or": "ou",
            "segment": "Segmento",
            "segments": "Segmentos",
            "eventField": "Campo do evento",
            "jsonPathPlaceholder": "Caminho JSON, ex.: order.total",
            "value": "Valor",
            "valuePlaceholder": "valor",
            "operators": {
                "isAnyOf": "é qualquer um de",
                "isNoneOf": "não é nenhum de",
                "is": "é",
                "isNot": "não é",
                "isOneOf": "é um de",
                "contains": "contém",
                "notContains": "não contém",
                "isKnown": "está preenchido",
                "isUnknown": "não está preenchido",
                "greaterThan": "é maior que",
                "lessThan": "é menor que"
            },
            "listPlaceholder": "valores, separados por vírgula",
            "tooComplex": "Estes filtros foram criados com um editor antigo e são complexos demais para exibir. Limpe-os para reconstruir.",
            "clearFilters": "Limpar filtros",
            "deletedSegment": "(segmento excluído)",
            "incompleteFilter": "Complete este filtro ou remova-o",
            "eventFields": {
                "provider": "Provedor de pagamento",
                "account": "Conta de pagamento",
                "location": "Localização",
                "amount": "Valor pago",
                "currency": "Moeda",
                "firstPurchase": "Primeira compra",
                "paymentCount": "Número de compras",
                "brand": "Marca"
            },
            "unavailableOption": "(não está mais disponível)",
            "age": "Idade",
            "contactLocation": "Localização do contato"
        },
        "triggers": {
            "contactCreated": "Contato criado",
            "surveyResponded": "Pesquisa respondida",
            "surveySent": "Pesquisa enviada",
            "conversationResolved": "Conversa resolvida",
            "reviewLeft": "Avaliação recebida",
            "integrationEvent": "Evento de integração",
            "customEvent": "Evento personalizado",
            "couponRedeemed": "Cupom resgatado",
            "formSubmitted": "Formulário enviado",
            "integrationCoverManager": "Reserva do CoverManager",
            "integrationVtex": "Pedido da VTEX",
            "paymentCompleted": "Pagamento concluído",
            "bookingStarted": "Reserva iniciada",
            "bookingEnded": "Reserva encerrada",
            "addedToSegment": "Adicionado a um segmento"
        },
        "units": {
            "minutes": "minutos",
            "hours": "horas",
            "days": "dias"
        },
        "issues": {
            "triggerEvents": "Escolha pelo menos um evento de gatilho",
            "channelRequired": "Escolha um canal",
            "channelUnavailable": "O canal selecionado está desconectado ou indisponível",
            "messageRequired": "Adicione uma mensagem",
            "emailTemplateRequired": "Escolha um modelo de email",
            "whatsAppTemplateRequired": "Escolha um modelo de WhatsApp",
            "surveyRequired": "Escolha uma pesquisa",
            "couponRequired": "Escolha um cupom",
            "waitInvalid": "Defina uma duração de espera",
            "conditionIncomplete": "Complete ou remova os filtros incompletos",
            "segmentMissing": "Um filtro usa um segmento que não existe mais",
            "noAction": "Adicione uma etapa de mensagem ou pesquisa à qual o gatilho leve",
            "triggerDate": "Escolha a data em que esta automação começa",
            "eventFieldOnDate": "Remova os filtros de evento: uma automação que começa em uma data não tem evento para filtrar",
            "triggerSegmentMissing": "O gatilho usa um segmento que não existe mais"
        }
    },
    "CampaignsPage": {
        "title": "Gere suas campanhas",
        "subtitle": "Informe seus clientes sobre novidades ou promos importantes com campanhas de outbound",
        "audience": "Segmento",
        "audienceHint": "Deixe vazio para alcançar todos os contactos.",
        "name": "Título",
        "createTitle": "Criar campanha",
        "editTitle": "Editar campanha",
        "viewTitle": "Detalhes da campanha",
        "contactsNumber": "Contactos seleccionados: {{count}}",
        "triggerEvent": "Eventos de desencadeamento",
        "triggerExplanation": "Escolha os eventos que darão início à sua campanha de envio de mensagens. Nos casos em que se realizem múltiplos eventos, o atraso será contado a partir do último evento.",
        "surveySent": "Pesquisa enviada",
        "status0": "Agendada",
        "status1": "Contínua",
        "status2": "Concluído",
        "status3": "Cancelado",
        "status5": "Pausada",
        "warningMessage": "Para reduzir o risco de ser bloqueado pelo WhatsApp, recomendamos manter o tamanho da sua campanha de marketing abaixo de 50 contactos.",
        "addCoverPhoto": "Adicionar foto da capa",
        "coverPhotoFormat": "Formato: JPG ou PNG. Largura mínima: 600 px",
        "imageFormat": "Formato: JPG ou PNG.",
        "addCTAButton": "Adicionar botão de CTA",
        "buttonTitle": "Título do botão",
        "addImage": "Adicionar imagem"
    },
    "common": {
        "unsavedChangesTitle": "Descartar as alterações não guardadas?",
        "unsavedChangesDescription": "Tem alterações não guardadas que serão perdidas se fechar esta janela.",
        "enabled": "Ativado",
        "unknown": "Utilizador desconhecido",
        "noOptions": "Sem opções",
        "noData": "Sem data",
        "noNotifications": "Não há novas notificações",
        "timeframe": "Intervalo de tempo",
        "allTime": "Desde Sempre",
        "today": "Hoje",
        "previous": "Anterior",
        "next": "Próximo",
        "last7Days": "Últimos 7 dias",
        "lastWeek": "Semana passada",
        "last30Days": "Últimos 30 dias",
        "last90Days": "Últimos 90 dias",
        "thisMonth": "Este mês",
        "lastMonth": "Mês passado",
        "thisYear": "Este ano",
        "exportError": "Impossível exportar dados como CSV",
        "zapierIntegration": "Integração Zapier",
        "clipboardCopied": "Copiado para o clipboard",
        "clipboardFailed": "Clipboard não compatível",
        "image": "Imagem",
        "imageUploadFormat": "Formatos de arquivo: JPG, PNG. Tamanho máximo: {{size}}",
        "images": "Imagens",
        "users": "Usuários",
        "location": "Localização",
        "locations": "Localizações",
        "allLocations": "Todas as localizações",
        "channel": "Canal",
        "survey": "Pesquisa",
        "surveys": "Pesquisas",
        "reviewSites": "Sites de Avaliações",
        "rating": "Pontuação",
        "status": "Status",
        "update": "Atualização",
        "keywords": "Palavras-chave",
        "replyTemplates": "Modelos com link",
        "all": "Todos",
        "url": "URL",
        "or": "ou",
        "name": "Nome",
        "firstName": "Primeiro Nome",
        "lastName": "Último Nome",
        "lastNameOpt": "Último Nome (opcional)",
        "fullName": "Nome Completo",
        "phoneNumber": "Nº de telefone",
        "email": "Email",
        "emailAddress": "Endereço de email",
        "login": "Login",
        "password": "Senha",
        "outOf": "{{total}} de {{max}}",
        "saving": "Salvando...",
        "edit": "Editar",
        "delete": "Eliminar",
        "view": "Ver",
        "duplicate": "Duplicar",
        "deleteTitle": "Confirmar eliminação",
        "deleteDescription": "Tem a certeza de que deseja eliminar isto? Esta ação não pode ser desfeita.",
        "delay": "Atraso",
        "refresh": "Refrescar",
        "contactCreated": "Contacto criado",
        "liveChat": "Live-chat",
        "left": "Esquerda",
        "right": "Direita",
        "file": "Arquivo",
        "audio": "Áudio",
        "video": "Vídeo",
        "monday": "Segunda-feira",
        "tuesday": "Terça-feira",
        "wednesday": "Quarta-feira",
        "thursday": "Quinta-feira",
        "friday": "Sexta-feira",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "open": "Aberto",
        "closed": "Fechado",
        "24hours": "24 horas",
        "story": "Story",
        "user": "Usuário",
        "new_other": "Novas",
        "new_one": "Novo",
        "unassigned": "Não atribuídas",
        "title": "Título",
        "scheduledTime": "Hora Agendada",
        "scheduled": "Agendada",
        "published": "Publicado",
        "unpublished": "Não publicado",
        "publishing": "Publicando",
        "cancelled": "Cancelado",
        "deleted": "Eliminado",
        "description": "Descrição",
        "completed": "Concluída",
        "cancel": "Cancelar",
        "subscriptionExpiredMsg": "Existe um problema com o seu plano. Por favor verifique seus dados de faturação ou entre em contacto com equipa de suporte.",
        "upgradeToAdd": "Faça Upgrade para incluir mais",
        "planCancelledUntilPeriodEnd": "A sua assinatura foi cancelada e permanece ativa até ao fim do período pago. Contacte o suporte para a reativar.",
        "upgradeAskAdmin": "Peça ao administrador da conta para atualizar o plano.",
        "upgradeToUnlock": "Faça Upgrade para ativar funcionalidade",
        "sms": "SMS",
        "whatsApp": "WhatsApp",
        "liveChatLowercase": "live-chat",
        "facebookMessenger": "Facebook Messenger",
        "instagram": "Instagram",
        "templates": "Modelos",
        "industry": "Indústria",
        "impressions": "Impressões",
        "reach": "Alcance",
        "engagement": "Engajamentos",
        "learnMore": "Saiba mais",
        "number": "Número",
        "text": "Texto",
        "date": "Data",
        "required": "Obrigatório",
        "type": "Escreva",
        "templateName": "Nome do Modelo",
        "author": "Autor",
        "yes": "Sim",
        "no": "Não",
        "labels": "Segmento",
        "locationLabels": "Etiquetas de localização",
        "logo": "Logótipo",
        "low": "Baixo",
        "medium": "Médio",
        "high": "Alto",
        "critical": "Crítico",
        "average": "Médio",
        "good": "Bom",
        "excellent": "Excelente",
        "conversations": "Conversas",
        "platform": "Plataforma",
        "actionRequired": "Requer Açāo",
        "conflict": "Conflito",
        "conflicts": "Conflitos",
        "conflict_one": "Conflito",
        "conflict_other": "Conflitos",
        "notFound": "Não encontrado",
        "notVerified": "Não verificado",
        "disconnected": "Desconectado",
        "notPublished": "Não publicado",
        "inProgress": "Em progresso",
        "synced": "Sincronizado",
        "syncedWithConflicts": "Sincronizado com conflitos",
        "na": "N/A",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "none": "Nenhum",
        "reported": "Denunciado",
        "report": "Denunciar",
        "format": "Formato",
        "photo": "Fotografia",
        "customer": "Cliente",
        "business": "Negócio",
        "category_other": "Categorias",
        "category_one": "Categoria",
        "action": "Ação",
        "day": "Dia",
        "week": "Semana",
        "month": "Mês",
        "year": "Ano",
        "draft": "Rascunho",
        "top": "Top",
        "bottom": "Últimas",
        "notifications": "Notificações",
        "complaint_other": "Reclamações",
        "complaint_one": "Reclamação",
        "review_other": "Avaliações",
        "review_one": "Revisão",
        "location_other": "Localizações",
        "location_one": "Localização",
        "profile_other": "Perfis",
        "profile_one": "Perfil",
        "message_other": "Mensagens",
        "message_one": "Mensagem",
        "subject": "Assunto",
        "cc": "CC",
        "bcc": "CCO",
        "link": "Link",
        "microsite": "Microsite",
        "color_one": "Cor",
        "color_other": "Cores",
        "archived": "Arquivado",
        "assignedTo": "Atribuído a",
        "question": "Pergunta",
        "answer": "Cópia",
        "copy": "Copy",
        "brands": "Marcas",
        "brand": "Marca",
        "failed": "Falhado",
        "actions": "Acções",
        "questions": "Perguntas",
        "language": "Idioma",
        "localization": "Localização",
        "disabled": "Desativado",
        "active": "Ativo",
        "day(s)": "dia(s)",
        "hour(s)": "hora(s)",
        "minute(s)": "minuto(s)",
        "appearance": "Aparência",
        "settings": "Configurações",
        "style": "Estilo",
        "font": "Fonte",
        "button_one": "Botão",
        "button_other": "Botões",
        "background": "Cor de fundo",
        "customEvent": "Evento externo",
        "unverified": "Não verificado",
        "verify": "Verificar",
        "noFileSelected": "Nenhum ficheiro selecionado",
        "chat": "Chat",
        "customInstructionsOpt": "Instruções personalizadas (opcional)",
        "activity": "Atividade",
        "information": "Informação",
        "newMessage": "Nova mensagem",
        "frequency": "Frequência",
        "currency": "Moeda",
        "coupon": "Oferta",
        "service": "Serviço",
        "paymentMethods": "Métodos de pagamento",
        "externalId": "ID externo",
        "public": "Público",
        "publicLink": "Link público",
        "private": "Privado",
        "sharedTemplate": "Modelo partilhado",
        "template": "Modelo",
        "teams": "Equipas",
        "createdOn": "Criado em",
        "platforms": "Plataformas",
        "emoji": "Emoji",
        "attachFile": "Anexar arquivo",
        "menu": "Menu",
        "form": "Formulário",
        "team": "Equipe",
        "recoveryForm": "Formulário de recuperação",
        "removedPersonName": "{{name}} (removido)",
        "notSpecified": "Não especificado",
        "timesInZone": "Os horários estão em {{timeZone}}."
    },
    "ContactsPage": {
        "createdOn": "Criado em",
        "deleteContactsDescription": "Tem a certeza que quer eliminar {{selectedContacts}} contactos? Esta ação é irreversível.",
        "facebookProfile": "Perfil de Facebook",
        "instagramProfile": "Perfil de Instagram",
        "createTitle": "Criar novo contacto",
        "createSubtitle": "Adicione informação básica dos contactos",
        "editTitle": "Editar contacto",
        "editContactsTitle": "Editar contactos",
        "editBulkContactsSubtitle": "Seleccione as propriedades a editar. As alterações serão aplicadas aos contactos seleccionados.",
        "editSubtitle": "Alterar informações básicas do contacto",
        "mergeContactsTitle": "Fusão de contactos",
        "mergeContactsSubtitle": "Fundir contactos para combinar dois perfis em um só, incluindo todos os atributos e actividade. Em caso de conflito, os atributos do contacto primário terão precedência.",
        "mergeContactPrimary": "Contacto primário (A manter)",
        "mergeContactSecondary": "Contacto para fundir (A eliminar)",
        "unsubscribe": "Desinscrever",
        "unsubscribed": "Desinscrito",
        "lastActiveOn": "Úlima atividade em",
        "importTitle": "Importar novos contactos",
        "importSubtitle": "Importar contactos de um ficheiro CSV.",
        "importConsent": "Confirmo que estes contactos aceitaram receber mensagens da minha empresa e que a lista não foi comprada, alugada nem obtida de terceiros.",
        "bulkFileLink": "Baixar amostra do CSV.",
        "csvFile": "ficheiro CSV",
        "importFile": "Importar",
        "id": "ID",
        "dataVerificationDescription": "Reveja os dados do ficheiro csv. Para que possam ser processados, não devem conter qualquer erro.\nSe encontrou um erro, feche este pop-up, edite e recarregue o ficheiro.",
        "validate": "Validar",
        "numberToImport": "Contactos para adicionar {{diff}}. Contactos para atualizar {{duplicates}}",
        "contactsToAdd": "Contactos a adicionar",
        "contactsToUpdate": "Contactos a atualizar",
        "noContacts": "Não há contactos para importar",
        "search": "Pesquise",
        "searchLabel": "Pesquise por nome, telefone ou e-mail",
        "activitySurveySent": "Pesquisa enviada: {{template}}",
        "activityFormSubmitted": "Enviou o formulário {{name}}",
        "activitySurveyReminder": "Lembrete de pesquisa enviado: {{template}}",
        "activitySurveyResponded": "Respondeu a {{template}} com {{rating}} estrelas",
        "activityMessageSent": "Mensagem enviada por {{channel}}",
        "activityConversationStarted": "Conversa iniciada",
        "activityConversationClosed": "Conversa resolvida por {{name}}",
        "activityConversationReopened": "Conversa reaberta por {{name}}",
        "activityReviewLeft": "Deixou uma avaliação no {{reviewType}}",
        "activityIntegrationEvent": "Evento do {{integration}}",
        "contacts": "contactos",
        "contactsSelected": "{{selectedContacts}} contactos selecionados",
        "mergeSuccess": "Os contatos foram fusão com sucesso",
        "mergeFail": "Não foi possível fusão os contatos",
        "activityPaymentCompleted": "Pagamento concluído",
        "paymentDetails": {
            "amount": "Valor",
            "location": "Localização",
            "paidAt": "Pago em",
            "method": "Forma de pagamento",
            "account": "Conta de pagamento",
            "purchase": "Compra",
            "firstPurchase": "Primeira",
            "purchaseNumber": "Nº {{count}}",
            "viewReceipt": "Ver recibo",
            "sources": {
                "CARD": "Cartão",
                "BANK_ACCOUNT": "Conta bancária",
                "WALLET": "Carteira digital",
                "BUY_NOW_PAY_LATER": "Compre agora, pague depois",
                "SQUARE_ACCOUNT": "Saldo do Square",
                "CASH": "Dinheiro",
                "EXTERNAL": "Outro"
            }
        },
        "sex": "Sexo",
        "sexFemale": "Feminino",
        "sexMale": "Masculino",
        "dateOfBirth": "Data de nascimento",
        "language": "Idioma",
        "dateOfBirthWithoutYear": "Salvo como {{date}}, sem ano",
        "leaveUnchanged": "Deixar sem alterar",
        "activityAddedToSegment": "Adicionado ao segmento {{name}}"
    },
    "ErrorsPages": {
        "titleSomethingWrong": "Impossível carregar esta página",
        "textSomethingWrong": "Desculpem o incómodo. Estamos cientes deste problema e já estamos a analisar a situação. Se o problema persistir, não hesite e envie um email para help@pluspoint.io para apoio imediato.",
        "notFoundPage": "Não encontramos a página que procura"
    },
    "FeedbackResponses": {
        "newReviews": "Novas avaliações estão disponíveis. <0>{{update}}</0>",
        "update": "UPDATE",
        "noDataMessage": "N/A",
        "onlyRating": "O cliente não deixou comentário, apenas uma avaliação.",
        "aiReviewTags": "O que mais gostou",
        "contactDetailsOnly": "O cliente deixou os dados de contacto sem mensagem.",
        "copyNumber": "Copiar nº de telefone",
        "callNumber": "Telefonar",
        "chatViber": "Alcançar via Viber",
        "chatWhatsApp": "Alcançar via WhatsApp",
        "copyEmail": "Copiar email",
        "chatEmail": "Alcançar via email",
        "ticketStatus": "Status do ticket",
        "completed": "Concluído",
        "viaCoverManager": "Via CoverManager",
        "hideAnonimous": "Ocultar respostas anónimas",
        "linkedReview": "Avaliação associada"
    },
    "FeedbackSurveys": {
        "created": "Pesquisas criadas:",
        "createdQrOnly": "Códigos QR criados:",
        "title": "Gerir suas pesquisas",
        "subtitle": "Organize pedidos de feedback valioso dos seus clientes, compreenda e melhore as suas necessidades para garantir lealdade e recomendações dos mesmos.",
        "titleQrOnly": "Recolha avaliações de forma mais inteligente",
        "subtitleQrOnly": "Faça upgrade para o Pluspoint Professional e tire mais partido da recolha de avaliações. Envie inquéritos por email, SMS ou WhatsApp, incentive clientes satisfeitos a deixar uma avaliação pública, recolha feedback privado e acompanhe a evolução do NPS.",
        "responses": "Respostas:",
        "views": "Visualizações:",
        "modalTitle": "Editar pedido — {{surveyName}}",
        "surveyName": "Nome do Pedido",
        "contactDetails": "Detalhes do contacto",
        "contactEmail": "Email de contacto",
        "contactPhone": "Telefone de contacto",
        "contactName": "Nome de contacto",
        "contactFormPlacement": "Mostrar o formulário de contacto em",
        "contactFormMainScreen": "Ecrã principal",
        "contactFormMainScreenDescription": "Todos os que avaliam veem o formulário de contacto.",
        "contactFormNegativeScreen": "Ecrã negativo",
        "contactFormNegativeScreenDescription": "Só vê o formulário de contacto quem avalia abaixo do limite.",
        "contactFormNoFields": "Ative pelo menos um campo abaixo para mostrar o formulário de contacto.",
        "addField": "Adicionar campo",
        "deleteField": "Eliminar campo",
        "reviewSites": "Sites de Avaliaçāo",
        "fillColor": "Preenchimento",
        "topText": "Texto superior",
        "bottomText": "Texto inferior",
        "messageTemplate": "Modelo de mensagem",
        "emailSubject": "Assunto do e-mail",
        "protectionLabel": "Proteção contra sobreopiniões",
        "protectionTooltip": "Ative esta opção para impedir que o sistema envie vários convites para o mesmo nº de telefone durante um período de tempo específico.",
        "day": "1 dia",
        "days3": "3 dias",
        "week": "1 semana",
        "weeks2": "2 semanas",
        "month": "1 mês",
        "months3": "3 meses",
        "months6": "6 meses",
        "year": "1 ano",
        "followUpLabel": "Enviar follow-ups automáticos",
        "followUpDescription": "Configure pedidos de follow-up que serão enviados automaticamente se não receber uma resposta dentro de um periodo.",
        "wait": "Espere",
        "days": "dias depois envie",
        "followUpMessage": "Mensagem de Follow-up",
        "main": "Principal",
        "positive": "Positivo",
        "negative": "Negativo",
        "neutral": "Neutro",
        "tabSettings": "Configurações",
        "tabSharing": "Partilha",
        "qrCode": "Código QR",
        "enableSendSurveys": "Ativar envio de pesquisas",
        "enableSendSurveysDescription": "Permitir que esta pesquisa seja enviada a clientes através de campanhas, caixa de entrada e a funcionalidade Enviar pesquisa",
        "customizeQrCodeDesign": "Personalize o design do QR",
        "surveyQuestions": "Perguntas de inquérito",
        "addQuestion": "Adicionar pergunta",
        "questionsDescription": "Cria perguntas de inquérito personalizadas para compreender melhor as necessidades dos clientes.",
        "brandSettings": "Configurações da marca",
        "changeAppearance": "Você pode alterar a aparência nas <0>{{brandSettings}}</0>.",
        "addFirstQuestion": "Adicione uma pergunta para ativar a pré-visualização.",
        "page": "Página",
        "addPage": "Adicionar página",
        "emptyPageHint": "Arraste uma pergunta para cá",
        "nps": "Ativar pontuação de satisfação (NPS)",
        "customerSatisfaction": "Pedir uma classificação",
        "ratingScale": "Escala de classificação:",
        "fiveStar": "1–5 Estrelas",
        "npsScale": "0–10 Pontuação",
        "enableNpsToAddQuestions": "Ative a pontuação de satisfação nas Configurações para adicionar perguntas",
        "sendableSurveyRequired": "Requer uma pesquisa com o envio de pesquisas ativado",
        "satisfactionSurveyThreshold": "Interceptar comentários negativos se a classificação for menor que:",
        "labelsTitle": "Segmentos",
        "labelsSubtitle": "Atribuir segmentos aos contactos recolhidos através desta pesquisa",
        "typeRating": "Avaliação",
        "typeSingleChoice": "Escolha única",
        "typeYesNo": "Sim / Não",
        "typeMultiSelect": "Seleção múltipla",
        "typeShortAnswer": "Resposta curta",
        "typeParagraph": "Texto longo",
        "typeDate": "Data",
        "questionType": "Question type",
        "addOption": "Add option",
        "optionLabel": "Option",
        "gateQuestion": "Pergunta de filtro",
        "gateQuestionTooltip": "Pular as perguntas restantes se 'Não' for selecionado.",
        "gateRequiresTooltip": "Indisponível quando a pergunta de filtro está ativada.",
        "showConditionally": "Mostrar com base na resposta anterior",
        "showConditionallyTooltip": "Mostrar esta pergunta apenas quando respostas específicas forem dadas a perguntas anteriores. Várias regras usam lógica E (todas devem corresponder).",
        "conditionShowIf": "Mostrar esta pergunta apenas se",
        "conditionAndIf": "E se",
        "conditionMatches": "corresponde a",
        "addCondition": "Adicionar condição",
        "star": "estrela",
        "stars": "estrelas",
        "yes": "Sim",
        "no": "Não",
        "other": "Outro",
        "includeOtherOption": "Incluir opção \"Outro\"",
        "customWording": "Texto personalizado da pesquisa",
        "aiReviewSuggestions": "Sugestões de avaliações com IA",
        "aiReviewSuggestionsTooltip": "Os visitantes que o avaliam bem escolhem o que mais gostaram e a Pulse AI redige uma avaliação curta que podem copiar para o Google e para os outros sites de avaliações.",
        "aiReviewTags": "Etiquetas que os visitantes podem escolher",
        "addReviewTag": "Adicionar etiqueta",
        "reviewTagNamePlaceholder": "Nome da etiqueta",
        "createReviewTag": "Criar",
        "editReviewTagTitle": "Editar etiqueta",
        "deleteReviewTagTitle": "Eliminar etiqueta?",
        "deleteReviewTagDescription": "\"{{name}}\" será eliminada para toda a conta e removida de todas as pesquisas.",
        "useCustomWording": "Usar texto personalizado",
        "customWordingTooltip": "Adicione texto personalizado para cada idioma que a pesquisa deve oferecer. Um idioma só aparece na pesquisa se tiver texto.",
        "positiveMessage": "Mensagem positiva",
        "negativeMessage": "Mensagem negativa",
        "localizationSingleLanguage": "Adicione idiomas em Texto personalizado da pesquisa, nas Configurações, para traduzir as perguntas"
    },
    "filters": {
        "labels": "Etiquetas de localização",
        "companies": "Localizações",
        "locations": "Localizações",
        "surveys": "Pesquisas",
        "integrations": "Sites de Avaliações",
        "channels": "Canais",
        "platforms": "Plataformas",
        "timeframe": "Intervalo de tempo",
        "rating": "Pontuação",
        "statuses": "Status",
        "views": "Status",
        "hideAnonimous": "Ativar para ver apenas respostas com informações de contacto",
        "keywords": "Palavras-chave",
        "withoutReplies": "Avaliações sem respostas",
        "onlyFeatured": "Avaliações em destaque",
        "formats": "Formato",
        "categories": "Categorias",
        "authors": "Autor",
        "contactLabels": "Segmento",
        "grouping": "Agrupar por",
        "brands": "Marcas",
        "showUnreadOnly": "Mostrar apenas conversas não lidas",
        "sorting": "Ordenar por",
        "teams": "Equipes",
        "sexes": "Sexo",
        "languages": "Idioma",
        "birthMonths": "Mês de aniversário",
        "ageBracket": "Idade",
        "anyAge": "Qualquer idade"
    },
    "ForgotPasswordPage": {
        "title": "Esqueceu a senha?",
        "description": "Introduza o seu endereço de email. Enviaremos um link para redifiner a sua senha.",
        "backToLogin": "Voltar à página de login",
        "confirmationSuccess": "Se existir uma conta com a Pluspoint, receberá um email com mais instruções."
    },
    "Header": {
        "home": "Início",
        "reviewsOverview": "Visão Geral",
        "templates": "Modelos",
        "responses": "Todas as respostas",
        "surveys": "Pesquisas",
        "reviewsManage": "Todas as avaliações",
        "reviewsTemplates": "Modelos de respostas",
        "reviewsAutoreplies": "Respostas automáticas",
        "reviewsAutomation": "Automatização",
        "messagingInbox": "Caixa de entrada",
        "messagingTemplates": "Modelos de mensagens",
        "microsites": "Micro-sites",
        "menus": "Menus",
        "forms": "Formulários",
        "analytics": "Análises",
        "analyticsConversion": "Análise de Conversões",
        "analyticsReviews": "Análise de Avaliações",
        "analyticsSurveys": "Análises de Respostas",
        "analyticsConversations": "Conversas",
        "analyticsPresence": "Presença",
        "settings": "Configurações",
        "onboarding": "Introdução",
        "reviewsWidgets": "Widgets do site",
        "socialPosts": "Publicações",
        "keywords": "Palavras-chave e Sentimentos",
        "ordersIfood": "Pedidos",
        "campaigns": "Campanhas",
        "campaignsAutomated": "Automatizadas",
        "campaignsOneTime": "Únicas",
        "contacts": "Contactos",
        "presence": "Presença",
        "presenceProfiles": "Perfis",
        "presenceMedia": "Fotos e vídeos",
        "locationsManage": "Gerir localizações",
        "locationsProfiles": "Perfis",
        "locationsMedia": "Fotos e Vídeos",
        "visibilityScanner": "Scanner de visibilidade",
        "locationsAnalytics": "Análise de Localizações",
        "login": "Iniciar Sessão",
        "signup": "Registe-se",
        "resetPassword": "Repor senha",
        "forgotPassword": "Esqueceu a senha?",
        "verifyEmail": "",
        "acceptInvitation": "Aceitar convite",
        "error": "Error",
        "pulseAI": "Pulse AI",
        "coupons": "Ofertas",
        "campaignsLibrary": "Biblioteca"
    },
    "HomePage": {
        "leaderboard": "Classificações",
        "5LocationsBy": "5 localizações por",
        "rating": "pontuação",
        "reviews": "avaliações",
        "nps": "NPS",
        "inbox": "Caixa de entrada",
        "surveys": "Respostas a pesquisas",
        "recommendations": "Recomendações",
        "presence": "Presença online",
        "locations": "Presença online",
        "synchronization": "Sincronização de perfis",
        "optimizationScoreSubtitle": "Identifique localizações com perfis incompletos para melhorar a visibilidade e a confiança dos clientes",
        "locationsSubtitle": "Descubra como os clientes encontram as suas localizações e interagem com elas online",
        "synchronizationSubtitle": "Mantenha as informações do seu negócio consistentes em todos os locais onde os clientes o procuram",
        "leaderboardSubtitle": "Identifique as localizações líderes e as que precisam de apoio para melhorar o desempenho",
        "inboxSubtitle": "Responda às mensagens dos clientes de todos os canais num só lugar",
        "reviewsSubtitle": "Mantenha-se a par das novas avaliações e melhore a sua reputação respondendo rapidamente",
        "surveysSubtitle": "Recolha feedback para detetar reclamações cedo e melhorar a experiência dos clientes",
        "socialSubtitle": "Envolva o seu público com publicações consistentes e acompanhe o que chega aos clientes",
        "surveysTitle": "Gerir feedback e reclamações dos clientes",
        "unreplied": "Não respondidas",
        "vsPrevMonth": "<0>{{percentage}}</0> vs mês prévio",
        "getStarted": "Comece com {{steps}} passos fáceis",
        "continueOnboarding": "Continuar a integração",
        "googleTitle": "Integrar com o Google My Business (5 min)",
        "googleDescription": "Gerir e responder a avaliações de clientes e atualizar informações públicas.",
        "brandTitle": "Criar uma marca (5 min)",
        "brandDescription": "Agrupe localizações para uma gestão mais simples e personalize a aparência na plataforma.",
        "channelsTitle": "Configurar canais de comunicação (20 min)",
        "channelsDescription": "Consolide chat ao vivo e plataformas de mensagens para comunicação simplificada com os clientes.",
        "templatesTitle": "Criar modelos de pesquisa (10 min)",
        "templatesDescription": "Ative pesquisas para capturar feedback essencial dos clientes e aumentar avaliações online.",
        "qrCodesTitle": "Crie códigos QR para avaliações (5 min)",
        "qrCodesDescription": "Gere códigos QR para colocar em recibos, mesas ou montras e os clientes deixarem uma avaliação no momento.",
        "autoRepliesTitle": "Configurar respostas-auto de avaliações (10 min)",
        "autoRepliesDescription": "Automatize respostas personalizadas às avaliações para maior envolvimento e cuidado com o cliente.",
        "usersTitle": "Convidar outros usuários (5 min)",
        "usersDescription": "Expanda as capacidades da sua equipa, convidando colegas para a plataforma.",
        "recommendation1Title": "Responder às avaliações",
        "recommendation1Subtitle": "Há avaliações que não foram respondidas.",
        "recommendation1Text": "Ao responder às avaliações, ajuda a melhorar a classificação por estrelas das suas localizações.",
        "recommendation1UrlText": "Ir para as avaliações",
        "recommendation2Title": "Atualizar as fotos dos seus perfis",
        "recommendation2Subtitle": "As fotos não foram atualizadas há mais de um mês.",
        "recommendation2Text": "Fotos atualizadas ajudarão a melhorar a sua presença online.",
        "recommendation2UrlText": "Ir para as fotos",
        "recommendation3Title": "Adicionar descrições aos seus locais",
        "recommendation3Subtitle": "Alguns dos seus perfis não têm descrições.",
        "recommendation3Text": "Uma descrição completa melhora o ranking do seu perfil nos resultados de pesquisa.",
        "recommendation3UrlText": "Ir para as configurações",
        "recommendationLocationsUrlText": "Ir para localizações",
        "recommendation4Title": "Resolva conflitos de perfis e publique listagens em falta",
        "recommendation4Subtitle": "Alguns perfis precisam da sua atenção.",
        "recommendation4Text": "Resolva os conflitos para manter os seus dados consistentes e publique perfis que ainda não estão ativos para que os clientes possam encontrá-lo.",
        "recommendation4UrlText": "Ir para os perfis",
        "recommendation5Title": "Responder às mensagens não lidas",
        "recommendation5Subtitle": "Tem mensagens não lidas que precisam da sua atenção.",
        "recommendation5Text": "Responder prontamente aumenta a satisfação dos seus clientes.",
        "recommendation5UrlText": "Ir para a caixa de entrada",
        "recommendation6Title": "Publicar uma publicação social",
        "recommendation6Subtitle": "Alguns perfis não têm novas publicações há algum tempo.",
        "recommendation6Text": "Publicações sociais regulares mantêm o seu público envolvido e melhoram a sua presença online.",
        "recommendation6UrlText": "Ir para as publicações",
        "recommendation7Title": "Rever reclamações recentes",
        "recommendation7Subtitle": "Existem reclamações dos seus clientes.",
        "recommendation7Text": "Responder prontamente às reclamações ajuda a melhorar a satisfação do cliente e a confiança na sua empresa.",
        "recommendation7UrlText": "Ir para reclamações",
        "recommendation8Title": "Integração desconectada",
        "recommendation8Text": "A integração entre uma plataforma de avaliações e o Pluspoint está atualmente desconectada. Por favor, reconecte para continuar a utilizar a integração corretamente.",
        "recommendation9Title": "Canal desconectado",
        "recommendation9Text": "Um canal de comunicação está atualmente desconectado. Reconecte para garantir que todas as mensagens e respostas dos clientes sejam entregues sem interrupções.",
        "recommendation10Title": "Campanha automatizada falhada",
        "recommendation10Text": "Uma campanha automatizada não foi executada com sucesso. Verifique as configurações da automação para identificar e resolver o problema.",
        "recommendation10UrlText": "Ir para campanhas",
        "recommendation11Title": "Campanha única falhada",
        "recommendation11Text": "Sua campanha única não foi enviada com sucesso. Revise os detalhes da campanha e tente novamente.",
        "showAllRecommendation": "Mostrar todas as recomendações",
        "showLessRecommendation": "Não mostrar recomendações ocultas"
    },
    "Listings": {
        "modalTitleGoogle": "Gerir o perfil do Google Meu Negócio",
        "modalTitleFacebook": "Gerir o perfil do Facebook",
        "about": "Geral",
        "name": "Nome",
        "openingDate": "Data de abertura",
        "contact": "Contacto",
        "primaryPhone": "Telefone principal",
        "additionalPhone": "Telefone adicional",
        "website": "Website",
        "businessHours": "Horário",
        "categories": "Categorias",
        "primaryCategory": "Categoria principal",
        "secondaryCategory_one": "Categoria secundária",
        "secondaryCategory_other": "Categorias secundárias",
        "enableProfileSync": "Ativar a sincronização de perfil",
        "disableProfileSync": "Desativar a sincronização de perfil",
        "connectMainPage": "Conectar página principal",
        "storeLocation": "Loja",
        "connectStoreLocation": "Conectar loja",
        "ignoredFields": "Campos ignorados",
        "ignoredFieldsHint": "A Pluspoint não envia esses campos para esta ficha nem os reporta como conflitos.",
        "currentlyDifferent": "atualmente diferente"
    },
    "LoginPage": {
        "title": "Bem-vindo de volta!",
        "description": "Acesse suas localizações, avaliações e mensagens em um só painel.",
        "forgotPassword": "Esqueceu a senha?",
        "notRegistered": "Não tem conta? <0>{{link}}</0>",
        "signUp": "Registe-se",
        "terms": "Termos de Uso,",
        "privacy": "Políticas de Privacidade",
        "dpa": "Acordo de Tratamento de Dados",
        "termsConditions": "Ao utilizar a Pluspoint, confirma que aceita <0>{{terms}}</0> <1>{{privacy}}</1> e <2>{{dpa}}</2>",
        "signinWithGoogle": "Entrar com o Google",
        "googleUserNotFound": "Nenhuma conta encontrada com este email. <0>{{link}}</0> para começar."
    },
    "LogoutModal": {
        "logOutConfirmation": "Sair da Pluspoint?",
        "logOutConfirmationDescription": "Voltará ao ecrã de início de sessão"
    },
    "DnsRecordCard": {
        "type": "Tipo:",
        "name": "Nome:",
        "value": "Valor:",
        "status": "Status:",
        "notChecked": "Sem verificação"
    },
    "MicrositesPage": {
        "createCustomLending": "Crie uma página de destino personalizada para cada localização.",
        "createCustomLendingSubTitle": "Crie páginas de destino mobile-first para cada localização para fornecer informações necessárias ao cliente, como por exemplo, contactos, lista de serviços, efetuar reservas diretas e links das suas redes sociais.",
        "created": "Micro-sites criados:",
        "content": "Conteúdo",
        "modalTitle": "Editar micro-site",
        "codeName": "Nome do Micro-site",
        "displaySocialMediaLinks": "Mostrar links para as redes sociais",
        "showReviews": "Mostrar avaliações e pontuações",
        "links": "Links, Pesquisas e Formulários",
        "linksSubtitle": "Criar um micro-site ao adicionar links externos, pesquisas e formulários",
        "visits": "Visitas:",
        "additionalSettings": "Configurações adicionais",
        "showLiveChat": "Mostrar live-chat",
        "surveyNotAvailableForBrand": "Pesquisas não são suportadas para marcas. Remova este link.",
        "micrositeNotAvailableForLocation": "Links de microsites não são suportados para localizações. Remova este link.",
        "surveyNotAvailableForLocation": "Pesquisa não disponível para esta localização. Selecione outra ou remova.",
        "micrositeNotAvailableForBrand": "Microsite não disponível para esta marca. Selecione outro ou remova.",
        "customDomain": "Domínio personalizado",
        "customDomainCaption": "Publique este microsite a partir do seu próprio domínio em vez de plsp.io",
        "useCustomDomain": "Usar domínio personalizado",
        "domain": "Domínio",
        "statusPending": "Pendente",
        "statusActive": "Ativo",
        "statusFailed": "Falhado",
        "noDomainsInAccount": "Não há domínios na sua conta",
        "noDomainsAvailable": "Não há domínios disponíveis. Contacte o seu administrador para adicionar um domínio personalizado.",
        "addNewDomain": "Adicionar novo domínio",
        "addCustomDomain": "Adicionar domínio personalizado",
        "enterDomainDescription": "Introduza o domínio que pretende utilizar para os seus microsites.",
        "domainOwnershipNote": "O domínio deve ser de sua propriedade. Precisará de adicionar um registo CNAME para verificar a propriedade. Para usar um domínio raiz, o seu fornecedor DNS deve suportar CNAME flattening.",
        "dnsInstructions": "Adicione este registo CNAME no seu fornecedor de domínio para apontar o seu domínio para o Pluspoint.",
        "domainRequired": "O domínio é obrigatório",
        "domainLengthError": "O domínio deve ter entre 4 e 253 caracteres",
        "domainInvalidFormat": "Introduza um domínio válido",
        "domainPluspoint": "Os domínios Pluspoint não podem ser usados como domínios personalizados",
        "addDomain": "Adicionar domínio",
        "editDomain": "Editar domínio — {{hostname}}",
        "status": "Estado:",
        "lastChecked": "Última verificação:",
        "micrositesUsingDomain": "Microsites a usar este domínio:",
        "checkStatus": "Verificar estado",
        "checking": "A verificar...",
        "checkStatusError": "Não foi possível verificar o estado do domínio. Tente novamente.",
        "deleteCustomDomain": "Eliminar domínio personalizado",
        "deleteConfirm": "Eliminar permanentemente {{hostname}}?",
        "deleteImpact": "Este domínio é utilizado por {{count}} microsite(s). Perderão o URL personalizado e só serão acessíveis através de plsp.io.",
        "deleteWarning": "Esta ação não pode ser desfeita. Precisará de adicionar e verificar novamente o domínio para o utilizar.",
        "domainDeleted": "Domínio personalizado eliminado",
        "deleteError": "Erro ao eliminar o domínio",
        "addDomainError": "Não foi possível registar o domínio. Tente novamente mais tarde.",
        "loadError": "Erro ao carregar os domínios personalizados",
        "menuNotAvailable": "Menu não disponível para este microsite. Selecione outro ou remova.",
        "formNotAvailable": "Formulário não disponível para este microsite. Selecione outro ou remova.",
        "menuNotAvailableForBrand": "Os menus não estão disponíveis em microsites de marca. Remova este link."
    },
    "ContactFieldsSettings": {
        "identifyingFieldRequired": "Um telefone ou um email deve continuar obrigatório"
    },
    "FormsPage": {
        "title": "Transforme visitas em relações duradouras",
        "subtitle": "Colete os dados dos seus clientes com formulários personalizáveis e use-os para criar suas listas de contatos, segmentar públicos e criar campanhas direcionadas.",
        "created": "Formulários criados:",
        "createForm": "Criar formulário",
        "modalTitle": "Formulário",
        "internalName": "Nome do formulário",
        "downloadSubmissions": "Baixar envios",
        "confirmationMessage": "Mensagem de confirmação",
        "defaultConfirmationMessage": "Obrigado por enviar o formulário",
        "views": "Visualizações:",
        "submissions": "Envios:",
        "contactFields": "Campos de contato",
        "contactFieldsSubtitle": "Escolha quais dados o formulário pede e quais são obrigatórios.",
        "deleteForm": "Excluir formulário"
    },
    "LocalizeItemModal": {
        "defaultLanguages": "Idioma predefinido",
        "additionalLanguages": "Idiomas adicionais"
    },
    "multiSelectLabels": {
        "done": "Concluído",
        "manage": "Gerir",
        "createNewLabel": "Criar novo segmento",
        "searchLabel": "Pesquisar ou criar novos segmentos"
    },
    "GoogleLocationsList": {
        "searchLabel": "Pesquisar",
        "hideConnected": "Ocultar as já conectadas",
        "hideUnverified": "Ocultar as não verificadas",
        "noMatches": "Nenhuma localização encontrada",
        "allConnected": "Todas as localizações já estão conectadas"
    },
    "OnboardingPage": {
        "titleFirst": "Bem-vindo à Pluspoint!",
        "subtitleFirst": "Vamos começar pelos seus dados básicos para configurarmos o seu workspace e adaptarmos a experiência às suas necessidades.",
        "titleSecond": "Ligue a sua conta Google",
        "subtitleSecond": "Associe o seu Google Business Profile para importar e gerir as suas localizações no Pluspoint. Certifique-se de que concede todas as permissões — só assim o Pluspoint pode sincronizar corretamente as localizações e gerir as avaliações por si.",
        "buttonConnectWithGoogle": "Conectar com o Google",
        "titleGoogleEmpty": "Sem resultados",
        "subtitleGoogleEmpty": "Não encontrámos nenhuma localização do Google Business associada a esta conta. Tente ligar outra conta Google ou confirme que todas as permissões foram ativadas durante a autorização.",
        "titleManual": "Adicione sua primeira localização.",
        "subtitleManual": "Insira o nome e a morada da sua localização. Depois pode adicionar mais localizações no menu de Listagens.",
        "titleGoogle": "Selecionar localizações para importar",
        "subtitleGoogle": "Escolha as localizações que quer importar para o Pluspoint. Pode importar uma ou várias localizações para começar a gerir avaliações, mensagens e perfis.",
        "canTryNextFull": "Não é a lista que procura? Pode tentar o seguinte:",
        "canTryNext": "Não é esta a lista que procura? Ligue outra conta Google.",
        "success": "Sucesso!"
    },
    "AcceptInvitationPage": {
        "title": "Configure sua conta",
        "description": "Você foi convidado a se juntar ao Pluspoint",
        "continueWithGoogle": "Continuar com o Google",
        "emailMismatch": "O e-mail da conta Google não corresponde ao e-mail do convite. Tente novamente com a conta correta.",
        "tokenExpired": "Este link de convite expirou. Entre em contato com seu administrador para um novo convite.",
        "alreadyAccepted": "Este convite já foi aceito. Faça login."
    },
    "ResetPasswordPage": {
        "titleReset": "Repor senha",
        "titleChanged": "Senha foi alterada",
        "descriptionReset": "Insira uma nova senha para a sua conta",
        "descriptionChanged": "Sua senha foi alterada com sucesso. Pode iniciar a sessão usando a senha que criou agora.",
        "confirmPassword": "Confirme a senha"
    },
    "ReviewsAutoreplies": {
        "instantlyRespond": "Responda de imediato às avaliações dos clientes",
        "googleConnected": "Instale respostas automáticas às avaliações do Google que serão acionadas quando determinadas condições são cumpridas.",
        "subtitleWithManualSupport": "Configure respostas com IA para as avaliações dos clientes. Personalize as sugestões em todas as plataformas e publique respostas automaticamente em avaliações do Google.",
        "created": "Respostas-Auto criadas:",
        "ruleName": "Nome",
        "containsMessage": "Nāo contém mensagem",
        "addRule": "Adicionar nova resposta-auto",
        "editRule": "Editar resposta automática",
        "viewRule": "Detalhes da resposta automática",
        "reviewType": "Tipo de avaliação",
        "withComment": "Com comentário",
        "withoutComment": "Sem comentário",
        "applyToPastReviews": "Aplicar a avaliações anteriores não respondidas",
        "enableAI": "Ativar respostas automáticas Pulse AI para novas avaliações",
        "enableAIDescription": "As respostas-auto da Pulse AI podem gerar respostas imprecisas ou inadequadas. Ao ativar esta opção, reconhece os riscos e aceita a responsabilidade de monitorizar e gerir as respostas.",
        "pulseAiDescription": "Adicione instruções personalizadas para moldar as respostas geradas por IA. Aplicam-se quando clica em Escrever resposta em qualquer avaliação, e às respostas-auto de avaliações do Google quando o interruptor abaixo está ativado.",
        "createNewTemplate": "Criar nova modelo",
        "sendRecoveryForm": "Enviar formulário de recuperação",
        "sendRecoveryFormDescription": "As respostas às avaliações de 1 a 4 estrelas terminam com uma ligação para um formulário privado onde o cliente pode deixar os seus contactos."
    },
    "ReviewsEmptyFeed": {
        "reviewsNotSelectedTitle": "Não selecionou nenhuma fonte",
        "integrationDescription": "Site de avaliação",
        "surveyDescription": "Pesquisa",
        "reviewsAreLoadingTitle": "Suas avaliações serão transferidas para a Pluspoint",
        "reviewsAreLoadingDescription": "Geralmente demora alguns minutos",
        "reviewsNotSelectedDescription": "Selecione uma localização válida, {{feedback}} e classificação no filtro",
        "reviewsNotExistTitle": "Ainda não recebeu nenhumas avaliações",
        "reviewsNotExistDescriptionEx": "<0>{{sendSurveys}}</0> ou <1>{{setupSurvey}}</1> para receber mais avaliações",
        "sendSurveys": "Enviar pesquisas",
        "setupSurvey": "Configurar Pesquisa"
    },
    "ReviewsManage": {
        "newReviews": "Novas avaliações disponíveis. <0>{{update}}</0>",
        "update": "UPDATE",
        "withoutReplies": "Mostrar só avaliações sem respostas",
        "noTextMsg": "Nenhum texto fornecido",
        "onlyRating": "O cliente não deixou comentário, apenas uma avaliação.",
        "repliedOn": "Respondido em {{date}}",
        "replied": "Respondido",
        "repliedOnByUser": "{{name}} respondeu em {{date}}",
        "repliedByUser": "{{name}} respondeu",
        "viewOn": "Ver em {{integration}}",
        "editReply": "Editar Resposta",
        "unverifiedListingNotice": "Esta ficha não está verificada no Perfil da Empresa no Google, então o Google não aceita respostas.",
        "verifyListingAction": "Verificar a ficha",
        "replyingAsOwner": "Responder como proprietário da empresa",
        "publishReply": "Publicar Resposa",
        "yourReply": "Sua resposta",
        "unresolvedPlaceholders": "Sua resposta contém um marcador que não pode ser preenchido: {{placeholders}}. Remova-o antes de publicar.",
        "viaOn": "via {{integration}} a {{date}}",
        "locationsCount": "{{count}} locais",
        "assignContact": "Atribuir contacto",
        "markAsReplied": "Marcar como respondido",
        "replyingOnExternal": "Responder no site externo",
        "manuallyRepliedOn": "Respondido manualmente em {{date}}",
        "manuallyReplied": "Respondido manualmente",
        "manuallyRepliedOnByUser": "{{name}} respondeu manualmente em {{date}}",
        "manuallyRepliedByUser": "{{name}} respondeu manualmente",
        "translate": "Traduzir",
        "showOriginal": "Mostrar original",
        "translatedByGoogle": "Traduzido pelo Google",
        "markAsFeatured": "Marcar como destaque",
        "removeFromFeatured": "Remover dos destaques",
        "markAsDeleted": "Marcar como eliminada",
        "unmarkAsDeleted": "Desmarcar como eliminada",
        "markedAsDeleted": "Avaliação marcada como eliminada",
        "unmarkedAsDeleted": "Avaliação desmarcada como eliminada",
        "reviewStatus": {
            "updated": "Atualizada",
            "deleted": "Eliminada",
            "featured": "Em destaque"
        }
    },
    "RespondTemplate": {
        "insertTemplate": "Inserir modelo",
        "noSavedTemplates": "Nenhum modelo salvo",
        "saveReplyAsTemplate": "Salvar a resposta como modelo",
        "deleteTemplate": "Eliminar modelo",
        "overwriteTemplate": "Modificar modelo",
        "saveAsNewTemplate": "Salvar como novo modelo",
        "saveNewTemplate": "Salvar novo modelo",
        "editTemplate": "Editar modelo?",
        "editTemplateDescription": "Isto irá substituir o modelo."
    },
    "ReviewsReplyTemplates": {
        "tenfoldProductivity": "Aumente a produtividade da sua equipa com respostas pré-defenidas",
        "googleConnected": "Administre e atualize suas respostas já definidas às avaliações na Google",
        "created": "Modelos criados:",
        "templateMessage": "Mensagem do modelo",
        "linkedAutoreplies": "Respostas-Auto  com link",
        "addTemplate": "Adicionar modelo de resposta",
        "editTemplate": "Editar modelo de resposta",
        "viewTemplate": "Detalhes do modelo de resposta",
        "messageInputText": "Insira seu modelo de mensagem na caixa de mensagens abaixo. Pode usar os marcadores [name] e [location] que serão automaticamente substituídos pelo nome e localização da pessoa que fez a avaliação. Insira o link do formulário de recuperação pelo mesmo menu para convidar o cliente a deixar os contactos dele."
    },
    "SendInvites": {
        "sendSurvey": "Enviar Pesquisa",
        "sendSurveys": "Enviar pesquisas",
        "personal": "Pessoal",
        "bulk": "Volume",
        "phoneEmail": "Nº de telefone ou email",
        "from": "De",
        "messageSent": "Convite foi enviado com sucesso",
        "messagesSent": "convites foram enviados com sucesso",
        "bulkDescription1": "Pode importar até 1.000 clientes que gostaria de enviar pesquisas de avaliação.",
        "bulkDescription2": "Para ver a estrutura correcta do ficheiro CSV, pode",
        "bulkFileLink": "baixe amostra do ficheiro",
        "dataVerification": "Verificação de dados",
        "dataVerificationDescription": "Reveja os dados a partir do ficheiro csv. Para que sejam processados, eles não podem conter erros. Se encontrou um erro, feche este pop-up, edite e carregue novamente o ficheiro. Se o contacto tem email e nº de telefone, eles receberão uma mensagem de texto.",
        "id": "ID",
        "import": "Importar {{amount}} contactos",
        "contactsAdded": "contactos adicionados.",
        "viewContacts": "Ver contactos",
        "addedContacts": "Contactos adicionados."
    },
    "SettingsTabs": {
        "profile": "Perfil",
        "general": "Conta",
        "companies": "Localizações",
        "channels": "Canais",
        "integrations": "Integrações"
    },
    "mcpConnections": {
        "title": "Conexões MCP",
        "subtitle": "Aplicações que podem ligar-se à sua conta Pluspoint através do Model Context Protocol. Revogue as que já não utiliza.",
        "row": {
            "authorizedBy": "Autorizado por {{name}} · {{when}}",
            "authorizedByNoDate": "Autorizado por {{name}}",
            "lastUsed": "Última utilização: {{when}}",
            "lastUsedNever": "Última utilização: nunca",
            "verified": "Fornecedor verificado"
        },
        "empty": {
            "title": "Ainda não há conexões MCP.",
            "body": "Cole {{url}} no Claude.ai, ChatGPT ou outro cliente MCP para se ligar. Pediremos autorização primeiro."
        },
        "howTo": {
            "title": "Como ligar",
            "body": "Cole este URL no seu cliente MCP:",
            "guide": "Guia passo a passo para Claude, ChatGPT e outros assistentes"
        },
        "revoke": {
            "confirmTitle": "Revogar esta conexão?",
            "confirmBody": "{{name}} deixará de poder aceder à sua conta Pluspoint. As sessões ativas podem continuar por até 1 hora enquanto os tokens de acesso existentes expiram. A conexão terá de ser autorizada novamente para restabelecer o acesso.",
            "success": "{{name}} foi revogado."
        },
        "errors": {
            "fetchFailed": "Não foi possível carregar as conexões MCP.",
            "revokeFailed": "Não foi possível revogar esta conexão."
        }
    },
    "SettingsIntegrations": {
        "manageIntegration": {
            "title": "Gerir integração",
            "subtitle": "Conecte cada perfil desta conta a um local do Pluspoint.",
            "connectToLocation": "Conectar ao local",
            "dontConnect": "Não conectar",
            "createNew": "Criar novo local",
            "emptyProfiles": "Nenhum perfil encontrado para esta conta.",
            "loadError": "Não foi possível carregar os perfis desta conta. Tente novamente.",
            "retry": "Tentar novamente",
            "singleProfilePrompt": "Escolha um local para associar esta conta",
            "inactiveLocation": "Inativa no Square"
        },
        "connected": "Conectado",
        "notConnected": "Não está conectado",
        "integrations": "Integrações",
        "googleNoLocations": "Sem Resultados. Selecione outra conte da Google.",
        "iFoodSubtitle": "Gerencie avaliações do iFood e envie pesquisas de opinião aos clientes do iFood",
        "iFoodTitle": "Conecte a conta de iFood",
        "iFoodInstructions": "Insira o CNPJ de cada local no iFood.",
        "vtexTitle": "Conecte a sua conta de VTEX",
        "vtexSubtitle": "Para integrar a sua conta VTEX na nossa plataforma e permitir pesquisas pós-compra automatizadas, precisamos que nos forneça as credenciais de acesso necessárias. Estas incluem uma App Key e um App Token. <0>{{link}}</0> sobre como obtê-las.",
        "instructionsLink": "Leia as nossas instruções",
        "accountName": "Nome da Conta",
        "appToken": "Application Token",
        "appKey": "Application Key",
        "coverManagerTitle": "Conecte a sua conta de CoverManager",
        "coverManagerSubtitle": "Insira a sua ApiKey para conectar a sua conta CoverManager à Pluspoint",
        "apiKey": "apiKey",
        "deleteIntegration": "Eliminar integração?",
        "deleteIntegrationMessage": "Esta integração será eliminada da sua conta. Deseja continuar?",
        "addIntegration": "Adicionar integração",
        "columnPlatform": "Plataforma",
        "columnAccount": "Conta",
        "columnStatus": "Estado",
        "columnActions": "Ações",
        "noIntegrationsTitle": "Ainda não há integrações",
        "noIntegrationsDescription": "Conecte a sua primeira integração para começar a sincronizar dados.",
        "searchPlaceholder": "Pesquisar integrações",
        "requestIntegrationTitle": "Não encontra a sua integração?",
        "requestIntegrationDescription": "Solicite-a e iremos analisá-la, ou conecte-se através do Zapier ou da nossa API.",
        "requestIntegrationSuccess": "Obrigado! O seu pedido de integração foi enviado.",
        "requestIntegrationError": "Não foi possível enviar o seu pedido",
        "connectViaApi": "Conectar via API",
        "connectViaZapier": "Conectar via Zapier",
        "headerTitle": "Conecte as suas plataformas",
        "headerSubtitle": "Conecte as plataformas que já utiliza — Google, redes sociais, mensagens e CRM — para sincronizar avaliações, publicar conteúdo, gerir conversas e centralizar os dados dos seus clientes.",
        "requestNamed": "Solicitar adicionar “{{name}}”"
    },
    "SettingsProfile": {
        "alertsAndReports": "Alertas e Relatórios",
        "settingsTitle": "Perfil e configurações pessoais",
        "profilePhoto": "Foto de perfil",
        "generalInfo": "Informações Gerais",
        "systemLanguage": "Idioma do sistema",
        "currentPassword": "Senha atual",
        "newPassword": "Nova senha",
        "confirmPassword": "Confirm nova senha",
        "passwordResetText": "Esqueceu a senha atual?",
        "passwordResetUrl": "Criar nova senha",
        "everyHour": "Por hora",
        "everyDay": "Diária",
        "everyWeek": "Semanalmente",
        "everyMonth": "Mensalmente",
        "emptyNumberTooltip": "Insira o seu  nº de telefone para receber alertas SMS",
        "emailNotifications": "Emails de notificação",
        "emailNotificationsDescription": "Recebe novidades e alertas no teu email.",
        "profileSyncConflicts": "Conflitos de sincronização de perfis",
        "newReviews": "Novas reseñas",
        "newMessages": "Mensagens não atribuídas",
        "newSurveyResponses": "Novas respostas de encuestas",
        "performanceReports": "Relatórios de desempenho",
        "performanceReportsDescription": "Consulta relatórios regulares da tua conta.",
        "smsNotifications": "Alertas SMS de reclamações",
        "smsNotificationsDescription": "Recebe um SMS quando um cliente deixa um feedback negativo.",
        "browserNotifications": "Notificações no navegador",
        "browserNotificationsDescription": "Sê avisado de novas mensagens no teu dispositivo.",
        "pushMessagesSnackbar": "Active as notificações do browser para receber alertas de novas mensagens directamente no seu dispositivo. <0>{{enable}}</0>",
        "serviceWorkerUpdate": "Está disponível uma nova versão da Pluspoint. <0>{{refresh}}</0>",
        "bumpVersion": "Nova versão disponível. Por favor, atualize a página. <0>{{refresh}}</0>",
        "installApp": "Instalar aplicativo",
        "installAppDescription": "Instale o Pluspoint no seu dispositivo para acesso rápido.",
        "installIosInstructions": "Abra esta página no Safari, toque no ícone de Compartilhar e depois em \"Adicionar à Tela Inicial\".",
        "installed": "Instalado"
    },
    "SettingsGeneral": {
        "apiDocumentation": "Documentação da API",
        "accountNameOwnership": "Nome da conta e titular",
        "linkTracking": "Rastreamento de links",
        "linkTrackingDescription": "Veja na sua análise quantos visitantes chegam ao seu site a partir das suas fichas do Google, do Facebook e dos diretórios. O Pluspoint adiciona para você as tags de rastreamento ao link do site de cada ficha.",
        "trackingTagsEnabled": "Marcar os links das fichas",
        "trackingTagsSource": "utm_source",
        "trackingTagsMedium": "utm_medium",
        "trackingTagsCampaign": "utm_campaign",
        "trackingTagsContent": "utm_content",
        "trackingTagsPreview": "Exemplo para uma ficha do Google",
        "accountName": "Nome da Conta",
        "accountOwner": "Nome do Titular",
        "accountLocale": "Localização",
        "billing": "Faturação",
        "upgradePluspointSubscription": "Faça Upgrade à sua subscrição Pluspoint",
        "currentPlan": "Plano atual",
        "endsOn": "termina em",
        "endedOn": "terminou em",
        "daysLeft_one": "dia restante",
        "daysLeft_other": "dias restantes",
        "upgradeDescription": "Por favor selecione o plano, o período de faturação e a quantidade de localidades a prosseguir:",
        "numberOfCompanies": "N° de localizações",
        "annual": "Anual",
        "monthly": "Mensal",
        "proceedToPayment": "Proceder ao pagamento",
        "pricePerCompany": "Preço por localização:",
        "totalPrice": "Preço Total",
        "month": "mês",
        "year": "ano",
        "nextPaymentOn": "Próximo pagamento a",
        "cancelsOn": "Cancela a",
        "upgradePlan": "Upgrade do Plano",
        "changePlan": "Alterar plano",
        "changeDescription": "Seleccione o plano de preços, o ciclo de faturação e o número de localizações e usuários.",
        "numberOfUsers": "Número de usuários",
        "onlineListings": "Listagens Online",
        "reviewManagement": "Gestão de Avaliações",
        "inboxAndLiveChat": "Caixa de Entrada e Live-chat",
        "socialPosting": "Social",
        "microsites": "Micro-sites",
        "analytics": "Análises",
        "surveysAndTickets": "Pesquisas e Tickets",
        "campaigns": "Campanhas de Mensagem",
        "additionalUsers": "Usuários adicionais",
        "currentPrice": "Preço atual",
        "newPrice": "Novo preço",
        "dueToday": "Vencimento hoje",
        "proratedOnNextInvoice": "Cobranças proporcionais na próxima fatura",
        "pulseAICredits": "Pulse AI Créditos",
        "recurrentCredits": "Créditos recorrentes",
        "recurrentCreditsDescription": "Utilização dos créditos recorrentes atribuídos. São renovados no início de cada ciclo de faturação.",
        "additionalCredits": "Créditos adicionais",
        "additionalCreditsDescription": "Créditos adicionais disponíveis. Não expiram e podem ser usados a qualquer momento.",
        "buyCredits": "Comprar créditos",
        "enableAutoPay": "Ativar pagamento automático",
        "autoPayDescription": "Compre créditos automaticamente quando o saldo ficar abaixo do limite definido.",
        "creditsLeft": "{{amount}} créditos disponíveis",
        "creditLimit": "Limite de crédito",
        "creditsToPurchase": "Créditos a comprar",
        "selectAccount": "Selecionar conta",
        "twoMonthsFree": "2 meses grátis",
        "perLocationPer": "localização / {{period}}",
        "pluspointFeatureEverything": "Todas as funcionalidades incluídas — sem níveis nem restrições",
        "pluspointFeatureReviews": "Avaliações: monitorize, responda e ganhe mais com IA",
        "pluspointFeatureInbox": "Caixa de entrada omnicanal com chatbot de IA 24/7",
        "pluspointFeatureEngage": "Publicações sociais, campanhas, inquéritos e cupões",
        "pluspointFeatureAllowances": "{{users}} usuários e {{credits}} créditos de IA / mês incluídos",
        "minimumLocations": "Mínimo de {{count}} localizações",
        "usersIncluded": "{{count}} incluídos",
        "summaryPlan_one": "{{count}} localização",
        "summaryPlan_other": "{{count}} localizações",
        "summaryAdditionalUsers_one": "{{count}} usuário adicional",
        "summaryAdditionalUsers_other": "{{count}} usuários adicionais",
        "billToSubscription": "Cobrar na assinatura",
        "directoriesNoneEnrolled": "Ainda não há localizações inscritas.",
        "directoriesManagedPerLocation": "Adicione ou cancele os Diretórios Locais para cada localização a partir da sua página de gestão.",
        "openLocations": "Abrir localizações",
        "locationsEnrolled_one": "{{count}} localização ativada",
        "locationsEnrolled_other": "{{count}} localizações ativadas"
    },
    "SettingsCompanies": {
        "movedTitle": "As localizações foram movidas",
        "movedDescription": "Agora você pode gerenciar suas localizações no menu principal.",
        "goToLocations": "Ir para Localizações",
        "degree": "Título",
        "office": "Escritório",
        "menus": "Menus",
        "menuAssignmentFailed": "Localização guardada, mas não foi possível atribuir o menu. Tente novamente.",
        "headshotUrl": "Foto de perfil",
        "locationName": "Nome de Localização",
        "internalName": "Nome interno",
        "primaryPhone": "Telefone principal",
        "phoneExtension": "Ext.",
        "addChat": "Adicionar chat",
        "email": "Correio eletrónico do serviço",
        "website": "Website",
        "contact": "Contacto",
        "additionalInformation": "Informações adicionais",
        "descriptionShort": "Descrição curta",
        "descriptionMedium": "Descrição média",
        "descriptionLong": "Descrição longa",
        "openingDate": "Data de abertura",
        "businessHours": "Horário",
        "specialHours": "Horário especial",
        "specialHoursNeedBusinessHours": "O horário especial precisa do horário de funcionamento. Ative o horário e abra pelo menos um dia para adicionar datas.",
        "coverPhoto": "Foto da capa",
        "nationalHealthProviderId": "National Health Provider ID",
        "storeCode": "Código da loja",
        "certifications": "Certificações",
        "categoriesAndServices": "Categorias e Serviços",
        "address": "Endereço",
        "city": "Cidade",
        "channels": "Canais",
        "pending": "Pendente",
        "createChannel": "Adicionar novo canal",
        "showAddress": "Mostrar o endereço da empresa aos clientes",
        "locatedInToggle": "Localizado dentro de outro negócio",
        "locatedInNeedsPin": "Coloque o marcador no mapa para pesquisar negócios próximos",
        "locatedIn": "Localizado em",
        "relationIndependent": "Negócio independente",
        "locatedInRelationLabel": "Relação",
        "relationDepartment": "Departamento",
        "viewOnGoogleMaps": "Ver no Google Maps",
        "addressLine1": "Linha de endereço 1",
        "addressLine2": "Linha de endereço 2",
        "postalCode": "Código postal",
        "state": "Região",
        "country": "País",
        "countryLockedByListings": "Bloqueado enquanto os diretórios estiverem conectados",
        "countryLockedByGoogle": "Bloqueado enquanto uma ficha do Google estiver conectada",
        "pinFollowsGoogle": "O marcador do mapa segue a sua ficha do Google. Mova-o no seu Perfil da Empresa no Google",
        "publishedDirectories_one": "Publicado ({{count}} diretório)",
        "publishedDirectories_other": "Publicado ({{count}} diretórios)",
        "optimizationScore": "Pontuação de otimização",
        "optimizationScoreTooltip": "Mede o quão bem otimizada está sua localização para descoberta online, com base na completude dos campos do perfil. Pontuações mais altas melhoram a visibilidade.",
        "integrationName": "Nome de integração",
        "disconnectIntegration": "Desconectar a integração ativa?",
        "disconnectIntegrationMessage": "Não vai conseguir recolher avaliações através da Pluspoint nesta plataforma nem ver análises. Deseja continuar?",
        "integrations": "Integrações",
        "onlineProfiles": "Perfis online",
        "socialLinks": "Links sociais",
        "managedByConnection": "Gerido pela ligação",
        "connected": "Conectado",
        "notConnected": "Desconectado",
        "published": "Publicado",
        "notPublished": "Não publicado",
        "generalInfo": "Info Geral",
        "profileURL": "URL do Perfil",
        "uberEatsReviewsHint": "O Uber Eats publica apenas uma seleção das avaliações de 5 estrelas de cada loja. As contagens e médias na Pluspoint refletem essa seleção.",
        "bookingExtranetLink": "Link da Extranet do Booking.com",
        "bookingExtranetHint": "Opcional. Cole qualquer link da Extranet desta propriedade (admin.booking.com) ou o ID da propriedade. As respostas abrirão diretamente a página de avaliações da Extranet.",
        "connectIntegration": "Conectar integração",
        "editProfile": "Editar perfil",
        "reviewPlatforms": "Plataformas de avaliações",
        "addReviewPlatform": "Adicionar plataforma de avaliações",
        "connectIntegrationMsg": "Perfil foi conectado",
        "locationPublishedMsg": "Localização publicada. As atualizações podem levar vários dias para aparecer em sites externos.",
        "profileDisconnected": "Perfil foi desconectado",
        "atLeastOneProfile": "Pelo menos uma integração deve estar ativa",
        "selectLocation": "Selecione localização",
        "connectLocation": "Conectar Localização",
        "goToIntegrations": "Acessar integrações",
        "importCompanies": "Importar localizações",
        "importCompaniesCount": "Importar {{count}} localização(ões)",
        "selectCompanies": "Por favor selecione as localizações que deseja importar da sua conta Google:",
        "linkedTo": "Ligado a",
        "googleAutocomplete": "Pesquisar negócio no Google",
        "addLocationTitle": "Adicionar novo local",
        "addLocationDescription": "Pesquise o local do Google que você gostaria de adicionar ao Pluspoint e clique em Adicionar local.",
        "connectDrawerDescription": "Selecione um item apropriado da lista para vincular à localização.",
        "connectDrawerNotConnected": "Integración no conectada",
        "connectDrawerNotConnectedDescription": "Conecte su cuenta en los ajustes de integración para continuar (se requieren permisos del 'Global Admin').",
        "iFoodPendingTitle": "Conexão com o iFood em andamento",
        "iFoodPendingDescription": "Sua solicitação de conexão foi enviada ao iFood. Você poderá vincular as localizações assim que o iFood conceder o acesso.",
        "title": "Gerencie todas as suas localizações em um só lugar",
        "subtitle": "Mantenha dados do negócio, horários, endereços e informações de contato precisos e consistentes em todas as suas localizações. Adicione novas localizações, edite em lote ou importe do Google — tudo o que você precisa para se manter organizado.",
        "additionalPhone": "Telefone adicional",
        "additionalPhones": "Telefones adicionais",
        "addPhone": "Adicionar telefone",
        "geoModifier": "Geomodificador",
        "addFeatureMessage": "Adicionar mensagem destacada",
        "healthcareFacility": "Unidade de saúde",
        "healthcareProfessional": "Profissional de saúde",
        "hotel": "Hotel",
        "restaurant": "Restaurante",
        "listingDirectories": "Diretórios de Listagens",
        "listingDirectoriesDescription": "Publique e sincronize a sua localização em mais de 200 diretórios",
        "findOnGoogle": "Buscar no Google",
        "enterManually": "Inserir manualmente",
        "googleAccountRequired": "Conecte sua conta do Google nas configurações de integração para continuar",
        "facebookAccountRequired": "Conecte sua conta do Facebook nas configurações de integração para continuar",
        "tiktokAccountRequired": "Conecte sua conta do TikTok nas configurações de integração para continuar",
        "xAccountRequired": "Conecte sua conta do X nas configurações de integração para continuar",
        "whatsappAccountRequired": "Conecte sua conta do WhatsApp nas configurações de integração para continuar",
        "createGoogleProfileTitle": "Criar perfil no Google",
        "createGoogleProfileDescription": "Escolha em qual conta do Google e grupo de localizações esta ficha deve ser criada.",
        "googleAccount": "Conta do Google",
        "googleLocationGroup": "Grupo de localizações",
        "selectAccountToLink": "Escolha em qual conta conectada esta localização irá publicar.",
        "account": "Conta",
        "localDirectories": "Diretórios Locais",
        "addLocalDirectories": "Adicionar Diretórios Locais",
        "cancelLocalDirectories": "Cancelar Diretórios Locais",
        "cancelLocalDirectoriesDescription": "A publicação continua até ao fim do período que pagou; depois as listagens desta localização são removidas. Não são emitidos reembolsos.",
        "directoriesValueCopy": "Publique esta localização em mais de 200 diretórios — do Apple Maps e Bing ao TripAdvisor e Yelp — e mantenha horários, fotos e dados sincronizados automaticamente. Dados consistentes em todo o lado são a base da pesquisa local e das respostas de IA como o ChatGPT: assim é encontrado primeiro e ganha mais clientes.",
        "directoriesPromoTitle": "Seja encontrado em mais de 200 diretórios locais",
        "directoriesPromoDescription": "Publique {{location}} em mais de 200 diretórios — Apple Maps, Bing, TripAdvisor, Yelp e mais — com os dados sempre sincronizados. Seja encontrado primeiro na pesquisa local e nas respostas de IA como o ChatGPT.",
        "seeAllDirectories": "Ver todos os diretórios",
        "perLocation": "por localização",
        "directoriesMinimumTermNotice": "Pode ser cancelado após 3 meses.",
        "chargedTodayProrated": "Cobrado hoje (proporcional)",
        "thenFrom": "Depois a partir de {{date}}",
        "addForToday": "Adicionar por {{amount}} hoje",
        "subscribeAndAddLocation": "Assinar e adicionar esta localização",
        "directoriesRequiresSubscription": "Diretórios Locais requer uma assinatura ativa. Assine o seu plano e adicione esta localização num só passo.",
        "directoriesSinceCancellableAfter": "A publicar desde {{since}} · cancelável após {{cancellableAfter}}",
        "directoriesCancellableAfter": "Cancelável após {{date}}",
        "directoriesEndsOn": "A publicar até {{date}}",
        "directoriesIncludedInPlan": "Incluído no seu plano",
        "viewListings": "Ver diretórios",
        "directoriesAddedMsg": "Diretórios Locais adicionado. A publicação começou.",
        "directoriesCancelledMsg": "Diretórios Locais cancelado. A publicação continua até ao fim do período pago."
    },
    "ScorePanel": {
        "recommendations": "Recomendações",
        "allDone": "Tudo o que conta para a pontuação está preenchido",
        "suggest": "Sugerir",
        "write": "Redigir",
        "dismiss": "Dispensar",
        "replace": "Substituir",
        "undo": "Desfazer",
        "waitForAi": "Aguarde a Pulse AI terminar",
        "thinking": "A Pulse AI está trabalhando nisso…",
        "failed": "Não foi possível gerar sugestões. Tente novamente.",
        "noSuggestions": "A Pulse AI não tem sugestões para esta localização.",
        "reviewBeforeSave": "Revise no formulário. Nada é salvo até você selecionar Salvar.",
        "aiServices": "Pulse AI · com base nas suas categorias e descrição",
        "aiCategories": "Pulse AI · com base nos dados do seu negócio",
        "aiSpecialHours": "Pulse AI · feriados em {{country}}",
        "aiDescription": "Pulse AI · descrição sugerida",
        "specialHoursNote": "As datas são adicionadas como Fechado. Mude uma data para Aberto e defina o horário se você abrir nesse dia.",
        "addServices_zero": "Adicionar serviços",
        "addServices_one": "Adicionar {{count}} serviço",
        "addServices_other": "Adicionar {{count}} serviços",
        "addCategories_zero": "Adicionar categorias",
        "addCategories_one": "Adicionar {{count}} categoria",
        "addCategories_other": "Adicionar {{count}} categorias",
        "addDates_zero": "Adicionar datas",
        "addDates_one": "Adicionar {{count}} data",
        "addDates_other": "Adicionar {{count}} datas",
        "drafted": {
            "shortDescription": "Descrição curta redigida",
            "mediumDescription": "Descrição média redigida",
            "longDescription": "Descrição longa redigida"
        },
        "rec": {
            "locationName": "Adicione o nome da localização",
            "practitioner": "Complete os dados do profissional",
            "certifications": "Adicione uma certificação",
            "phone": "Adicione um número de telefone",
            "email": "Adicione um email",
            "website": "Adicione um website",
            "address": "Complete o endereço",
            "workingHours": "Defina o horário",
            "specialHours": "Adicione um horário especial",
            "shortDescription": "Adicione uma descrição curta",
            "mediumDescription": "Adicione uma descrição média",
            "longDescriptionAdd": "Adicione uma descrição longa",
            "longDescriptionExtend": "Amplie a descrição longa",
            "openingDate": "Adicione a data de abertura",
            "engagement": "Adicione uma mensagem em destaque",
            "categoriesAdd": "Adicione uma categoria",
            "categoriesMore": "Adicione outra categoria",
            "servicesAdd": "Adicione serviços",
            "servicesMore": "Adicione mais serviços",
            "paymentMethods": "Selecione métodos de pagamento",
            "logo": "Envie um logótipo",
            "cover": "Envie uma foto da capa",
            "socialAdd": "Adicione um link social",
            "socialMore": "Adicione outro link social"
        }
    },
    "SettingsChannels": {
        "historyImportRunning": "A importar conversas anteriores…",
        "historyImportCompleted": "Conversas anteriores importadas",
        "historyImportDeclined": "Conversas anteriores não partilhadas",
        "historyImportFailed": "Não foi possível importar as conversas anteriores ou os contactos",
        "headerTitle": "Gerencie os seus Canais",
        "headerSubtitle": "Conecte todos os seus canais de comunicação para proporcionar uma experiência coerente ao cliente, a partir de um único painel de controlo.",
        "firstStepTitle": "Adicionar novo canal",
        "firstStepSubtitle": "Selecione que tipo de canal que quer adicionar",
        "createChannelTitle": "Adicione um novo canal de {{channelType}}",
        "editChannelTitle": "Editar canal de {{channelType}}",
        "editChannelSubtitle": "Forneça suporte instantâneo aos seus clientes com a integração do {{channelType}}",
        "linkChannelToLocation": "Vincular este canal a uma localização ou marca",
        "channelName": "Nome do Canal",
        "senderId": "ID do Remetente",
        "provider": "Fornecedor",
        "accountSid": "Account SID",
        "authToken": "Auth token",
        "apiToken": "HTTP API Token",
        "customGateway": "Gateway personalizado",
        "whatsAppNumber": "N°de WhatsApp",
        "senderIdNotice": "O ID do remetente identifica a pessoa de uma mensagem de SMS. Pode ter até 11 caracteres, incluindo letras maiúsculas e minúsculas, os dígitos de 0 a 9 e conter espaço.",
        "isNewWhatsAppAcc": "Nova conta do WhatsApp?",
        "whatsAppSuccess": "WhatsApp conectado com sucesso!",
        "whatsAppFail": "O número já existe nesta conta",
        "whatsAppTooltip": "Ative esta opção se o seu nº WhatsApp foi registado há menos de 30 dias, para reduzir a probabilidade de o bloquear ao enviar mensagens automáticas em massa. Se ativar, a Pluspoint estabelece um limite de mensagens enviadas neste canal para 2 pedidos por dia. este limite é gradualmente aumentado em 1,5 vezes po dia (exe. 2,3,5,7,10, etc.).",
        "whatsAppInstruction1": "1. Abra o WhatsApp no telefone com o número fornecido",
        "whatsAppInstruction2": "2. Clique <strong>{{settings}}</strong> e depois clique em <strong>{{qrIcon}}</strong>",
        "qrIcon": "Ícone de QR",
        "whatsAppInstruction3": "3. Clique em <strong>{{scan}}</strong> e aponte o seu telefone para este ecrã",
        "scan": "Digitalizar",
        "pending": "Pendente",
        "liveChatTitle": "Adicione um novo canal de chat ao vivo",
        "liveChatSubtitle": "Forneça suporte instantâneo aos seus clientes com a integração do chat ao vivo",
        "liveChatEditTitle": "Editar canal de chat ao vivo",
        "welcomeTagline": "Mensagem de boas-vindas",
        "businessHoursSwitch": "Ativar o horário de funcionamento",
        "offlineMessage": "Mensagem offline",
        "widgetPosition": "Posição do widget de live chat",
        "widgetOffsetX": "Deslocamento horizontal (px)",
        "widgetOffsetY": "Deslocamento vertical (px)",
        "addCodeBelow": "Adicione o código abaixo à secção principal do HTML do seu website.",
        "messagesTab": "Mensagens",
        "contactDetailsHint": "Pedidos no chat depois da primeira mensagem do visitante. Pelo menos um dos campos, e-mail ou telefone, deve ser obrigatório.",
        "assignLocationSwitch": "Atribuir as conversas a uma localização",
        "assignLocationHint": "Cada conversa é atribuída a uma localização. Quando há mais de uma localização na lista, os visitantes escolhem a localização com a qual estão falando.",
        "allLocationsCount": "Todas as localizações ({{number}})",
        "selectedLocations": "Localizações selecionadas",
        "reachVisitorsTitle": "Falar com visitantes que saíram",
        "missedRepliesSwitch": "Avisar sobre respostas não vistas",
        "missedRepliesHint": "Quando um agente responde depois que o visitante fechou a página, ele recebe uma nota curta com um link de volta para o chat.",
        "followUpRequiresContact": "Exige que o e-mail ou o telefone seja obrigatório",
        "followUpChannelCleared": "O canal selecionado já não corresponde aos campos de contato; escolha outro",
        "followUpChannelUnavailable": "O canal de acompanhamento está desconectado ou foi excluído; escolha outro",
        "followUpChannelOtherTeam": "Um canal de outra equipe",
        "welcomeButtons": "Botões",
        "welcomeButton": "Botão {{number}}",
        "addButton": "Adicionar botão",
        "welcomePopupSwitch": "Mostrar a mensagem de boas-vindas ao lado do botão do chat automaticamente",
        "welcomePopupHint": "Aparece alguns segundos depois que a página carrega, uma vez por visitante. No celular, ou se estiver desligado, os visitantes a veem ao abrir o chat.",
        "showOfflineMessage": "Mostrar a mensagem offline",
        "offlineHoursHint": "Publicada no chat fora do horário abaixo.",
        "websiteWidget": "Widget do site",
        "chatLink": "Link do chat",
        "chatLinkHint": "Abre este chat em uma página hospedada. Compartilhe como link ou código QR onde o widget não pode ser instalado: cardápios, recibos, assinaturas de e-mail, perfis sociais.",
        "chatLinkParams": "Adicione ?locationId= com o ID de uma localização para pular a pergunta da localização, ?language= com um código de idioma para abrir o chat nesse idioma, ou ?start= com uma mensagem para preencher a primeira mensagem do visitante.",
        "allowedSites": "Sites permitidos",
        "allowedSitesHint": "Domínios em que o widget pode aparecer, incluindo subdomínios. Deixe a lista vazia para permitir qualquer site. Seus micro-sites e o link do chat são sempre permitidos.",
        "allowedSiteInvalid": "Informe um domínio como example.com",
        "signedInCustomers": "Clientes autenticados",
        "signingSecretHint": "Assine os dados do cliente no seu servidor com este segredo para que os clientes que fizeram login no seu site pulem o formulário.",
        "signingSecret": "Segredo de assinatura",
        "replaceSecretTitle": "Substituir o segredo de assinatura?",
        "replaceSecretBody": "Os dados assinados com o segredo atual deixam de ser aceitos imediatamente. Atualize seu site com o novo segredo.",
        "followUpWarning": "Aviso",
        "logoUrl": "URL do logótipo",
        "smtpHost": "SMTP Host",
        "smtpPort": "SMTP Port",
        "username": "Nome de usuário",
        "encryption": "Método de criptografia",
        "saveInstagramReplies": "Receber menções no story",
        "createNewChannel": "Criar novo canal",
        "enableIncomingEmail": "Receber e-mails na caixa de entrada (IMAP)",
        "enableIncomingEmailHint": "Receber e responder a e-mails de clientes diretamente na caixa de entrada",
        "imapHost": "IMAP Host",
        "imapPort": "IMAP Port",
        "imapUsername": "Utilizador IMAP",
        "imapUsernamePlaceholder": "Deixe vazio para usar o usuário SMTP",
        "imapPassword": "Senha IMAP",
        "imapPasswordPlaceholder": "Deixe vazio para usar a senha SMTP",
        "signature": "Assinatura de e-mail",
        "facebookPage": "Página do Facebook",
        "hostedEmailSubtitle": "Envie campanhas, pesquisas e respostas do Inbox de um endereço no seu próprio domínio.",
        "receiveEmailsInInbox": "Receber e-mails no Inbox",
        "forwardingAddress": "Endereço de encaminhamento",
        "receiveRepliesHint": "Encaminhe {{email}} para este endereço no seu provedor de e-mail. As respostas aparecem no Inbox e você responde por aqui.",
        "fromNameHint": "Exibido como nome do remetente",
        "emailAddress": "Endereço de e-mail",
        "emailAddressLocked": "O endereço não pode ser alterado depois que o canal é criado",
        "returnPathSubdomain": "Subdomínio Return-Path",
        "customReturnPath": "Usar um subdomínio Return-Path personalizado",
        "customReturnPathHint": "Os e-mails devolvidos voltam por este subdomínio. Altere o padrão só se o seu domínio já o usar.",
        "returnPathSubdomainReused": "{{domain}} já está conectado. O novo endereço compartilha seus registros DNS e o subdomínio Return-Path.",
        "returnPathSubdomainInvalid": "Use apenas letras, dígitos e hifens",
        "verifyDomainTitle": "Verificar {{domain}}",
        "verifyDomainSubtitle": "Adicione estes registros no seu provedor de DNS. O canal fica disponível quando todos estiverem verificados.",
        "dnsRecordsHint": "Estes dois registros DNS verificam que o domínio é seu e permitem que os provedores de e-mail confiem nas suas mensagens. O registro TXT assina seus e-mails; o CNAME trata os retornos.",
        "dnsPropagationNote": "Observação: alterações de DNS podem levar até 48 horas para propagar.",
        "showDnsRecords": "Mostrar registros DNS",
        "hideDnsRecords": "Ocultar registros DNS",
        "recordVerified": "Verificado",
        "statusSuspended": "Suspenso",
        "domainSuspended": "O envio a partir deste domínio está suspenso. Fale com o suporte para retomar.",
        "ringCentralAccount": "Conta RingCentral",
        "ringCentralNumber": "Número RingCentral",
        "ringCentralNoNumbers": "Este usuário do RingCentral não tem nenhum número que possa enviar SMS",
        "ringCentralNumbersInUse": "Todos os números desta conta do RingCentral já são usados por outro canal",
        "ringCentralDisconnected": "A conta RingCentral deste canal está desconectada. Reconecte-a em <0>{{link}}</0> para voltar a enviar.",
        "ringCentralIntegrations": "Integrações"
    },
    "SettingsUsers": {
        "addedOn": "Adicionadas em",
        "lastLogin": "Último acesso",
        "generalInfo": "Info Geral",
        "editUser": "Editar usuário",
        "accessLevel": "Nível de acesso",
        "owner": "Proprietário",
        "global": "Global",
        "role": "Função",
        "superAdmin": "Super admin",
        "admin": "Administrador",
        "user": "Usuário",
        "permissions": "Permissões",
        "permissionsDescription": "Selecionar uma função: Os super administradores podem alterar as configurações globais e gerenciar as integrações da conta. Administradores podem configurar localizações, inquéritos, modelos e campanhas, normalmente destinados a chefes de departamento ou proprietários de empresas. Os usuários gerem as atividades comerciais diárias, ideal para o pessoal operacional.",
        "accessDescription": "Selecione um nível de acesso: Global dá acesso a toda a organização, Marca permite o acesso a um grupo selecionado de localizações e Localização dá acesso apenas a localizações específicas.",
        "globalAccess": "Nível de acesso global",
        "brandAccess": "Nível de acesso baseado na marca",
        "locationAccess": "Nível de acesso baseado na localização"
    },
    "SettingsTeams": {
        "createTeam": "Criar equipe",
        "editTeam": "Editar equipe",
        "teamName": "Nome da equipe",
        "permissions": "Permissões",
        "permissionsDescription": "Controle o que cada equipe pode fazer. Restrito permite visualizar e realizar ações básicas, enquanto Completo habilita edição, criação e gestão dentro de cada módulo. As configurações de conta também podem ser definidas como Nenhum para ocultar os ajustes por completo.",
        "restricted": "Restrito",
        "full": "Completo",
        "none": "Nenhum",
        "noneTooltip": "Sem acesso — o recurso fica oculto para esta equipe",
        "globalPermission": "Global",
        "scope": "Escopo",
        "scopeDescription": "Defina quais localizações esta equipe pode acessar. Global dá acesso a todas as localizações, Marca limita o acesso às localizações das marcas selecionadas e Localização restringe o acesso apenas a localizações específicas.",
        "scopeScopedOnlyNote": "O escopo se aplica apenas às permissões com escopo. Permissões globais (Contatos, Configurações de conta) sempre cobrem toda a conta.",
        "members": "Membros",
        "membersDescription": "Selecione usuários para adicionar a esta equipe. Os membros podem ser alterados depois.",
        "addMember": "Adicionar membro",
        "enabledPermissionsCount": "{{count}} permissões",
        "messagingRestricted": "Ver, Responder, Reatribuir, Resolver/Reabrir, Exportar, Análises",
        "messagingFull": "Agentes de IA, Base de conhecimento",
        "accountSettings": "Configurações de conta",
        "tooltipRestricted": "Restrito",
        "tooltipFull": "Completo",
        "contactsRestricted": "Ver todos os contatos da conta",
        "contactsFull": "Criar, Editar, Excluir, Ações em massa, Importar, Exportar",
        "locationsRestricted": "Ver localizações e perfis, Enviar/Excluir mídia, Exportar CSV",
        "locationsFull": "Adicionar/Importar localizações, Editar, Excluir, Edição em massa, Exportar/Importar, Sincronizar, Análises",
        "reviewsRestricted": "Ver, Responder avaliações, Usar modelos, Análises, Widgets",
        "reviewsFull": "Gerenciar respostas automáticas e modelos de resposta",
        "postsRestricted": "Ver publicações, Análises",
        "postsFull": "Criar, Editar, Excluir, Agendar publicações",
        "micrositesRestricted": "Ver páginas web",
        "micrositesFull": "Criar, Editar, Excluir páginas web",
        "surveysRestricted": "Ver respostas, Conversas, Tickets, Ver modelos",
        "surveysFull": "Gerenciar modelos de pesquisas",
        "campaignsRestricted": "Ver campanhas",
        "campaignsFull": "Criar, Editar, Excluir campanhas",
        "couponsRestricted": "Ver cupons",
        "couponsFull": "Criar, Editar, Excluir cupons",
        "settingsNoneTooltip": "Apenas página de perfil",
        "settingsRestrictedTooltip": "Gestão de usuários: convidar, editar, excluir usuários",
        "settingsFullTooltip": "Todas as configurações: Geral, Faturamento, Marcas, Usuários, Equipes, Canais, Integrações"
    },
    "SettingsBrands": {
        "title": "Organize suas localizações com marcas",
        "subtitle": "Gerencie várias localizações facilmente agrupando-as sob uma única marca. Centralize suas mensagens, avaliações, campanhas e pesquisas para uma gestão simplificada em todas as suas localizações.",
        "editBrand": "Editar marca",
        "shared": "Compartilhado",
        "gradient": "Gradiente",
        "solid": "Sólido",
        "sharp": "Afiados",
        "softlyRounded": "Suavemente arredondados",
        "rounded": "Arredondados",
        "fontColor": "Cor da fonte",
        "automaticallyAssignBrand": "Atribuir automaticamente a novas localizações",
        "brandIsAlreadyAssigned": "Já existe uma marca predefinida definida",
        "createNewBrand": "Criar nova marca",
        "previewDisclaimer": "Isto é apenas uma demonstração de como a sua marca aparece para os clientes."
    },
    "ShowcaseWidgets": {
        "title": "Avaliações do Cliente",
        "subtitle": "Exiba avaliações positivas dos clientes no seu site utilizando os nossos widgets.",
        "popup": "Pop-up",
        "grid": "Grade",
        "popupWidget": "Widget Pop-up",
        "gridWidget": "Widget Grade",
        "reviewsSorting": "Ordenar avaliacões",
        "random": "Aleatoriamente",
        "recent": "Mais recentes",
        "reviewsToShow": "Total de avaliações exibidas",
        "reviewsMode": "Quais avaliações exibir",
        "topRatedReviews": "Avaliações de 5 estrelas com comentários",
        "featuredReviews": "Avaliações em destaque",
        "noFeaturedReviews": "Ainda não há avaliações em destaque. Marque avaliações como destaque na página de avaliações",
        "widgetPosition": "Posição do widget",
        "widgetCode": "Código do widget",
        "addCodeSubtitle": "Adicione o código abaixo ao HTML do seu site onde gostaria de exibir o widget."
    },
    "Sidebar": {
        "bookmarks": "Favoritos",
        "addBookmark": "Adicionar aos favoritos",
        "removeBookmark": "Remover dos favoritos",
        "home": "Início",
        "responses": "Todas as respostas",
        "templates": "Modelos",
        "surveys": "Pesquisas",
        "surveysQrOnly": "Códigos QR",
        "analytics": "Análises",
        "analyticsConversion": "Conversão",
        "analyticsNpsOverview": "Visão geral do NPS",
        "analyticsSurveyInsights": "Insights de pesquisas",
        "analyticsSurveys": "NPS e Pesquisas",
        "analyticsConversations": "Conversas",
        "analyticsPresence": "Presença",
        "analyticsSocialPosts": "Publicações sociais",
        "performance": "Desempenho",
        "insights": "Insights",
        "reviews": "Avaliações",
        "reviewsManage": "Todas as avaliações",
        "reviewsTemplates": "Modelos de resposta",
        "reviewsAutoreplies": "Respostas-auto",
        "reviewsAutomation": "Automatização",
        "microsites": "Micro-sites",
        "messaging": "Mensagens",
        "messagingInbox": "Caixa de entrada",
        "reviewsWidgets": "Widgets de site",
        "social": "Social",
        "socialPosts": "Publicações",
        "profile": "Perfil",
        "helpCenter": "Centro de Suporte",
        "logout": "Sair",
        "switchAccount": "Mudar de conta",
        "accountMenu": "Menu da conta",
        "ordersIfood": "Pedidos",
        "campaigns": "Campanhas",
        "campaignsAutomated": "Automatizadas",
        "campaignsOneTime": "Únicas",
        "contacts": "Contactos",
        "presence": "Presença",
        "presenceProfiles": "Perfis",
        "presenceMedia": "Fotos e vídeos",
        "locations": "Localizações",
        "locationsManage": "Gerir localizações",
        "locationsProfiles": "Perfis",
        "locationsMedia": "Fotos e Vídeos",
        "visibilityScanner": "Scanner de visibilidade",
        "pulseAI": "Pulse AI",
        "knowledgeBase": "Base de conhecimento",
        "agents": "Agentes",
        "referral": "Programa de indicações",
        "coupons": "Ofertas",
        "expand": "Expandir",
        "collapse": "Recolher",
        "webPages": "Páginas web",
        "menus": "Menus",
        "forms": "Formulários",
        "campaignsLibrary": "Biblioteca"
    },
    "SignupPage": {
        "title": "Crie uma conta gratuita",
        "description": "Comece a gerenciar suas listagens, avaliações e conversas com clientes em um só painel.",
        "alreadyRegistered": "Já tem uma conta? <0>{{link}}</0>",
        "logIn": "Iniciar Sessão",
        "or": "ou",
        "terms": "Termos de Uso,",
        "privacy": "Políticas de Privacidade",
        "dpa": "Acordo de Tratamento de Dados",
        "termsConditions": "Ao utilizar a Pluspoint, confirma que aceita <0>{{terms}}</0> <1>{{privacy}}</1> e <2>{{dpa}}</2>",
        "confirmationTitle": "Veja a sua caixa de entrada",
        "confirmationDescription": "Enviámos um email de confirmação para sua resposta. Por favor, veja também a sua caixa de spam, caso não o encontre na sua caixa de entrada.",
        "returnToHomepage": "Voltar à Página Inicial",
        "signupWithGoogle": "Registar com o Google",
        "signupWithGoogleCaption": "Certifique que seleciona todas as caixas de verificação para obter todas as funcionalidades."
    },
    "Table": {
        "allOnPageSelected": "Todos os {{selected}} {{entity}} nesta página estão selecionados.",
        "selectAll": " Selecione todos os {{data}} {{entity}}",
        "allDataSelected": "Todos os {{data}} {{entity}} estão selecionados.",
        "clearSelection": " Limpar seleção.",
        "moreThan": "mais de",
        "of": "de",
        "rowsPerPage": "Linhas por página"
    },
    "FeedbackToolbar": {
        "reviewsTicketToggle": "Mostrar feedback sem tickets",
        "createTicket": "Criar ticket",
        "viewTicket": "Ver ticket",
        "ticketAssignedTo": "Ticket atribuído a:",
        "ticketStatus": "Status do ticket:",
        "completed": "Concluído",
        "empty": "Vazio",
        "price": "Preço",
        "quality": "Qualidade",
        "cleanliness": "Limpeza",
        "communication": "Comunicação",
        "ticketDescription": "Descrição do ticket"
    },
    "AuthLayout": {
        "title": "Assuma o controle da sua <0>{{reputation}}</0>",
        "onlineReputation": "reputação online",
        "block1Title": "Impulsione suas avaliações",
        "block1Description": "Converta clientes satisfeitos em promotores com solicitações automáticas de reviews.",
        "block2Title": "Economize tempo",
        "block2Description": "Responda a reviews, mensagens e agende publicações em um único painel.",
        "block3Title": "Expanda sua presença online",
        "block3Description": "Atraia mais clientes ao divulgar seu negócio em mais de 200 plataformas."
    },
    "validation": {
        "minPasswordLength": "Sua senha tem que ter pelo menos 8 caracteres",
        "wrongPasswordFormat": "Sua senha tem que conter números e letras",
        "confirmPasswordMatch": "As senhas não coincidem, tente novamente",
        "minLength4": "Este campo tem de ter pelo menos 4 caracteres",
        "minLength8": "Este campo tem de ter pelo menos 8 caracteres",
        "wrongEmailFormat": "Por favor introduza um email válido",
        "wrongFile": "Formato incorreto de ficheiro",
        "maxLength": "Este campo deve ser até {{count}} caracteres",
        "trackingTagSlug": "Use letras minúsculas, dígitos e hífens",
        "trackingTagPaidMedium": "A análise contaria este meio como tráfego pago",
        "trackingTagShoppingCampaign": "A análise contaria esta campanha como tráfego de compras",
        "numberRange": "Introduza um valor entre {{min}} e {{max}}",
        "descriptionContainsUrl": "Não são permitidos links na descrição",
        "hexFormat": "Tem que estar em formato HEX",
        "onlyAlphanumericSpace": "Deveria só conter, letras, números e espaços",
        "onlyNumbers": "Deveria só conter números",
        "invalidURL": "Inválido URL",
        "takenURL": "Indisponível",
        "required": "Este campo é mandatório",
        "wrongPhoneFormat": "Deveria de estar em formato internacional",
        "specialHoursNeedBusinessHours": "Remova as datas especiais ou ative o horário de funcionamento",
        "specialHoursDuplicateDate": "Esta data já está na lista. Mantenha uma só entrada por data",
        "specialHoursReversedRange": "Um intervalo de tempo deve terminar depois de começar",
        "duplicatePhone": "Este número já está na lista",
        "timeRangeExceeded": "Intervalo de tempo excedido",
        "completeAllFields": "Preencha os campos obrigatórios para continuar",
        "platformWithoutDirectCompany": "Cada plataforma selecionada precisa de pelo menos uma localização conectada diretamente",
        "unsupportedPlaceholders": "Espaço(s) reservado(s) não suportado(s): {{tokens}}",
        "dateOfBirthOutOfRange": "Informe uma data a partir de 1900 que não seja no futuro"
    },
    "VerifyEmail": {
        "message": "Seu email ainda não está verificado. Enviámos as instruções de verificação para {{email}}. Se não encontrar o email de verificação, por favor veja a sua caixa de spam. Também pode reenviar o email ao clicar no link <1>{{link}}</1>.",
        "link": "REENVIAR EMAIL DE VERIFICAÇÃO",
        "resendSuccess": "Email foi reenviado com sucesso",
        "resendFail": "Impossível reenviar o email"
    },
    "IfoodOrders": {
        "accountId": "ID da Conta",
        "createdAt": "Criado a",
        "customerName": "Cliente",
        "customerPhoneNumber": "N° de telefone do Cliente",
        "merchant": "Estabelecimento",
        "orderId": "ID do pedido",
        "orderType": "Tipo de pedido",
        "paymentInformation": "Info de Pagamento",
        "expireAt": "expira em:"
    },
    "InboxPage": {
        "sentFromWhatsAppBusinessApp": "Aplicação WhatsApp Business",
        "sentFromWhatsAppApp": "Aplicação WhatsApp",
        "sentFromMetaBusinessSuite": "Meta Business Suite",
        "sentFromExternalApp": "Aplicação externa",
        "unsupportedMessage": "Esta mensagem não pode ser mostrada aqui. Consulte-a na aplicação WhatsApp Business.",
        "mediaNotImported": "Foto ou ficheiro não importado",
        "viewFullContact": "Ver contato completo",
        "conversationsCount_one": "{{count}} conversa",
        "conversationsCount_other": "{{count}} conversas",
        "viewDetails": "Ver detalhes",
        "createdAt": "Criada",
        "resolvedAt": "Resolvida",
        "pulseAgent": "Pulse",
        "views": "Visualizações",
        "myConversations": "Minhas conversas",
        "allConversations": "Todas as conversas",
        "moveToTeam": "Mover para equipe",
        "moveToTeamTitle": "Mover para outra equipe",
        "moveToTeamDescription": "A conversa e todo o seu histórico são movidos junto. A outra equipe será notificada.",
        "moveToTeamAssigneeKept": "{{name}} é membro de {{team}} e continuará atribuído.",
        "moveToTeamAssigneeCleared": "{{name}} não é membro de {{team}}. A conversa ficará sem atribuição e será colocada na fila dessa equipe.",
        "internalNoteOptional": "Nota interna (opcional)",
        "internalNote": "Nota interna",
        "teamChangedBy": "{{date}} — {{name}} moveu esta conversa de {{fromTeam}} para {{toTeam}}",
        "teamChangedAuto": "{{date}} — A conversa foi movida de {{fromTeam}} para {{toTeam}} após uma alteração de equipe do canal",
        "deletedTeam": "uma equipe excluída",
        "conversationAssignedToUser": "Esta conversa está atribuída a {{name}}. Você pode entrar para interagir diretamente com o cliente.",
        "movedToTeam": "Conversa movida para {{team}}",
        "allStatuses": "Todos status",
        "open": "Abertas",
        "resolved": "Resolvidas",
        "viewContact": "Ver contacto",
        "messageLabel": "Digite sua mensagem aqui",
        "noConversations": "Não há conversas",
        "noConversationsSelected": "Por favor, seleccione uma conversa no painel da esquerda.",
        "resolvedBy": "{{date}} — Resolvida por {{name}}",
        "reopenedBy": "{{date}} — Reaberta por {{name}}",
        "conversationStarted": "{{date}} — Conversa iniciada",
        "download": "Descarregar",
        "resend": "Reenviar",
        "emptyChannelsTitle": "Todas as suas conversas num só lugar",
        "emptyChannelsSubtitle": "Veja todas as conversas dos clientes num só painel. Ligue vários canais — do live chat no seu site ao Facebook, Instagram ou WhatsApp.",
        "emptyChannelsButton": "Ligar canais",
        "storyNotAvailable": "Este story não está disponível",
        "showQuotedText": "Mostrar texto citado",
        "hideQuotedText": "Ocultar texto citado",
        "mine": "Minhas",
        "unassigned": "Não atribuídas",
        "archivedConversation": "Esta conversa é de um canal eliminado. Você não pode reabri-la nem receber novas mensagens.",
        "importedConversation": "Esta conversa foi importada da aplicação WhatsApp Business. Não a pode reabrir; inicie uma nova conversa para escrever ao contacto.",
        "disconnectedChannel": "PT: Esta conversa é de um canal desconectado. Por favor, reconecte o canal nas <0>{{link}}</0>.",
        "settings": "configurações",
        "liveChatVisitorUnreachable": "Este visitante não pode ser contatado depois que sai. Escolha um canal de acompanhamento nas <0>{{link}}</0>.",
        "closedConversation": "Esta conversa está resolvida. Podes reabri-la para continuar a comunicar com o contacto.",
        "whatsApp24HoursWindow": "O WhatsApp só permite respostas em texto livre nas 24 horas seguintes à última mensagem do cliente. Para retomar o contato, <0>{{link}}</0>. Você poderá responder livremente assim que o cliente voltar a escrever.",
        "useApprovedMessage": "use um modelo de mensagem aprovado",
        "messagingWindowClosed": "A Meta não aceita mais respostas nesta conversa. Você poderá responder assim que o cliente voltar a escrever.",
        "activityNewestFirst": "Última atividade: Mais recente",
        "activityOldestFirst": "Última atividade: Mais antiga",
        "createdAtNewestFirst": "Criado em: Mais recente",
        "createdAtOldestFirst": "Criado em: Mais antigo",
        "backToAllConversations": "Voltar a todas as conversas",
        "messageDeleted": "Excluído",
        "conversationSelected_one": "{{count}} conversação selecionada",
        "conversationSelected_other": "{{count}} conversas selecionadas",
        "exportInProgress": "Exportação em andamento. Aguarde o e-mail",
        "editConversations": "Editar conversas",
        "selectProperty": "Selecionar propriedade",
        "conversationAssignedOnPulse": "Esta conversa está atribuída ao Pulse. Entre para interagir diretamente com o cliente.",
        "replyTab": "Responder",
        "noteTab": "Nota",
        "notePlaceholder": "Adicionar uma nota interna…",
        "noteVisibilityHint": "Nunca visível para o cliente",
        "noteSnippet": "Nota: {{text}}",
        "collaborators": "Colaboradores",
        "addCollaborator": "Adicionar",
        "tags": "Etiquetas",
        "addTag": "Adicionar",
        "createNewTag": "Criar",
        "tagNamePlaceholder": "Nome da etiqueta",
        "deleteTagTitle": "Eliminar etiqueta?",
        "deleteTagDescription": "\"{{name}}\" será eliminada para toda a conta e removida de todas as conversas.",
        "editTagTitle": "Editar etiqueta",
        "tagColor": "Cor",
        "keepMeAsCollaborator": "Manter-me como colaborador",
        "collaborating": "Colaborando",
        "collaboratorReadOnly": "Você acompanha esta conversa como colaborador — use notas internas para participar",
        "bulkEditPartial": "{{updated}} de {{total}} conversas atualizadas — conversas de colaborador não são alteradas",
        "bulkEditUpdatedCount": "{{updated}} de {{total}} conversas atualizadas"
    },
    "SocialPosts": {
        "title": "Crie, personalize e agende publicações em várias plataformas",
        "subtitle": "Planeie, personalize e agende publicações nas redes sociais para cada local e plataforma ligados, a partir de um único lugar.",
        "editPost": "Editar publicação",
        "viewPost": "Detalhes da publicação",
        "tableView": "Tabela",
        "calendarView": "Calendário",
        "moreCount": "+{{count}} mais",
        "rescheduleSuccess": "Publicação reagendada",
        "rescheduleFail": "Não foi possível reagendar a publicação",
        "book": "Reservar",
        "orderOnline": "Encomendar online",
        "buy": "Comprar",
        "signUp": "Registe-se",
        "callNow": "Ligar agora",
        "imageFormat": "Imagens: Formato: JPG ou PNG. Tamanho: 10KB - 10MB. Imagens maiores são otimizadas automaticamente.",
        "videoFormatDynamic": "Vídeos: Formato: MP4. Resolução: até {{maxResolution}}. Tamanho: até {{maxSize}}. Duração: de {{minDuration}} a {{maxDuration}}.",
        "videoConstrainedBy": "{{platform}} define este limite.",
        "noMediaPreview": "Envie imagens ou um vídeo para ver a pré-visualização aqui",
        "content": "Conteúdo",
        "contentDescription": "Comece com uma publicação comum e ajuste o conteúdo, a multimédia e as opções para cada plataforma.",
        "allPlatforms": "Todas as plataformas",
        "customizeFor": "Personalizar para {{platform}}",
        "media": "Mídia",
        "customized": "Personalizado",
        "messageRequired": "Adicione uma mensagem",
        "tiktokAutoAddMusic": "Adicionar música automaticamente",
        "tiktokAutoAddMusicHint": "O TikTok adiciona um som recomendado às publicações com imagens. Pode alterá-lo mais tarde na aplicação do TikTok.",
        "videoTooLongForCreator": "Mais longo do que {{handle}} permite no TikTok (máx. {{limit}})",
        "tiktok": {
            "loadingCreatorInfo": "A carregar as definições da conta do TikTok…",
            "cannotPostNow": "O TikTok não está a aceitar publicações de {{handle}} neste momento. Tente novamente mais tarde.",
            "creatorInfoFailed": "Não foi possível carregar as definições da conta do TikTok.",
            "retry": "Tentar novamente",
            "privacy": "Quem pode ver esta publicação",
            "privacyHint": "As opções vêm das contas conectadas.",
            "privacyLevels": {
                "PUBLIC_TO_EVERYONE": "Todos",
                "MUTUAL_FOLLOW_FRIENDS": "Amigos",
                "FOLLOWER_OF_CREATOR": "Seguidores",
                "SELF_ONLY": "Só eu"
            },
            "privacyNoCommonOption": "Estas contas do TikTok não partilham nenhuma opção de privacidade. Remova {{handle}} ou agende-a em separado.",
            "privacyNoCommonOptionAny": "Estas contas do TikTok não partilham nenhuma opção de privacidade. Agende-as em separado.",
            "privacyChooseAgain": "Escolha quem pode ver esta publicação.",
            "interactions": "Permitir que os espectadores",
            "allowComment": "Comentem",
            "allowDuet": "Façam dueto",
            "allowStitch": "Façam stitch",
            "interactionDisabled": "Desativado nas definições do TikTok de {{handle}}",
            "interactionDisabledForSome": "{{handle}} tem esta opção desativada no TikTok, por isso a publicação dessa conta sai sem ela.",
            "commercial": "Divulgar conteúdo comercial",
            "commercialHint": "Ative se esta publicação promove o seu negócio, uma marca, um produto ou um serviço.",
            "yourBrand": "A sua marca",
            "brandedContent": "Conteúdo de marca",
            "labelPromotional": "O seu {{media}} será identificado como 'Conteúdo promocional'",
            "labelPaidPartnership": "O seu {{media}} será identificado como 'Parceria paga'",
            "mediaWordVideo": "vídeo",
            "mediaWordPhoto": "foto",
            "commercialIncomplete": "Tem de indicar se o seu conteúdo promove a si próprio, a terceiros ou a ambos.",
            "brandedNotPrivate": "A visibilidade do conteúdo de marca não pode ser privada.",
            "consent": "Ao publicar, concorda com a <musicLink>Music Usage Confirmation</musicLink> do TikTok",
            "consentBranded": "Ao publicar, concorda com a <bcLink>Branded Content Policy</bcLink> e a <musicLink>Music Usage Confirmation</musicLink> do TikTok",
            "processingNote": "O TikTok pode demorar alguns minutos a mostrar uma publicação no perfil depois de ser publicada.",
            "publishingTooltip": "O TikTok está a processar esta publicação. Pode demorar alguns minutos a aparecer no perfil.",
            "unauditedBanner": "Este ambiente só pode publicar publicações privadas no TikTok.",
            "noTikTokLocation": "Selecione uma localização com uma conta do TikTok conectada.",
            "noCreators": "Nenhuma das localizações selecionadas pode publicar no TikTok neste momento.",
            "reconnectAccount": "Volte a ligar {{handle}} em Definições, Integrações antes de agendar.",
            "thisAccount": "esta conta do TikTok",
            "chooseAccount": "Escolha que conta do TikTok publica para esta localização no perfil da localização."
        },
        "messageTooLong": "A mensagem excede o limite de {{count}} caracteres desta plataforma",
        "mediaRequired": "Esta plataforma requer pelo menos uma imagem ou vídeo",
        "videoTooLarge": "O vídeo excede o limite de tamanho de {{limit}} para esta plataforma",
        "videoTooLong": "O vídeo excede o limite de duração de {{limit}} para esta plataforma",
        "videoTooSmall": "O vídeo está abaixo do tamanho mínimo de {{limit}} para esta plataforma",
        "videoTooLargeSummary": "Vídeo muito grande para: {{platforms}}",
        "videoTooLongSummary": "Vídeo muito longo para: {{platforms}}",
        "videoTooSmallSummary": "Vídeo muito pequeno para: {{platforms}}",
        "checkingVideoLength": "Verificando a duração do vídeo…",
        "mediaRules": {
            "google": "Máximo de uma imagem. Vídeo não compatível.",
            "facebook": "Máximo de um vídeo, ou até 10 imagens (sem misturar).",
            "instagram": "Até 10 imagens ou vídeos. Multimédia obrigatória.",
            "tiktok": "Máximo de um vídeo, ou até 35 imagens (sem misturar). Algumas contas do TikTok permitem vídeos mais curtos do que o indicado.",
            "x": "Máximo de um vídeo, ou até 4 imagens (sem misturar).",
            "facebookStory": "Exatamente uma imagem ou um vídeo. Recomendado 9:16.",
            "instagramStory": "Exatamente uma imagem ou um vídeo. Recomendado 9:16. As imagens são convertidas para JPEG."
        },
        "retry": "Tentar novamente",
        "openPublishedPost": "Ver publicação",
        "storyMediaOnlyNotice": "As histórias publicam apenas multimédia — o texto não aparecerá na história.",
        "storyAspectWarning": "Esta multimédia não é 9:16 — o {{platform}} irá cortá-la para ajustar.",
        "storyExpiry": "Ver história (as histórias expiram 24 horas após a publicação)",
        "storyExpired": "Esta história expirou — o link pode já não funcionar",
        "queued": "Em fila",
        "removedExternally": "Removido na plataforma",
        "cancelPost": "Cancelar publicação",
        "cancelPostTitle": "Cancelar esta publicação?",
        "cancelPostDescription": "Esta publicação não será publicada.",
        "deletePostTitle": "Eliminar esta publicação?",
        "deletePostDescription": "Isto remove a publicação publicada da plataforma. Esta ação não pode ser anulada.",
        "preview": {
            "emptyHint": "Selecione plataformas e localizações, depois adicione uma mensagem ou mídia para pré-visualizar o post",
            "seeMore": "Ver mais",
            "like": "Curtir",
            "comment": "Comentar",
            "share": "Compartilhar",
            "more": "mais",
            "likesPlaceholder": "Curtido pelos seus seguidores",
            "tiktokSound": "Som original",
            "storyHint": "Pré-visualização 9:16 · apenas multimédia"
        },
        "videoTooWide": "O vídeo excede o máximo de {{width}}×{{height}} desta plataforma",
        "videoTooWideSummary": "Resolução do vídeo alta demais para: {{platforms}}"
    },
    "PostDynamicVariables": {
        "title": "Variáveis dinâmicas"
    },
    "UpdateLocations": {
        "title": "Importar localizações",
        "subtitle": "Actualize ou crie várias localizações de uma só vez utilizando um ficheiro CSV.",
        "list1Title": "Baixar o modelo",
        "list1Description": "Baixar o modelo com as suas localizações existentes",
        "list2Title": "Carregar ficheiro",
        "list2Description": "Carregue o seu ficheiro. Preencha o ID do local para actualizar uma localização existente, ou deixe em branco para criar uma nova.",
        "locationsToUpdate": "Locais actualizados",
        "locationsToAdd": "Locais a adicionar",
        "dataVerificationDescription": "Reveja as localizações processadas. As linhas \"Nova\" criarão uma nova localização; as linhas \"Atualização\" atualizarão uma existente.",
        "showAddress": "Mostrar endereço",
        "featuredMessage": "Mensagem em destaque",
        "featuredMessageUrl": "URL da mensagem em destaque",
        "showHours": "Mostrar horários",
        "importButton": "Importar {{amount}} localizações",
        "quotaExceeded": "Adicionar {{count}} nova(s) localização(ões) excede o seu limite de {{available}}."
    },
    "ImportValidationTable": {
        "showErrorsOnly": "Mostrar apenas erros",
        "showErrorsOnlyCount": "Mostrar apenas erros ({{count}} item(ns))"
    },
    "BulkEditLocations": {
        "notUpdated": "{{count}} de {{total}} localizações não foram atualizadas:",
        "title": "Editar localizações em massa",
        "subtitle": "Edite várias localizações de uma só vez. As alterações serão aplicadas a todas as localizações selecionadas.",
        "applyToLocations": "Aplicar a {{count}} localização(ões)",
        "services": "Serviços",
        "socialLinkPlatform": "Link social: {{platform}}"
    },
    "AIAssistant": {
        "translate": "Traduzir",
        "english": "Inglês",
        "spanish": "Espanhol",
        "portuguese": "Português",
        "french": "Francês",
        "german": "Alemão",
        "italian": "Italiano",
        "russian": "Russo",
        "ukrainian": "Ucraniano",
        "polish": "Polaco",
        "changeTone": "Alterar o tom",
        "professional": "Profissional",
        "friendly": "Amigável",
        "fixGrammar": "Correção de erros",
        "makeShoter": "Tornar mais curto",
        "makeLonger": "Tornar mais longo",
        "writeResponse": "Escrever a resposta",
        "writeTemplate": "Escrever modelo",
        "writePost": "Escrever publicação",
        "optimizeForPlatform": "Otimizar para {{platform}}",
        "writeCampaign": "Escrever campanha",
        "writeReply": "Escrever resposta",
        "writeDescription": "Escrever descrição"
    },
    "industry": {
        "Automotive": "Automotiva",
        "BeautySpaAndSalon": "Beleza, Spa e Salão",
        "ClothingAndApparel": "Vestuário e Vestimenta",
        "Education": "Educação",
        "Entertainment": "Entretenimento",
        "EventPlanningAndService": "Planejamento e Serviço de Eventos",
        "FinanceAndBanking": "Finanças e Bancos",
        "FoodAndGrocery": "Alimentação e Mercearia",
        "Pharmacy": "Farmácia",
        "PublicService": "Serviço Público",
        "HotelAndLodging": "Hotelaria e Hospedagem",
        "HealthcareAndDental": "Saúde e Odontologia",
        "ProfessionalServices": "Serviços Profissionais",
        "ShoppingAndRetail": "Compras e Varejo",
        "TravelAndTransportation": "Viagem e Transporte",
        "Restaurant": "Restaurante",
        "Veterinary": "Veterinária",
        "WellnessAndFitness": "Bem-estar e Fitness",
        "Other": "Outros"
    },
    "themes": {
        "amenities": "Comodidades",
        "atmosphere": "Atmosfera",
        "availability": "Disponibilidade",
        "billing": "Faturação",
        "check-in/out": "Check-in/out",
        "checkout": "Caixa",
        "cleanliness": "Limpeza",
        "communication": "Comunicação",
        "delivery": "Entrega",
        "experience": "Experiência",
        "expertise": "Especialização",
        "facilities": "Instalações",
        "food": "Comida",
        "location": "Localização",
        "menu": "Menu",
        "noise": "Ruído",
        "policies": "Políticas",
        "pricing": "Preços",
        "products": "Produtos",
        "quality": "Qualidade",
        "quality of care": "Qualidade do atendimento",
        "results": "Resultados",
        "rooms": "Quartos",
        "scheduling": "Agendamento",
        "service": "Serviço",
        "staff": "Equipa",
        "transparency": "Transparência",
        "treatment": "Tratamento",
        "value": "Custo-benefício",
        "wait time": "Tempo de espera"
    },
    "ProfilesPage": {
        "title": "Impulsione seu SEO local",
        "titleGoogle": "Ative o Google para sincronizar todos os seus perfis",
        "titleFreemium": "Atualize para uma visibilidade local completa",
        "subtitleFreemium": "Publique e sincronize as suas localizações no Apple Maps, Bing, ChatGPT e em mais de 200 diretórios e aplicações de navegação com o Pluspoint Starter. Listagens corretas melhoram o SEO local e reforçam os sinais de confiança para assistentes de IA.",
        "subtitleGoogle": "Ligue a sua conta Google para manter os dados dos seus perfis sincronizados, incluindo localizações, horários, fotos e atualizações. Sem a integração com o Google, algumas informações podem ficar incompletas ou desatualizadas.",
        "subtitle": "Publique e sincronize os perfis do seu negócio em mais de 100 diretórios, mapas e plataformas de busca. Listagens consistentes aumentam sua visibilidade perante clientes, mecanismos de busca e assistentes de IA.",
        "profiles": "Perfis",
        "profileInformation": "Informações de perfil",
        "syncStatus": "Estado da sincronização",
        "synced": "Sincronizado",
        "syncStarted": "Sincronização iniciada",
        "syncCompleted": "Sincronização concluída",
        "lastSynced": "Última sincronização",
        "lastChecked": "Última verificação",
        "details": "Detalhes",
        "detailsConflictIntegration_one": "{{count}} campo difere entre o Pluspoint e {{platform}}. Escolha quais valores manter para resolver o conflito.",
        "detailsConflictIntegration_other": "{{count}} campos diferem entre o Pluspoint e {{platform}}. Escolha quais valores manter para resolver o conflito.",
        "detailsConflictScanner_one": "{{count}} campo difere entre o Pluspoint e {{platform}}. Publique para atualizar o perfil.",
        "detailsConflictScanner_other": "{{count}} campos diferem entre o Pluspoint e {{platform}}. Publique para atualizar o perfil.",
        "detailsNotFound": "Não está listado em {{platform}}. Publique para tornar o seu negócio visível.",
        "detailsNotVerified": "O perfil de {{platform}} não está verificado. Verifique para gerir esta listagem.",
        "detailsDisconnected": "{{platform}} está desconectado. Reconecte para retomar a sincronização.",
        "detailsSynced": "Todos os campos principais correspondem à fonte do Pluspoint.",
        "detailsSyncedWithConflicts_one": "O perfil está sincronizado, mas {{count}} campo é ignorado.",
        "detailsSyncedWithConflicts_other": "O perfil está sincronizado, mas {{count}} campos são ignorados.",
        "detailsDisabled": "A sincronização está desativada para este perfil.",
        "resolveTitle": "Resolver conflitos",
        "resolveSubtitle": "Resolva os conflitos de perfil seleccionando as informações correctas",
        "syncSuccessMessage": "Sincronização em progresso. Pode continuar a usar o sistema.",
        "noAddress": "Sem endereço",
        "field": "Campo",
        "ignore": "Ignorar",
        "openProfile": "Abrir perfil",
        "usePlatformValue": "Usar o valor de {{source}}",
        "updatePlatformToMatch": "Atualizar {{target}} para corresponder ao {{source}}",
        "noChangesWillBeMade": "Nenhuma alteração será feita",
        "restrictedFieldHint": "O {{source}} não permite atualizar este campo pelo Pluspoint. Atualize diretamente no {{source}} ou use o valor do {{source}}.",
        "noHoursToSendHint": "O {{source}} não consegue mostrar uma página sem horário de funcionamento, por isso não há nada a enviar. Use o valor do {{source}} ou ignore este campo.",
        "noCoverToSendHint": "Este local não tem foto de capa, por isso não há nada a enviar. Use o valor do {{source}} ou ignore este campo.",
        "descriptionContainsUrlHint": "O Google não permite links na descrição do negócio. Remova o link para sincronizá-la.",
        "rejectedFieldHint": "O {{source}} rejeitou este valor ({{reasons}}). Corrija no Pluspoint e resolva novamente.",
        "socialLinkedElsewhere": "Este perfil social já está associado a outra localização. Para usá-lo nas suas localizações, partilhe-o a partir da localização à qual está associado.",
        "titleScanner": "Visão geral da sua presença online",
        "subtitleScanner": "Veja onde o seu negócio aparece nos diretórios. Publique para corrigir imprecisões e estar listado em todos eles.",
        "notPublished": "Perfil não encontrado",
        "publishAction": "Publicar",
        "upgradeToPublish": "Atualize o plano para publicar suas listagens",
        "upgradeToPublishDescription": "Controle as informações da sua empresa em mais de 100 diretórios atualizando para o plano Starter.",
        "upgradeToPublishAll": "Atualizar para publicar tudo",
        "listingIssuesFound_one": "{{count}} problema nas listagens precisa de atenção",
        "listingIssuesFound_other": "{{count}} problemas nas listagens precisam de atenção",
        "listingIssuesDescription": "Listagens em falta e dados de contacto errados prejudicam a sua posição nas pesquisas locais. Adicione Diretórios Locais a uma localização para os corrigir e mantê-los sincronizados automaticamente.",
        "detailsNotFoundScanner": "Não listado em {{platform}} — faça upgrade para publicar automaticamente"
    },
    "ProfilesMedia": {
        "exterior": "Exterior",
        "interior": "Interior",
        "product": "Produto",
        "atWork": "No trabalho",
        "foodAndDrink": "Comida e bebidas",
        "menu": "Menu",
        "commonArea": "Área comum",
        "rooms": "Salas",
        "teams": "Equipas",
        "authorName": "Autor",
        "profileName": "Perfil",
        "locationsNames": "Localizações",
        "categoryName": "Categoria",
        "viewCount": "Vistas",
        "createdAt": "Publicado em",
        "reportedAt": "Denunciado em",
        "viewContent": "Ver conteúdo",
        "uploadPhotos": "Carregar fotos",
        "photosFormat": "Formato: JPG ou PNG. Tamanho: 10KB - 5MB. Resolução mínima: 720 px de altura, 720 px de largura."
    },
    "IntegrationRequired": {
        "title": "Integração necessária",
        "subtitleGoogle": "Para ativar esta funcionalidade, por favor, conecte a sua conta Pluspoint ao Google My Business",
        "subtitleCommon": "Para ativar esta funcionalidade, por favor, conecte a sua conta Pluspoint ao Google My Business ou Facebook"
    },
    "KnowledgeBase": {
        "title": "Dê mais inteligência ao Pulse com o seu conhecimento",
        "subtitle": "Adicione os seus artigos à base de conhecimento para fornecer as respostas de que o Pulse precisa. De perguntas frequentes a guias detalhados, o seu conteúdo ajuda o Pulse a dar respostas precisas e úteis aos clientes.",
        "editContent": "Editar conteúdo",
        "agents": "Agentes",
        "limitToLocations": "Limitar a localizações específicas",
        "items": "itens de conteúdo",
        "itemsSelected": "{{count}} itens de conteúdo selecionados",
        "faq": "Perguntas frequentes",
        "document": "Documento",
        "website": "Site",
        "addFaq": "Adicionar pergunta frequente",
        "addDocument": "Adicionar documento",
        "addWebsite": "Adicionar site",
        "dropFileOr": "Arraste um ficheiro para aqui ou",
        "browse": "selecione-o",
        "acceptedFiles": "PDF, Word, Excel, CSV, PowerPoint, texto, Markdown ou imagem. Até {{size}} {{metric}}; PDF até {{pages}} páginas e folhas até {{rows}} linhas.",
        "processing": "Em processamento",
        "ready": "Pronto",
        "failed": "Falhou",
        "processingFailed": "Não foi possível processar o ficheiro",
        "websitePlaceholder": "ajuda.exemplo.com ou exemplo.com/ajuda",
        "invalidWebsite": "Insira um domínio, com ou sem caminho, como ajuda.exemplo.com ou exemplo.com/ajuda",
        "documentsAtLimit": "Os documentos atingiram o limite",
        "websitesAtLimit": "Os sites atingiram o limite"
    },
    "Agents": {
        "title": "Personalize o Pulse para o seu negócio",
        "subtitle": "Configure o Pulse de acordo com as necessidades da sua empresa. Crie agentes de IA para diferentes canais e locais, cada um com um comportamento ajustado, garantindo a resposta certa em cada interação com o cliente.",
        "editAgent": "Editar agente",
        "activateAgent": "Ativar agente",
        "schedule": "Horário",
        "answerOutsideBusinessHours": "Responder apenas fora do horário de funcionamento",
        "activeInBusinessHours": "Ativo · Horário de funcionamento",
        "contactDetailsDescription": "Escolha quais dados de contacto quer que o Pulse solicite aos clientes.",
        "autoCloseTitle": "Conversas abandonadas",
        "autoCloseDescription": "Escolhe como o Pulse deve tratar as conversas abandonadas após um determinado período de inatividade.",
        "timeOfClientInactivity": "Tempo de inatividade do cliente antes de aplicar a ação:",
        "closeConversation": "Fechar conversa",
        "changeToUnassigned": "Mudar para Não atribuída",
        "doNothing": "Não fazer nada",
        "conversationHandoff": "Encaminhamento de conversa",
        "conversationHandoffDescription": "Defina como o Pulse deve agir quando não conseguir responder a uma pergunta ou quando o cliente pedir para falar com um operador.",
        "conversationHandoffSwitch": "Mudar para Não atribuída",
        "handoffResponseTime": "Tempo de resposta esperado",
        "fewMinutes": "Alguns minutos",
        "withinHour": "Em menos de uma hora",
        "fewHours": "Algumas horas",
        "withinDay": "Em menos de um dia",
        "within2Days": "No máximo 2 dias",
        "notTransferConversationSwitch": "Não transferir a conversa",
        "channelTakenByAgent": "O canal já está atribuído a outro agente",
        "customInstructions": "Instruções personalizadas",
        "customInstructionsDescription": "Adicione instruções personalizadas que o Agente de IA Pulse deve seguir ao interagir com os clientes.",
        "playgroundAssignContent": "Atribua conteúdo da base de conhecimento a este agente para começar a testá-lo no playground.",
        "playgroundSaveAgentFirst": "Guarde o agente e atribua-lhe conteúdo da base de conhecimento para começar a testá-lo no playground."
    },
    "InitConversation": {
        "recipient": "Destinatário",
        "newConversation": "Nova conversa",
        "viewConversation": "Ver conversa",
        "conversationExistsTitle": "Conversa aberta encontrada",
        "conversationExistsDescription": "Tem uma conversa aberta com este contacto através da mesma localização e canal. O que pretende fazer?",
        "resolveConversation": "Resolver conversa",
        "goToConversation": "Ir para a conversa"
    },
    "CouponsPage": {
        "title": "Ofertas inteligentes para impulsionar a fidelização e as vendas",
        "subtitle": "Crie e partilhe ofertas especiais para recompensar clientes satisfeitos, resolver situações ou aumentar as vendas. Personalize descontos, artigos gratuitos e regras de utilização em diferentes localizações.",
        "createNewCoupon": "Criar nova oferta",
        "createCoupon": "Criar oferta",
        "viewCoupon": "Ver oferta",
        "editCoupon": "Editar oferta",
        "activateCoupon": "Ativar oferta",
        "offerType": "Tipo de oferta",
        "percentageOff": "Desconto em Percentagem",
        "amountOff": "Desconto em Valor",
        "freeItem": "Artigo Gratuito",
        "minimumOrderValue": "Pedido mín.",
        "offerSchedule": "Calendário da oferta",
        "offerAndDate": "Data de fim da oferta",
        "setFinalIssueDate": "Defina o último dia em que esta oferta pode ser utilizada.",
        "redemptionPeriod": "Período de utilização",
        "periodOfValidity": "Quantos dias após a emissão a oferta permanece válida.",
        "redemptionPeriodDays": "Período de utilização (dias)",
        "waitPeriod": "Período de espera",
        "setDelay": "Defina o tempo de espera antes de a oferta poder ser utilizada.",
        "waitPeriodHours": "Período de espera (horas)",
        "activationPinCode": "Código PIN de ativação",
        "requireStaffForPin": "Exigir que o staff introduza um PIN para confirmar a utilização",
        "redeemed": "Resgatado {{title}}",
        "defaultMessage": "Mensagem padrão",
        "issuedCount": "Emitidos",
        "redeemedCount": "Resgatados"
    },
    "paymentMethod": {
        "cash": "Dinheiro",
        "visa": "Visa",
        "mastercard": "Mastercard",
        "applePay": "Apple Pay",
        "androidPay": "Android Pay",
        "paypal": "PayPal",
        "americanExpress": "American Express",
        "discover": "Discover",
        "invoice": "Fatura",
        "bitcoin": "Bitcoin",
        "travelersCheck": "Traveler's Check",
        "dinersClub": "Diners Club",
        "insurance": "Seguro"
    },
    "Paywall": {
        "whatYouGet": "O que recebe:",
        "unlockThis": "Desbloqueie isto e muito mais com o Pluspoint Professional.",
        "titleCoupons": "Ofertas que fidelizam clientes e incentivam o regresso",
        "subtitleCoupons": "Recompense os seus clientes e dê-lhes um motivo para voltar. Utilize ofertas para recuperar clientes insatisfeitos, incentivar avaliações e transformar interações em vendas reais.",
        "proposal1Coupons": "Ofertas flexíveis, incluindo itens gratuitos e descontos percentuais ou de valor fixo",
        "proposal2Coupons": "Análises integradas para acompanhar resgates, desempenho e ROI",
        "proposal3Coupons": "Ofertas interativas otimizadas para dispositivos móveis, pensadas para uso rápido e elevada conversão",
        "proposal4Coupons": "Sem necessidade de integração com POS, simples de lançar e fácil de gerir",
        "titleCampaigns": "Campanhas que geram compras recorrentes",
        "subtitleCampaigns": "Alcance os clientes certos no momento certo com campanhas direcionadas nos canais que eles realmente utilizam. Automatize mensagens recorrentes, lance promoções pontuais e deixe a IA tratar das respostas para que as conversas fluam naturalmente.",
        "proposal1Campaigns": "Campanhas automáticas e pontuais adaptadas aos seus objetivos",
        "proposal2Campaigns": "Segmentação inteligente baseada em dados e comportamento dos clientes",
        "proposal3Campaigns": "Comunicação multicanal por SMS, email e WhatsApp",
        "proposal4Campaigns": "Gestão inteligente das respostas e conversas com apoio de IA",
        "titleSurveys": "Pesquisas que transformam feedback em crescimento",
        "subtitleSurveys": "Faça do feedback dos clientes parte da sua operação diária. Automatize a recolha de opiniões, identifique e resolva reclamações atempadamente e gere mais avaliações junto de clientes que tiveram uma excelente experiência.",
        "proposal1Surveys": "Pesquisas automatizadas enviadas por mensagens, email, WhatsApp e códigos QR",
        "proposal2Surveys": "Identificação precoce e resolução de reclamações",
        "proposal3Surveys": "Geração de avaliações a partir de clientes satisfeitos",
        "proposal4Surveys": "Acompanhamento do Net Promoter Score para medir lealdade e tendências ao longo do tempo",
        "titleAutoReplies": "Respostas automáticas em que pode confiar",
        "subtitleAutoReplies": "Responda às avaliações de forma rápida e consistente, sem parecer artificial. A IA gera respostas naturais e humanas, enquanto mantém o controlo total sobre o tom, as regras e os casos específicos.",
        "proposal1AutoReplies": "Respostas geradas por IA com um tom natural e personalizado",
        "proposal2AutoReplies": "Lógica inteligente baseada na classificação e na presença de comentário",
        "proposal3AutoReplies": "Prompts de IA personalizáveis para refletir a voz e as políticas da sua marca",
        "proposal4AutoReplies": "Modelos reutilizáveis para garantir consistência e controlo",
        "upgradeForCustomerRating": "Atualize para recolher classificações dos clientes",
        "upgradeForCustomerRatingDescription": "Encaminhe clientes satisfeitos para deixar avaliação e os insatisfeitos para feedback privado.",
        "upgradeForCustomQuestions": "Atualize para fazer perguntas personalizadas",
        "upgradeForCustomQuestionsDescription": "Adicione perguntas de classificação, escolha múltipla e respostas abertas às suas pesquisas.",
        "upgradeForSendSurveys": "Atualize para enviar pesquisas",
        "upgradeForSendSurveysDescription": "Envie pesquisas aos seus contactos por email ou SMS, com follow-ups e lembretes."
    },
    "GoogleVerification": {
        "title": "Verificar perfil do Google Business",
        "verifyOnGoogle": "Verificar no Google Business",
        "selectMethod": "Selecione o método de verificação",
        "PHONE_CALL": "Chamada telefónica",
        "SMS": "SMS",
        "EMAIL": "Email",
        "ADDRESS": "Carta (correio)",
        "VETTED_PARTNER": "Verificação através de um parceiro Google",
        "AUTO": "Verificação automática",
        "pinSent": "O Google enviou-lhe um código de verificação.",
        "pinSentTo": "Um código de verificação foi enviado para",
        "pinPlaceholder": "Código de verificação",
        "postcardMailed": "A Google enviou uma carta para o endereço da sua empresa.",
        "postcardMailedOn": "A Google enviou uma carta para o endereço da sua empresa em {{date}}.",
        "postcardArrives": "Deve chegar em cerca de {{days}} dias.",
        "postcardComeBack": "Volte e introduza o código quando chegar.",
        "postcardTo": "A carta é enviada para",
        "checkInProgress": "A Google está a verificar este perfil. O perfil é atualizado quando terminar.",
        "lastAttemptFailed": "A sua última tentativa ({{method}}) não foi concluída.",
        "lastAttemptFailedOn": "A sua última tentativa ({{method}}), pedida em {{date}}, não foi concluída.",
        "pinSentOn": "Um código de verificação foi enviado em {{date}}.",
        "pendingStillOpen": "Uma verificação por {{method}} continua aberta. Escolher outro método inicia uma nova.",
        "pendingStillOpenOn": "Uma verificação por {{method}} pedida em {{date}} continua aberta. Escolher outro método inicia uma nova.",
        "latestLookupFailed": "Não foi possível verificar se já existe uma verificação em curso, por isso iniciar uma pode duplicá-la.",
        "verificationComplete": "Perfil verificado. A listagem é atualizada dentro de momentos.",
        "verificationFailed": "Essa verificação não foi concluída. Tente novamente ou escolha outro método.",
        "mailboxName": "Nome da caixa de correio",
        "resendPostcard": "Enviar uma nova carta",
        "useAnotherMethod": "Utilizar outro método"
    },
    "exports": {
        "exporting": "Exportando dados...",
        "ready": "Exportação pronta",
        "failed": "Erro na exportação"
    },
    "importLoading": {
        "connectingGoogle": "Conectando à sua conta Google...",
        "fetchingDetails": "Obtendo detalhes das localizações...",
        "settingUp": "Configurando suas localizações...",
        "almostDone": "Quase pronto, só um momento...",
        "progress": "Importadas {{current}} de {{total}} localizações"
    },
    "MenusPage": {
        "title": "Todos os menus das suas localizações num único lugar",
        "subtitle": "Crie e atualize os seus menus num único lugar e publique-os nos seus microsites e no Perfil da Empresa no Google. Mantenha pratos, preços e fotos sempre atualizados em todas as suas localizações.",
        "createMenu": "Criar menu",
        "importWithAi": "Importar com IA",
        "importButton": "Importar",
        "importModalDescription": "Carregue o seu menu existente — um PDF, fotos, uma folha de cálculo ou um documento — e a IA irá transformá-lo num rascunho de menu que pode rever e editar.",
        "importDropFiles": "Arraste os ficheiros para aqui ou clique para procurar",
        "importTooManyFiles": "Pode carregar até {{count}} ficheiros",
        "importReadingFiles": "A ler os seus ficheiros...",
        "importExtractingItems": "A extrair secções e pratos...",
        "importFetchingImages": "A importar fotos dos pratos...",
        "importAlmostDone": "Quase pronto, um momento...",
        "editMenu": "Editar menu",
        "modalTitle": "Menu",
        "builder": "Construtor de menus",
        "internalName": "Nome interno",
        "internalNameHint": "Visível apenas para a sua equipa",
        "cuisines": "Cozinhas",
        "locations": "Localizações",
        "menuLocalization": "Nome e descrição do menu",
        "duplicate": "Duplicar",
        "sections": "Secções",
        "addSection": "Adicionar secção",
        "itemsCount": "pratos",
        "items": "Pratos",
        "publishedOnGoogle": "Publicado no Google",
        "untitledSection": "Secção sem título",
        "addItem": "Adicionar prato",
        "item": "Prato",
        "untitledItem": "Prato sem título",
        "itemName": "Nome do prato",
        "itemPhoto": "Foto do prato",
        "itemPhotoFormat": "Formato: JPG ou PNG. Tamanho: até 10MB.",
        "price": "Preço",
        "additionalAttributes": "Atributos adicionais",
        "addItemOptions": "Adicionar opções ao prato",
        "option": "Opção",
        "untitledMenu": "Menu",
        "previewEmpty": "Adicione secções e pratos para ver a pré-visualização do menu.",
        "spiciness": "Picante",
        "allergens": "Alergénios",
        "dietaryRestrictions": "Restrições alimentares",
        "preparationMethods": "Métodos de preparação",
        "ingredients": "Ingredientes",
        "portionQuantity": "Quantidade da porção",
        "portionUnit": "Unidade da porção (p. ex. peças, oz)",
        "servesNumPeople": "Doses (número de pessoas)",
        "calories": "Calorias",
        "nutrition": {
            "totalFat": "Gordura total",
            "cholesterol": "Colesterol",
            "sodium": "Sódio",
            "totalCarbohydrate": "Hidratos de carbono totais",
            "protein": "Proteínas"
        },
        "units": {
            "GRAM": "g",
            "MILLIGRAM": "mg"
        },
        "cuisineValues": {
            "AMERICAN": "Americana",
            "ASIAN": "Asiática",
            "BRAZILIAN": "Brasileira",
            "BREAK_FAST": "Pequeno-almoço",
            "BRUNCH": "Brunch",
            "CHICKEN": "Frango",
            "CHINESE": "Chinesa",
            "FAMILY": "Familiar",
            "FAST_FOOD": "Fast food",
            "FRENCH": "Francesa",
            "GREEK": "Grega",
            "GERMAN": "Alemã",
            "HAMBURGER": "Hambúrguer",
            "INDIAN": "Indiana",
            "INDONESIAN": "Indonésia",
            "ITALIAN": "Italiana",
            "JAPANESE": "Japonesa",
            "KOREAN": "Coreana",
            "LATIN_AMERICAN": "Latino-americana",
            "MEDITERRANEAN": "Mediterrânica",
            "MEXICAN": "Mexicana",
            "PAKISTANI": "Paquistanesa",
            "PIZZA": "Pizza",
            "SEAFOOD": "Marisco",
            "SPANISH": "Espanhola",
            "SUSHI": "Sushi",
            "THAI": "Tailandesa",
            "TURKISH": "Turca",
            "VEGETARIAN": "Vegetariana",
            "VIETNAMESE": "Vietnamita",
            "OTHER_CUISINE": "Outra"
        },
        "spicinessValues": {
            "MILD": "Suave",
            "MEDIUM": "Médio",
            "HOT": "Picante"
        },
        "allergenValues": {
            "DAIRY": "Laticínios",
            "EGG": "Ovo",
            "FISH": "Peixe",
            "PEANUT": "Amendoim",
            "SHELLFISH": "Marisco",
            "SOY": "Soja",
            "TREE_NUT": "Frutos de casca rija",
            "WHEAT": "Trigo"
        },
        "dietaryValues": {
            "HALAL": "Halal",
            "KOSHER": "Kosher",
            "ORGANIC": "Biológico",
            "VEGAN": "Vegan",
            "VEGETARIAN": "Vegetariano"
        },
        "preparationValues": {
            "BAKED": "Assado no forno",
            "BARBECUED": "Grelhado na brasa",
            "BASTED": "Regado",
            "BLANCHED": "Escaldado",
            "BOILED": "Cozido",
            "BRAISED": "Estufado",
            "CODDLED": "Cozido lentamente",
            "FERMENTED": "Fermentado",
            "FRIED": "Frito",
            "GRILLED": "Grelhado",
            "KNEADED": "Amassado",
            "MARINATED": "Marinado",
            "PAN_FRIED": "Frito na frigideira",
            "PICKLED": "Em conserva",
            "PRESSURE_COOKED": "Cozido sob pressão",
            "ROASTED": "Assado",
            "SAUTEED": "Salteado",
            "SEARED": "Selado",
            "SIMMERED": "Cozido em lume brando",
            "SMOKED": "Fumado",
            "STEAMED": "Cozido a vapor",
            "STEEPED": "Infundido",
            "STIR_FRIED": "Salteado no wok",
            "OTHER_METHOD": "Outro"
        },
        "issuesTitle": "Complete o seguinte para guardar o menu:",
        "issueInternalName": "Adicione um nome interno",
        "issueName": "Adicione um título",
        "issueNameLength": "O título não deve exceder 140 caracteres",
        "issueDescriptionLength": "A descrição não deve exceder 1000 caracteres",
        "issueIngredientsLength": "Cada lista de ingredientes não deve exceder 5000 caracteres",
        "issueCurrency": "Selecione uma moeda",
        "issueLocations": "Atribua pelo menos uma localização",
        "issueSections": "Adicione pelo menos uma secção",
        "issueSectionNames": "Dê nome a todas as secções",
        "issueSectionItems": "Cada secção precisa de pelo menos um prato",
        "issueItemNames": "Dê nome a todos os pratos",
        "issueItemPrices": "Defina um preço para cada prato",
        "issueOptionNames": "Dê nome a todas as opções",
        "showOnGoogle": "Mostrar no Google Business Profile",
        "showOnGoogleHint": "Enquanto estiver ativado, este menu está publicado no Google Business Profile para as localizações de restaurante conectadas. Ao desativar, o menu é removido do Google.",
        "google": "Google",
        "titleOptional": "Título (opcional)",
        "noItems": "Ainda não há pratos nesta secção",
        "editSection": "Editar secção"
    },
    "SubscribeLock": {
        "freemiumRetiredTitle": "O plano gratuito foi descontinuado",
        "freemiumRetiredSubtitle": "As suas avaliações, contactos e conversas estão seguros — assine para continuar de onde parou.",
        "trialEndedTitle": "O seu teste gratuito terminou",
        "trialEndedSubtitle": "Mantenha tudo o que configurou durante o teste — assine para continuar.",
        "askAccountOwner": "Não é administrador? Peça ao proprietário da conta para fazer o upgrade.",
        "directoriesIntentTitle": "Assine para adicionar Diretórios Locais",
        "directoriesIntentSubtitle": "Diretórios Locais requer uma assinatura ativa — assine e adicione {{location}} num só passo."
    },
    "TemplateLibrary": {
        "title": "Biblioteca de modelos",
        "subtitle": "Designs prontos para suas campanhas. Crie um modelo de email ou WhatsApp uma vez, mantenha a identidade da sua marca e reutilize sempre que lançar uma campanha.",
        "filterChannelType": "Tipo de canal",
        "filterBrands": "Marcas",
        "tabSettings": "Configurações",
        "tabContent": "Conteúdo",
        "tabPreview": "Pré-visualização",
        "backToBlocks": "Voltar aos blocos",
        "paletteHint": "Clique em um bloco ou arraste para o seu e-mail",
        "dropHint": "Arraste um bloco para cá",
        "emptyState": "Nenhum modelo ainda. Crie seu primeiro modelo para começar.",
        "channelEmail": "Email",
        "systemTemplate": "Exemplo",
        "archived": "Arquivado",
        "usedByCampaigns": "{{count}} campanha ou automação",
        "usedByCampaigns_plural": "{{count}} campanhas ou automações",
        "duplicate": "Duplicar",
        "archive": "Arquivar",
        "unarchive": "Desarquivar",
        "duplicated": "Modelo duplicado",
        "deleteDescription": "Excluir o modelo \"{{name}}\"? Essa ação não pode ser desfeita.",
        "deleteBlocked": "Este modelo é usado em campanhas ou automações e não pode ser excluído. Arquive-o.",
        "createTemplateTitle": "Novo modelo de email",
        "editTemplateTitle": "Editar modelo de email",
        "viewTemplateTitle": "Modelo de email",
        "saveTemplate": "Salvar modelo",
        "sendTest": "Enviar teste",
        "sendTestHint": "Envie um teste para você mesmo e veja exatamente o que seus contatos receberão.",
        "templateName": "Nome do modelo",
        "preheader": "Pré-cabeçalho",
        "deviceDesktop": "Desktop",
        "deviceMobile": "Celular",
        "emailChannel": "Canal de email",
        "testSendSuccess": "Email de teste enviado",
        "testSendFail": "Não foi possível enviar o email de teste",
        "loadingPreview": "Gerando pré-visualização…",
        "blocks": "Blocos",
        "textColor": "Cor do texto",
        "buttonColor": "Cor do botão",
        "buttonShape": "Formato do botão",
        "shape_square": "Quadrado",
        "shape_rounded": "Arredondado",
        "shape_pill": "Pílula",
        "blockLogo": "Logo",
        "blockImage": "Imagem",
        "blockHeading": "Título",
        "blockText": "Texto",
        "blockButton": "Botão",
        "blockDivider": "Divisor",
        "blockSpacer": "Espaçador",
        "blockColumns": "Colunas",
        "columnsHint": "Arraste blocos da paleta para qualquer coluna, ou clique em um elemento dentro de uma coluna para editá-lo.",
        "cornerRadius": "Raio dos cantos",
        "blockSocial": "Redes sociais",
        "logoPlaceholder": "Logotipo",
        "imagePlaceholder": "Selecione o bloco para enviar uma imagem",
        "headingPlaceholder": "Título",
        "textPlaceholder": "Escreva seu texto…",
        "buttonPlaceholder": "Botão",
        "socialPlaceholder": "Redes sociais — do perfil da localização",
        "headingText": "Texto do título",
        "textContent": "Texto",
        "imageAlt": "Texto alternativo",
        "buttonLabel": "Nome do botão",
        "buttonDestination": "Destino",
        "bindingUrl": "URL personalizada",
        "bindingSurvey": "Link da pesquisa",
        "bindingCoupon": "Link do cupom",
        "spacerHeight": "Altura (px)",
        "logoHint": "O logo é definido pela marca ou pela localização no envio do email.",
        "socialHint": "Os links do Facebook e Instagram vêm do perfil da localização.",
        "padding": "Espaçamento",
        "headingLevel": "Nível do título",
        "fontSize": "Tamanho do texto",
        "buttonSize": "Tamanho do botão",
        "buttonWidth": "Largura do botão",
        "widthFull": "Largura total",
        "widthAuto": "Ajustar ao conteúdo",
        "imageWidth": "Largura da imagem",
        "lineColor": "Cor da linha",
        "thickness": "Espessura",
        "footerPreviewInfo": "Nome da empresa · Endereço",
        "footerPreviewLinks": "Cancelar inscrição · Política de privacidade",
        "footerLockedTooltip": "Adicionado automaticamente a cada email com os dados reais do seu negócio",
        "alignment": "Alinhamento",
        "alignLeft": "Esquerda",
        "alignCenter": "Centro",
        "alignRight": "Direita",
        "emailDesign": "Design do email",
        "createNew": "Criar novo",
        "surveyLinkHint": "A campanha que usar este modelo preencherá com o link da pesquisa.",
        "couponLinkHint": "A campanha que usar este modelo preencherá com o link do cupom.",
        "noBrand": "Sem marca",
        "dynamicLinkRequired": "Campanhas de pesquisa e cupom precisam de um modelo com botão de link dinâmico.",
        "dynamicLinkNotSupported": "Modelos com botão de link dinâmico só podem ser usados em campanhas de pesquisa ou cupom.",
        "channelWhatsApp": "WhatsApp",
        "newEmailTemplate": "Criar modelo de email",
        "newWhatsAppTemplate": "Criar modelo de WhatsApp",
        "waChannelRequired": "Conecte um canal do WhatsApp Business para criar modelos de WhatsApp.",
        "waStatus_draft": "Rascunho",
        "waStatus_pending": "Em análise",
        "waStatus_approved": "Aprovado",
        "waStatus_rejected": "Rejeitado",
        "waStatus_paused": "Pausado",
        "waStatus_disabled": "Desativado",
        "waNeedsSetup": "Requer configuração",
        "waDisconnected": "Desconectado",
        "waEditResubmit": "Editar e reenviar",
        "waCategory": "Categoria",
        "waCategory_MARKETING": "Marketing",
        "waCategory_UTILITY": "Utilidade",
        "waWaba": "Conta do WhatsApp Business",
        "waWabaRequired": "Selecione a conta do WhatsApp Business para este modelo.",
        "waNameHint": "Minúsculas, dígitos e sublinhados",
        "waEmptyPreview": "A prévia da sua mensagem aparecerá aqui",
        "waNameInvalid": "Use apenas minúsculas, dígitos e sublinhados.",
        "waHeader": "Cabeçalho",
        "waHeaderNone": "Nenhum",
        "waHeaderText": "Texto",
        "waHeaderImage": "Imagem",
        "waHeaderTextLabel": "Texto do cabeçalho",
        "waHeaderOneVariable": "Um cabeçalho de texto permite no máximo uma variável.",
        "waHeaderImageRequired": "Envie uma imagem de cabeçalho ou mude o cabeçalho para nenhum.",
        "waBody": "Corpo",
        "waBodyEdgeVariable": "O corpo da mensagem não pode começar nem terminar com uma variável.",
        "waBodyMixedVariables": "Não misture variáveis nomeadas e numeradas no mesmo modelo.",
        "waFooter": "Rodapé",
        "waFooterLabel": "Texto do rodapé (opcional)",
        "waButtons": "Botões",
        "waAddButton": "Adicionar botão",
        "waButtonQuickReply": "Resposta rápida",
        "waButtonUrl": "URL",
        "waButtonPhone": "Telefone",
        "waButtonWebsite": "Visitar o site",
        "waButtonSurvey": "Link da pesquisa",
        "waButtonCoupon": "Link do cupom",
        "waUrlAbsolute": "As URLs dos botões devem começar com http:// ou https://.",
        "waLinkTypeCouponOnly": "O botão de link deste modelo aponta para links de oferta, então só serve para campanhas de oferta.",
        "waLinkTypeSurveyOnly": "O botão de link deste modelo aponta para links de pesquisa, então não serve para campanhas de oferta.",
        "waQuickRepliesGrouped": "Os botões de resposta rápida devem ficar agrupados.",
        "waButtonsIncomplete": "Preencha o rótulo e o destino de cada botão.",
        "waVariables": "Variáveis",
        "waResolution": "Preenchida com",
        "waGroupContact": "Contato",
        "waGroupLocation": "Localização",
        "waMappingRequired": "Escolha como cada variável é preenchida.",
        "waViewTemplateTitle": "Modelo de WhatsApp",
        "waEditTemplateTitle": "Editar modelo de WhatsApp",
        "waCreateTemplateTitle": "Novo modelo de WhatsApp",
        "waSaveDraft": "Salvar rascunho",
        "waSubmitForReview": "Enviar para análise",
        "waSubmitted": "Modelo enviado para análise",
        "waReviewNote": "A Meta analisa os modelos após o envio — geralmente em algumas horas, até 24 h.",
        "waPendingBanner": "A Meta está analisando este modelo; ele fica somente leitura até o fim da análise.",
        "waDisabledBanner": "A Meta desativou este modelo. Ele não pode ser editado nem usado em campanhas.",
        "waRejectedBanner": "A Meta rejeitou este modelo. Corrija o conteúdo e reenvie.",
        "waResubmitBanner": "Ao salvar, o modelo é enviado novamente para análise da Meta.",
        "noLinkButton": "Este modelo não tem botão de link dinâmico, então não pode entregar um link de pesquisa ou oferta.",
        "linkButtonNotSupported": "Este modelo tem um botão de link dinâmico, então só pode ser usado em campanhas de pesquisa ou oferta.",
        "waLockedByCampaigns": "Este modelo é usado por campanhas agendadas ou em andamento, ou por automações ativas. Duplique-o para editá-lo, ou remova essas referências primeiro.",
        "waMalformedVariable": "Variável malformada — use {{nome_em_minusculas}} com letras, dígitos e sublinhados.",
        "waUnknownVariable": "Variável desconhecida — use um dos campos disponíveis.",
        "waFromContact": "do contato",
        "waFromLocation": "da localização",
        "waLinkSlotInfo": "O botão de URL é preenchido com o link da pesquisa ou da oferta."
    },
    "ImpersonationBanner": {
        "impersonatedBy": "Acesso feito por {{name}} da Pluspoint",
        "impersonatedByPartner": "Acesso feito por {{name}}",
        "minutesLeft": "{{count}} min restantes",
        "exit": "Sair"
    }
}
